import { defineMessages } from 'react-intl'

export interface Message {
  id: string
  defaultMessage: string
}

const baseCountStr = 'Base Count: '
const customProductsStr = 'Custom Products'
const fiveFootStr = "(5' to 3')"
const maxStr = 'Maximum oligo name length is '
const oligoNameStr = 'Oligo Name'
const oligosStr = 'Oligos & Probes'
const sequenceInfoStr = 'Sequence Information'
const sequenceEntryStr = 'Sequence Entry'
const reviewStr = 'Review & Confirm'

export const messages = defineMessages({
  ADD_TO_LIST: { id: 'ADD_TO_LIST', defaultMessage: 'Add to List' },
  CONF_ADD_INFO_MAX_VALIDATION_MSG: {
    id: 'CONF_ADD_INFO_MAX_VALIDATION_MSG',
    defaultMessage: 'Maximum character length is ',
  },

  CONF_ADD_INFO_MAX_VALIDATION_MSG_WITH_LENGTH: {
    id: 'CONF_ADD_INFO_MAX_VALIDATION_MSG_WITH_LENGTH',
    defaultMessage: 'Maximum character length is {length}',
  },
  CONF_GENE_ID_SPECIAL_CHARACTER_MASSAGE: {
    id: 'CONF_GENE_ID_SPECIAL_CHARACTER_MASSAGE',
    defaultMessage: 'Gene ID contains invalid character(s):',
  },
  CONF_GENE_ID_SPECIAL_CHARACTER_MASSAGE_WITH_SPACE: {
    id: 'CONF_GENE_ID_SPECIAL_CHARACTER_MASSAGE_WITH_SPACE',
    defaultMessage: 'Gene ID contains invalid character(s): {character}',
  },
  CONF_GENE_SYMBOL_SPECIAL_CHARACTER_MASSAGE: {
    id: 'CONF_GENE_SYMBOL_SPECIAL_CHARACTER_MASSAGE',
    defaultMessage: 'Gene Symbol contains invalid character(s):',
  },
  CONF_GENE_SYMBOL_SPECIAL_CHARACTER_MASSAGE_WITH_SPACE: {
    id: 'CONF_GENE_SYMBOL_SPECIAL_CHARACTER_MASSAGE_WITH_SPACE',
    defaultMessage: 'Gene Symbol contains invalid character(s): {character}',
  },
  CONF_REQUIRED_FIELD: {
    id: 'CONF_REQUIRED_FIELD',
    defaultMessage: 'Required Field',
  },
  CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE: {
    id: 'CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE',
    defaultMessage: 'Name contains invalid character(s):',
  },
  CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_WITH_SPACE: {
    id: 'CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_WITH_SPACE',
    defaultMessage: 'Name contains invalid character(s): {characters}',
  },
  CONF_CUSTOM_DESIGN_NAME: {
    id: 'CONF_CUSTOM_DESIGN_NAME',
    defaultMessage: 'Design Name:',
  },
  CONF_CRISPR_DESIGN_NAME: {
    id: 'CONF_CRISPR_DESIGN_NAME',
    defaultMessage: 'CRISPR Design Name',
  },
  CONF_CRISPR_DESIGN_NAME_INFO: {
    id: 'CONF_CRISPR_DESIGN_NAME_INFO',
    defaultMessage:
      'Character limit is 16 including spaces. Do not use ASCII characters',
  },
  CONF_CRISPR_GENE_ID: {
    id: 'CONF_CRISPR_GENE_ID',
    defaultMessage: 'Gene ID',
  },
  CONF_CRISPR_GENE_SYMBOL: {
    id: 'CONF_CRISPR_GENE_SYMBOL',
    defaultMessage: 'Gene Symbol',
  },
  CONF_CUSTOM_CRISPR_SEQUENCE: {
    id: 'CONF_CUSTOM_CRISPR_SEQUENCE',
    defaultMessage: "Sequence (Do not include 3' PAM. Must be written 5'-3')",
  },
  CONF_BASE_COUNT: { id: 'CONF_BASE_COUNT', defaultMessage: 'Base Count:' },
  CONF_CRISPR_SEQUENCE_MSG: {
    id: 'CONF_CRISPR_SEQUENCE_MSG',
    defaultMessage: 'DNA bases only: A, C, G, T',
  },
  CONF_CUSTOM_CRISPR_SEQUENCE_PREVIEW: {
    id: 'CONF_CUSTOM_CRISPR_SEQUENCE_PREVIEW',
    defaultMessage: 'Guide DNA Sequence Preview',
  },
  CONF_SEQUENCE_PREVIEW_HELP_TEXT: {
    id: 'CONF_SEQUENCE_PREVIEW_HELP_TEXT',
    defaultMessage: 'Start typing sequence above to see the preview.',
  },
  CONF_HOME_CUSTOMCRISPR: {
    id: 'CONF_HOME_CUSTOMCRISPR',
    defaultMessage: 'Home',
  },
  CONF_CUSTOM_PRODUCT_CUSTOMCRISPR: {
    id: 'CONF_CUSTOM_PRODUCT_CUSTOMCRISPR',
    defaultMessage: customProductsStr,
  },
  CONF_CUSTOM_PRODUCT_NAME_CUSTOMCRISPR: {
    id: 'CONF_CUSTOM_PRODUCT_NAME_CUSTOMCRISPR',
    defaultMessage: 'CRISPR & Gene Editing',
  },
  CONF_SEQUENCE_ENTRY: {
    id: 'CONF_SEQUENCE_ENTRY',
    defaultMessage: 'Sequence Entry',
  },
  CONF_SPECIFICATIONS: {
    id: 'CONF_SPECIFICATIONS',
    defaultMessage: 'Specifications  ',
  },
  CONF_CONFIRM_ORDER: {
    id: 'CONF_CONFIRM_ORDER',
    defaultMessage: 'Review & Confirm',
  },
  CONF_DOWNLOAD_PRINT_SUMMARY: {
    id: 'CONF_DOWNLOAD_PRINT_SUMMARY',
    defaultMessage: 'Download Summary ',
  },
  _PC_QUOTE_ITEM: { id: '_PC_QUOTE_ITEM', defaultMessage: 'Quote Item' },
  //Message returned as endpoint error. Do not modify or delete key.
  USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED: {
    id: 'USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED',
    defaultMessage:
      'You are not authorized or Your user session has expired. Sign in to continue.',
  },
  CONF_SPECIFICATION_PHYSICAL_MATERIAL: {
    id: 'CONF_SPECIFICATION_PHYSICAL_MATERIAL',
    defaultMessage: 'Physical Material',
  },
  PC_SPEC_PHYSICAL_MATERIAL_DNA: {
    id: 'PC_SPEC_PHYSICAL_MATERIAL_DNA',
    defaultMessage: 'Plasmid DNA',
  },
  CONF_DNA_SPECIFICATION_crispgrna: {
    id: 'CONF_DNA_SPECIFICATION_crispgrna',
    defaultMessage: 'Vector',
  },
  AMOUNT: { id: 'AMOUNT', defaultMessage: 'Amount' },
  PC_SPEC_PHYSICAL_MATERIAL_VIRUS: {
    id: 'PC_SPEC_PHYSICAL_MATERIAL_VIRUS',
    defaultMessage: 'Lentivirus',
  },
  CONF_SPECIFICATION_LENTIVIRAL_BACKBONE: {
    id: 'CONF_SPECIFICATION_LENTIVIRAL_BACKBONE',
    defaultMessage: 'Lentiviral Backbone',
  },
  CONF_VIRAL_TITER_customcrispr: {
    id: 'CONF_VIRAL_TITER_customcrispr',
    defaultMessage: 'Viral Titer:',
  },
  CONF_VIRUS_VOLUME_SPECIFICATION_crispgrna: {
    id: 'CONF_VIRUS_VOLUME_SPECIFICATION_crispgrna',
    defaultMessage: 'Volume',
  },
  CONF_VIRUS_ALIQUOTING_SPECIFICATION_crispgrna: {
    id: 'CONF_VIRUS_ALIQUOTING_SPECIFICATION_crispgrna',
    defaultMessage: 'Aliquoting',
  },
  PC_SPEC_PHYSICAL_MATERIAL_SRNA: {
    id: 'PC_SPEC_PHYSICAL_MATERIAL_SRNA',
    defaultMessage: 'Synthetic RNA',
  },
  CONF_PURIFICATION: {
    id: 'CONF_PURIFICATION',
    defaultMessage: 'Purification',
  },
  CONF_SPECIFICATION_CRISPR_SPECIES_crisprgrna: {
    id: 'CONF_SPECIFICATION_CRISPR_SPECIES_crisprgrna',
    defaultMessage: 'CRISPR Species',
  },
  STRUCTURE: { id: 'STRUCTURE', defaultMessage: 'Structure' },
  CONF_SCALE_OF_SYNTHESIS_customcrispr: {
    id: 'CONF_SCALE_OF_SYNTHESIS_customcrispr',
    defaultMessage: 'Scale of Synthesis',
  },
  CONF_SPECIFICATION_MODIFIED_crisprgrna: {
    id: 'CONF_SPECIFICATION_MODIFIED_crisprgrna',
    defaultMessage: 'Modified',
  },
  CONF_SPECIFICATION_FORMAT_crisprgrna: {
    id: 'CONF_SPECIFICATION_FORMAT_crisprgrna',
    defaultMessage: 'Format',
  },
  _PC_SPEC_DRY: { id: '_PC_SPEC_DRY', defaultMessage: 'Dry' },
  PC_SPEC_PHYSICAL_MATERIAL_VITRO: {
    id: 'PC_SPEC_PHYSICAL_MATERIAL_VITRO',
    defaultMessage: 'In vitro transcribed RNA(IVT RNA)',
  },
  CONF_CUSTOM_CRISPR_AKNOWLEDGEMENT_TEXT: {
    id: 'CONF_CUSTOM_CRISPR_AKNOWLEDGEMENT_TEXT',
    defaultMessage:
      'SygRNA® CRISPR crRNA requires tracrRNA for correct gene editing function. Please click to confirm you are aware of this requirement.',
  },
  CONF_DUPLEX_SHIPPING_OPTION: {
    id: 'CONF_DUPLEX_SHIPPING_OPTION',
    defaultMessage: 'Shipping:  ',
  },
  CONF_AMBIENT_ROOM_TEMP: {
    id: 'CONF_AMBIENT_ROOM_TEMP',
    defaultMessage: 'Ambient (Room Temperature)',
  },
  CART_QUOTATION_TEXT: {
    id: 'CART_QUOTATION_TEXT',
    defaultMessage:
      'Pricing can not be calculated. Add to cart to submit your quotation request.',
  },
  CONF_PRICE_SUB_TOTAL: {
    id: 'CONF_PRICE_SUB_TOTAL',
    defaultMessage: 'Price displayed is a subtotal amount.',
  },
  CONF_APPLICATIONFREIGHT_TAX: {
    id: 'CONF_APPLICATIONFREIGHT_TAX',
    defaultMessage:
      'Applicable freight, taxes and fees will be added at checkout.',
  },
  CONF_PROMOTIONAL_CODES: {
    id: 'CONF_PROMOTIONAL_CODES',
    defaultMessage: 'Promotional codes can be added at checkout',
  },
  SEND_REQUEST_TO_DEALER_HELP: {
    id: 'SEND_REQUEST_TO_DEALER_HELP',
    defaultMessage:
      'Click Send Request to Dealer to get a price quotation and arrange an order by providing your contact information.',
  },
  UPDATE_CART: { id: 'UPDATE_CART', defaultMessage: 'Update Cart' },
  ADD_TO_CART: { id: 'ADD_TO_CART', defaultMessage: 'Add to Cart' },
  CONF_CONFIRM_ORDER_DNA_PLATES: {
    id: 'CONF_CONFIRM_ORDER_DNA_PLATES',
    defaultMessage: 'Confirm Order',
  },
  CONF_DELETE_ALL_BUTTON: {
    id: 'CONF_DELETE_ALL_BUTTON',
    defaultMessage: 'Delete All ',
  },
  NAME: { id: 'NAME', defaultMessage: 'Name' },
  CONF_SEQUENCE_LABEL: {
    id: 'CONF_SEQUENCE_LABEL',
    defaultMessage: 'Sequence',
  },
  CONF_SEQUENCE_TYPE: {
    id: 'CONF_SEQUENCE_TYPE',
    defaultMessage: fiveFootStr,
  },
  CONF_BASES: { id: 'CONF_BASES', defaultMessage: 'Bases' },
  GENE_ID: { id: 'GENE_ID', defaultMessage: 'Gene ID' },
  GENE_SYMBOL: { id: 'GENE_SYMBOL', defaultMessage: 'Gene Symbol' },
  CONF_PRICE: { id: 'CONF_PRICE', defaultMessage: 'Price ' },
  CONF_ADD_OLIGO_SIDE_BAR_customcrispr: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_customcrispr',
    defaultMessage: 'Add CRISPR',
  },
  CONF_SELECT_REQUIRED_FIELD_crispgrna: {
    id: 'CONF_SELECT_REQUIRED_FIELD_crispgrna',
    defaultMessage: 'Please select the Required Fields',
  },
  CONF_SPECIFICATIONS_crisprgrna: {
    id: 'CONF_SPECIFICATIONS_crisprgrna',
    defaultMessage: 'Specifications',
  },
  CONF_CRISPR_ESSENTIALS_PAGE: {
    id: 'CONF_CRISPR_ESSENTIALS_PAGE',
    defaultMessage: 'CRISPR Essentials Page',
  },
  CONF_VISIT_CRISPR_ESSENTIALS_PAGE: {
    id: 'CONF_VISIT_CRISPR_ESSENTIALS_PAGE',
    defaultMessage:
      ' for more details about the formats and specifications offered.',
  },
  CONF_SPECIFICATION_PHYSICAL_MATERIAL_SYNTHETIC_RNA_crisprgrna: {
    id: 'CONF_SPECIFICATION_PHYSICAL_MATERIAL_SYNTHETIC_RNA_crisprgrna',
    defaultMessage: 'Synthetic RNA',
  },
  CONF_SPECIFICATION_STRUCTURE_crisprgrna: {
    id: 'CONF_SPECIFICATION_STRUCTURE_crisprgrna',
    defaultMessage: 'Structure',
  },
  CONF_SPECIFICATION_SYNTHESIS_SCALE_crisprgrna: {
    id: 'CONF_SPECIFICATION_SYNTHESIS_SCALE_crisprgrna',
    defaultMessage: 'Synthesis Scale',
  },
  CONF_SPECIFICATION_MODIFICATION_HELP_TEXT_customcrispr: {
    id: 'CONF_SPECIFICATION_MODIFICATION_HELP_TEXT_customcrispr',
    defaultMessage:
      "Chemically modified CRISPR RNA contain stabilizing 2'-O-methyl and phosphorothioate linkages which may lead to improved editing efficiency in primary cells and other hard-to-transfect cell lines.",
  },
  PURIFICATION_HELP_TEXT_ONE: {
    id: 'PURIFICATION_HELP_TEXT_ONE',
    defaultMessage:
      'Standard sgRNAs are purified via reverse-phase cartridge chromatography which separates the full-length sequence from shortmers and truncated sequences generated during the synthesis process. Standard purification sgRNAs work in numerous CRISPR applications over a range of model systems.',
  },
  PURIFICATION_HELP_TEXT_TWO: {
    id: 'PURIFICATION_HELP_TEXT_TWO',
    defaultMessage:
      'PURedit™ sgRNAs are purified via HPLC, which provides the highest, most consistent quality sgRNAs by precisely purifying out truncated sequences based on only a few base changes. For applications requiring high quality reagents, PURedit™ sgRNAs are the best choice.',
  },
  CONF_SPECIFICATION_PURIFICATION_crisprgrna: {
    id: 'CONF_SPECIFICATION_PURIFICATION_crisprgrna',
    defaultMessage: 'Purification',
  },
  CONF_SPECIFICATION_DRY_crisprgrna: {
    id: 'CONF_SPECIFICATION_DRY_crisprgrna',
    defaultMessage: 'Dry',
  },
  CONF_AMOUNT_DNA_SPECIFICATION_crispgrna: {
    id: 'CONF_AMOUNT_DNA_SPECIFICATION_crispgrna',
    defaultMessage: 'Amount',
  },
  CONF_VIRUS_LENTIVIRUS_SPECIFICATION_crispgrna: {
    id: 'CONF_VIRUS_LENTIVIRUS_SPECIFICATION_crispgrna',
    defaultMessage: 'Lentivirus Backbone',
  },
  CONF_DNA_DROPDOWN_SPECIFICATION_crispgrna: {
    id: 'CONF_DNA_DROPDOWN_SPECIFICATION_crispgrna',
    defaultMessage: 'View vector maps and features at',
  },
  CONF_DNA_LINK_SPECIFICATION_crispgrna: {
    id: 'CONF_DNA_LINK_SPECIFICATION_crispgrna',
    defaultMessage: ' CRISPR Essentials',
  },
  CONF_SPEC_VIRAL_TITER: {
    id: 'CONF_SPEC_VIRAL_TITER',
    defaultMessage: 'Viral Titer',
  },
  CONTINUE: { id: 'CONTINUE', defaultMessage: 'Continue' },
  CONF_DNAPLATES_ERROR_STEP2: {
    id: 'CONF_DNAPLATES_ERROR_STEP2',
    defaultMessage:
      'Please correct the error(s) before proceeding to the next step.',
  },
  CONF_UPLOAD_ERROR_MSG: {
    id: 'CONF_UPLOAD_ERROR_MSG',
    defaultMessage: 'Maximum number of items per session is 100.',
  },
  CONF_BASE_COUNT_standard: {
    id: 'CONF_BASE_COUNT_standard',
    defaultMessage: baseCountStr,
  },
  CONF_CRISPR_SEQUENCE_LIST: {
    id: 'CONF_CRISPR_SEQUENCE_LIST',
    defaultMessage: 'CRISPR Sequence List',
  },
  CONF_CONTINUE_DNA_PLATES: {
    id: 'CONF_CONTINUE_DNA_PLATES',
    defaultMessage: 'Continue',
  },
  CONF_SUCCESS: { id: 'CONF_SUCCESS', defaultMessage: 'success' },
  CONF_INVALID_TEMPLATE: {
    id: 'CONF_INVALID_TEMPLATE',
    defaultMessage:
      'The file you have uploaded is invalid. Try again using the template provided.',
  },
  MULTIPLE_LINE_ERROR: {
    id: 'MULTIPLE_LINE_ERROR',
    defaultMessage: 'Multiple lines are not allowed for Name',
  },
  CONF_EMPTY_FILE: {
    id: 'CONF_EMPTY_FILE',
    defaultMessage: 'The uploaded file is empty.',
  },
  CONF_INVALID_FORMAT: {
    id: 'CONF_INVALID_FORMAT',
    defaultMessage: 'Invalid format. Please check the template and try again.',
  },
  CONF_OPTIONAL_INTR_MOD_TEMPLATE_standard: {
    id: 'CONF_OPTIONAL_INTR_MOD_TEMPLATE_standard',
    defaultMessage:
      'Follow these steps below to quickly upload multiple entries using a pre-defined template.',
  },
  CONF_DNAPLATES_STEP1: {
    id: 'CONF_DNAPLATES_STEP1',
    defaultMessage: 'Step 1',
  },
  CONF_DNAPLATES_DOWNLOAD: {
    id: 'CONF_DNAPLATES_DOWNLOAD',
    defaultMessage: 'Download the Plate Ordering Template you need:',
  },
  CONF_DNAPLATES_STEP2: {
    id: 'CONF_DNAPLATES_STEP2',
    defaultMessage: 'Step 2',
  },
  CONF_MULTIPLE_ENTRY_STEP_2: {
    id: 'CONF_MULTIPLE_ENTRY_STEP_2',
    defaultMessage:
      'Enter your specifications in the provided spreadsheet template.',
  },
  CONF_DNAPLATES_STEP3: {
    id: 'CONF_DNAPLATES_STEP3',
    defaultMessage: 'Step 3',
  },
  CONF_UPLOAD_YOUR_DATA_customcrispr: {
    id: 'CONF_UPLOAD_YOUR_DATA_customcrispr',
    defaultMessage: 'Upload Your Data:',
  },
  CONF_REVIEW_ERROR_MSG: {
    id: 'CONF_REVIEW_ERROR_MSG',
    defaultMessage: 'ReviewError',
  },
  CONF_ERROR: { id: 'CONF_ERROR', defaultMessage: 'Error: ' },
  DNA_RNA_OLIGO: { id: 'DNA_RNA_OLIGO', defaultMessage: 'DNA & RNA Oligos' },
  QPCR_PROBES_PRIMERS: {
    id: 'QPCR_PROBES_PRIMERS',
    defaultMessage: 'Predesigned Primers And Custom qPCR Probes',
  },
  ORDER_TEXT: { id: 'ORDER_TEXT', defaultMessage: 'Order' },
  HOME: { id: 'HOME', defaultMessage: 'Home' },
  PRODUCTS: { id: 'PRODUCTS', defaultMessage: 'Products' },
  MOLECULAR_BIOLOGY_FUNCTIONAL_GENOMICS: {
    id: 'MOLECULAR_BIOLOGY_FUNCTIONAL_GENOMICS',
    defaultMessage: 'Molecular Biology & Functional Genomics',
  },
  OLIGOS_QPCR_PROBES_PEPTIDES: {
    id: 'OLIGOS_QPCR_PROBES_PEPTIDES',
    defaultMessage: 'Oligos, qPCR Probes & Peptides',
  },
  CUSTOM_PREDESIGNED_DNA_OLIGOS_PROBES: {
    id: 'CUSTOM_PREDESIGNED_DNA_OLIGOS_PROBES',
    defaultMessage: 'Custom & Predesigned DNA Oligos & qPCR Probes',
  },
  CUSTOMOLIGO_OLIGO_PROBE: {
    id: 'CUSTOMOLIGO_OLIGO_PROBE',
    defaultMessage: 'Oligo & Probes',
  },
  CUSTOMOLIGO_GENE_KNOCKOUT: {
    id: 'CUSTOMOLIGO_GENE_KNOCKOUT',
    defaultMessage: 'Gene Knockout, Knockdown & Expression',
  },
  CUSTOMOLIGO_PEPTIDE: {
    id: 'CUSTOMOLIGO_PEPTIDE',
    defaultMessage: 'Peptides',
  },
  CUSTOM_OLIGO_PROBES_TITLE: {
    id: 'CUSTOM_OLIGO_PROBES_TITLE',
    defaultMessage: 'Custom Oligos and qPCR Probes',
  },
  CUSTOM_OLIGO_PROBES: {
    id: 'CUSTOM_OLIGO_PROBES',
    defaultMessage:
      'Sigma offers a comprehensive portfolio of DNA oligos, RNA oligos, predesigned primers and qPCR probes for application including PCR, cloning, next-generation sequencing (NGS), microarray production, CRISPR, gene synthesis, gene expression analysis, genotyping and pathogen detection.',
  },
  KNOCKOUT: { id: 'KNOCKOUT', defaultMessage: 'Knockout' },
  KNOCKDOWN: { id: 'KNOCKDOWN', defaultMessage: 'Knockdown' },
  EXPRESSIONS: { id: 'EXPRESSIONS', defaultMessage: 'Expressions' },
  AQUA_Peptides_PRODUCT_AQUA: {
    id: 'AQUA_Peptides_PRODUCT_AQUA',
    defaultMessage: 'AQUA™ Peptides',
  },
  QPCR_PROBES_kICqStart_primers: {
    id: 'QPCR_PROBES_kICqStart_primers',
    defaultMessage: 'KiCqStart™ Primers',
  },
  QPCR_PROBES_Desc_kICqStart_primers: {
    id: 'QPCR_PROBES_Desc_kICqStart_primers',
    defaultMessage:
      'Predesigned primer pairs for quantifying gene expression by SYBR{registered} Green | RT-qPCR.',
  },
  QPCR_PROBES_kICqStart_primers_gene_arrays: {
    id: 'QPCR_PROBES_kICqStart_primers_gene_arrays',
    defaultMessage: 'KiCqStart Primers Gene Arrays',
  },
  QPCR_PROBES_Desc_kICqStart_primers_gene_arrays: {
    id: 'QPCR_PROBES_Desc_kICqStart_primers_gene_arrays',
    defaultMessage:
      'Predesigned primer pairs organized into the groups of genes that comprise common gene families',
  },
  QPCR_PROBES_kICqStart_probes_assays: {
    id: 'QPCR_PROBES_kICqStart_probes_assays',
    defaultMessage: 'KiCqStart Probe Assays',
  },
  QPCR_PROBES_Desc_kICqStart_probes_assays: {
    id: 'QPCR_PROBES_Desc_kICqStart_probes_assays',
    defaultMessage:
      'Predesigned probes assays for quantifying gene expression by RT-qPCR',
  },
  CONF_TITLE_PROBE: {
    id: 'CONF_TITLE_PROBE',
    defaultMessage: 'Dual-Labeled Probes',
  },
  CONF_TITLE_PROBE_NEW: {
    id: 'CONF_TITLE_PROBE_NEW',
    defaultMessage: 'Dual-Labeled, Internal-Quenched & Dual-Quenched Probes',
  },
  QPCR_PROBES_Desc_dual_labeled_probes: {
    id: 'QPCR_PROBES_Desc_dual_labeled_probes',
    defaultMessage:
      "The most common probe type, linear hydrolysis probes are used in the 5' nuclease assays",
  },
  CONF_TITLE_BEACON: {
    id: 'CONF_TITLE_BEACON',
    defaultMessage: 'Molecular Beacons',
  },
  QPCR_PROBES_Desc_molecular_beacons: {
    id: 'QPCR_PROBES_Desc_molecular_beacons',
    defaultMessage:
      'Structured hybridization probes that are not degraded during the amplification reaction',
  },
  QPCR_PROBES_lightcycler_probes: {
    id: 'QPCR_PROBES_lightcycler_probes',
    defaultMessage: 'LightCycler® Probes',
  },
  QPCR_PROBES_Desc_lightcycler_probes: {
    id: 'QPCR_PROBES_Desc_lightcycler_probes',
    defaultMessage:
      'Dual-hybridization probes designed for use in Roche™ LightCycler instruments',
  },
  QPCR_PROBES_scorpions_uni_probes: {
    id: 'QPCR_PROBES_scorpions_uni_probes',
    defaultMessage: 'Scorpions® Uni-Probes',
  },
  QPCR_PROBES_Desc_scorpions_uni_probes: {
    id: 'QPCR_PROBES_Desc_scorpions_uni_probes',
    defaultMessage:
      'Combination one-part structured probes - primers that internally hybridized to the target sequence',
  },
  DNA_OLIGO_IN_TUBES: {
    id: 'DNA_OLIGO_IN_TUBES',
    defaultMessage: 'DNA Oligos in Tubes',
  },
  DNA_OLIGO_IN_TUBES_DESC: {
    id: 'DNA_OLIGO_IN_TUBES_DESC',
    defaultMessage: 'For applications including PCR, sequencing and cloning.',
  },
  DNA_OLIGO_IN_PLATES: {
    id: 'DNA_OLIGO_IN_PLATES',
    defaultMessage: 'DNA Oligos in Plates',
  },
  DNA_OLIGO_IN_PLATES_DESC: {
    id: 'DNA_OLIGO_IN_PLATES_DESC',
    defaultMessage:
      'Supplied in 96 or 384-well plates including many formatting options.',
  },
  RNA_OLIGO: { id: 'RNA_OLIGO', defaultMessage: 'RNA Oligos' },
  RNA_OLIGO_DESC: {
    id: 'RNA_OLIGO_DESC',
    defaultMessage:
      'Single strand oligos containing RNA bases, mixed DNA/RNA or RNA/OMe bases.',
  },
  EASY_OLIGO: { id: 'EASY_OLIGO', defaultMessage: 'Easy™ Oligos' },
  EASY_OLIGO_DESC: {
    id: 'EASY_OLIGO_DESC',
    defaultMessage: 'Normalized to 100 μM at a fixed price.',
  },
  PURE_PRIMERS: {
    id: 'PURE_PRIMERS',
    defaultMessage: 'Pure And Simple Primers',
  },
  PURE_PRIMERS_DESC: {
    id: 'PURE_PRIMERS_DESC',
    defaultMessage: 'Cartridge purified primers at a fixed price.',
  },
  WELLRED_OLIGO: { id: 'WELLRED_OLIGO', defaultMessage: 'WellRED Oligos' },
  WELLRED_OLIGO_DESC: {
    id: 'WELLRED_OLIGO_DESC',
    defaultMessage:
      "For use with Beckman Coulter's CEQ/GeXP Genetic Analysis Systems",
  },
  CONF_STANDARD_TUBES_longoligo: {
    id: 'CONF_STANDARD_TUBES_longoligo',
    defaultMessage: 'Long Oligos',
  },
  DNA_LONG_OLIGO_DESC: {
    id: 'DNA_LONG_OLIGO_DESC',
    defaultMessage:
      'DNA oligo lengths from 121 to 180 bases for gene construction, microarray development and CRISPR gene editing.',
  },
  KNOCKOUT_PRODUCT_CRISPR_DESCRIPTION: {
    id: 'KNOCKOUT_PRODUCT_CRISPR_DESCRIPTION',
    defaultMessage:
      'Order plasmids, RNA, nickases, controls and more for this exciting genome editing technology.',
  },
  KNOCKDOWN_PRODUCT_shRNA: {
    id: 'KNOCKDOWN_PRODUCT_shRNA',
    defaultMessage: 'shRNA',
  },
  KNOCKDOWN_PRODUCT_shRNA_DESCRIPTION: {
    id: 'KNOCKDOWN_PRODUCT_shRNA_DESCRIPTION',
    defaultMessage:
      'The largest, most validated shRNA collection on the planet; order clones and libraries or request custom designs.',
  },
  KNOCKDOWN_PRODUCT_siRNA: {
    id: 'KNOCKDOWN_PRODUCT_siRNA',
    defaultMessage: 'siRNA',
  },
  KNOCKDOWN_PRODUCT_siRNA_DESCRIPTION: {
    id: 'KNOCKDOWN_PRODUCT_siRNA_DESCRIPTION',
    defaultMessage:
      'Duplex RNA available as predesigned constructs or synthesized to your custom specifications.',
  },
  EXPRESSION_PRODUCT_ORF_DESCRIPTION: {
    id: 'EXPRESSION_PRODUCT_ORF_DESCRIPTION',
    defaultMessage:
      'Protein coding sequences from the human ORFeum in several lentiviral vector choices.',
  },
  AQUA_Peptides_PRODUCT_AQUA_DESCRIPTION: {
    id: 'AQUA_Peptides_PRODUCT_AQUA_DESCRIPTION',
    defaultMessage: 'Quantitated peptides with or without isotope labeling.',
  },
  CONF_DNAPLATES_ORDER_SUMMARY: {
    id: 'CONF_DNAPLATES_ORDER_SUMMARY',
    defaultMessage: 'Order Summary',
  },
  CONF_AMOUNT: { id: 'CONF_AMOUNT', defaultMessage: 'Amount:' },
  _PC_PROPERTY_DISPLAY_0_500mg_screen: {
    id: '_PC_PROPERTY_DISPLAY_0_500mg_screen',
    defaultMessage: '0.5 mg',
  },
  _PC_PROPERTY_DISPLAY_2_000mg_screen: {
    id: '_PC_PROPERTY_DISPLAY_2_000mg_screen',
    defaultMessage: '2 mg',
  },
  CONF_PURIFICATION_DNA_PLATES: {
    id: 'CONF_PURIFICATION_DNA_PLATES',
    defaultMessage: 'Purification:',
  },
  CONF_FORMAT_DNA_PLATES: {
    id: 'CONF_FORMAT_DNA_PLATES',
    defaultMessage: 'Format:',
  },
  CONF_CHLORIDE_SALT_EXCHANGE: {
    id: 'CONF_CHLORIDE_SALT_EXCHANGE',
    defaultMessage: 'Chloride Salt Exchange:',
  },
  CONF_DNAPLATES_ORDER_SUMMARY_PACKAGING_OPTIONS: {
    id: 'CONF_DNAPLATES_ORDER_SUMMARY_PACKAGING_OPTIONS',
    defaultMessage: 'Packaging Options',
  },
  CONF_PACKAGING_PEPSCREEN: {
    id: 'CONF_PACKAGING_PEPSCREEN',
    defaultMessage: 'Packaging:',
  },
  CONF_PACKAGING_PEPSCREEN_WELL_TUBE: {
    id: 'CONF_PACKAGING_PEPSCREEN_WELL_TUBE',
    defaultMessage: '96 Well-Tube Set',
  },
  CONF_SHIPPING_OPTION_PEPSCREEN: {
    id: 'CONF_SHIPPING_OPTION_PEPSCREEN',
    defaultMessage: 'Shipping Option:',
  },
  CONF_PACKAGING_PEPSCREEN_AMBIENT: {
    id: 'CONF_PACKAGING_PEPSCREEN_AMBIENT',
    defaultMessage: 'Ambient',
  },
  CONF_PEPSCREEN_DOWNLOAD_SUMMARY: {
    id: 'CONF_PEPSCREEN_DOWNLOAD_SUMMARY',
    defaultMessage: 'Download Summary',
  },
  CART_SUMMARY: { id: 'CART_SUMMARY', defaultMessage: 'Summary' },
  CONF_SUBTOTAL_DNA_PLATES: {
    id: 'CONF_SUBTOTAL_DNA_PLATES',
    defaultMessage: 'Subtotal:',
  },
  CONF_NOTE: { id: 'CONF_NOTE', defaultMessage: 'Note: ' },
  CONF_POINT_ONE_DNA_PLATES: {
    id: 'CONF_POINT_ONE_DNA_PLATES',
    defaultMessage:
      'Applicable freight, taxes and fees will be added at checkout',
  },
  CONF_ADDITIONAL_SHIPPING_INFO: {
    id: 'CONF_ADDITIONAL_SHIPPING_INFO',
    defaultMessage: 'Additional Comments / Specifications (Optional)',
  },
  CONF_ACKNOWLEDGE_DNA_PLATES: {
    id: 'CONF_ACKNOWLEDGE_DNA_PLATES',
    defaultMessage:
      'Acknowledge: Adding comments will slow the order processing',
  },
  CONF_ENTER_ADDITIONAL_INFO: {
    id: 'CONF_ENTER_ADDITIONAL_INFO',
    defaultMessage: 'Enter Additional Information',
  },
  CONF_SPL_CHAR_VALIDATION_MSG: {
    id: 'CONF_SPL_CHAR_VALIDATION_MSG',
    defaultMessage: 'Comment contains invalid character(s): ',
  },
  PC_PRICE_ERROR_EMPTY_PRICE: {
    id: 'PC_PRICE_ERROR_EMPTY_PRICE',
    defaultMessage:
      'We are experiencing some technical difficulties while calculating the price. Please proceed to cart and your shopping cart will be updated with the correct price',
  },
  CONF_PEPSCREEN_NUMBER_CONFIRM_ORDER: {
    id: 'CONF_PEPSCREEN_NUMBER_CONFIRM_ORDER',
    defaultMessage: 'Peptide Number:',
  },
  CONF_PEPSCREEN_ANALYTICAL_HPLC_CONFIRM_ORDER: {
    id: 'CONF_PEPSCREEN_ANALYTICAL_HPLC_CONFIRM_ORDER',
    defaultMessage: 'Analytical HPLC:',
  },
  CONF_OLIGO_NAME_WARNING: {
    id: 'CONF_OLIGO_NAME_WARNING',
    defaultMessage:
      'Character size varies and the product name prefix on the tube label may be truncated if longer than 18 characters.',
  },
  CONF_TOTAL_PEPTIDE_COUNT: {
    id: 'CONF_TOTAL_PEPTIDE_COUNT',
    defaultMessage: 'Total Peptide(s): ',
  },
  CONF_AMOUNT_TEXT: { id: 'CONF_AMOUNT_TEXT', defaultMessage: 'amount' },
  CONF_FORMAT_TEXT: { id: 'CONF_FORMAT_TEXT', defaultMessage: 'format' },
  CONF_PURIFICATION_TEXT: {
    id: 'CONF_PURIFICATION_TEXT',
    defaultMessage: 'purification',
  },
  CONF_PEPSCREEN_SPECIFICATION: {
    id: 'CONF_PEPSCREEN_SPECIFICATION',
    defaultMessage: 'Specifications',
  },
  CONF_PEPSCREEN_SPECIFICATION_TEXT: {
    id: 'CONF_PEPSCREEN_SPECIFICATION_TEXT',
    defaultMessage: 'Selections will apply to all peptides in this upload.',
  },
  CONF_PEPSCREEN_AMOUNT: {
    id: 'CONF_PEPSCREEN_AMOUNT',
    defaultMessage: 'Amount',
  },
  _PC_TOR_PEPTIDE_AMOUNT_TOOLTIP_screen: {
    id: '_PC_TOR_PEPTIDE_AMOUNT_TOOLTIP_screen',
    defaultMessage:
      ' Minimum guaranteed amount is based on 0.5 mg or 2 mg option.',
  },
  _PC_TOR_PEPTIDE_AMOUNT_TOOLTIP_screen_remaining: {
    id: '_PC_TOR_PEPTIDE_AMOUNT_TOOLTIP_screen_remaining',
    defaultMessage:
      ' The amount of individual peptides will vary in the set due to different peptide lengths and compositions.',
  },
  CONF_PEPSCREEN_FORMAT: {
    id: 'CONF_PEPSCREEN_FORMAT',
    defaultMessage: 'Format',
  },
  CONF_PEPSCREEN_PACKAGING: {
    id: 'CONF_PEPSCREEN_PACKAGING',
    defaultMessage: 'Packaging',
  },
  CONF_PEPSCREEN_SERVICES: {
    id: 'CONF_PEPSCREEN_SERVICES',
    defaultMessage: 'Services',
  },
  CONF_OVERRIDE_VALIDATION: {
    id: 'CONF_OVERRIDE_VALIDATION',
    defaultMessage: 'Override Validation',
  },
  CONF_PEPSCREEN_SERVICES_HELP_TEXT: {
    id: 'CONF_PEPSCREEN_SERVICES_HELP_TEXT',
    defaultMessage:
      'Selections will apply to all peptides in this upload and fees apply.',
  },
  CONF_CHLORIDE_SALT_EXCHANGE_PEPSCREEN: {
    id: 'CONF_CHLORIDE_SALT_EXCHANGE_PEPSCREEN',
    defaultMessage: 'Chloride Salt Exchange',
  },
  CONF_ALIQUOT_SPLIT_PEPSCREEN: {
    id: 'CONF_ALIQUOT_SPLIT_PEPSCREEN',
    defaultMessage: 'Aliquot (split equally into 2 sets)',
  },
  CONF_PEPSCREEN_PREVIOUS_BUTTON: {
    id: 'CONF_PEPSCREEN_PREVIOUS_BUTTON',
    defaultMessage: 'Previous',
  },
  CONF_DNAPLATES_EMPTY_WELLS: {
    id: 'CONF_DNAPLATES_EMPTY_WELLS',
    defaultMessage: 'Empty Wells',
  },
  CONF_DNAPLATES_VALID_SEQUENCE: {
    id: 'CONF_DNAPLATES_VALID_SEQUENCE',
    defaultMessage: 'Valid Sequence',
  },
  CONF_DNAPLATES_INVALID_SEQUENCE: {
    id: 'CONF_DNAPLATES_INVALID_SEQUENCE',
    defaultMessage: 'Invalid Sequence',
  },
  CONF_PEPSCREEN_MINIMUM_WELLS_TEXT: {
    id: 'CONF_PEPSCREEN_MINIMUM_WELLS_TEXT',
    defaultMessage: 'Minimum of 24 peptides is required.',
  },
  CONF_SCREEN_WELLSECTION_HEAD_TEXT: {
    id: 'CONF_SCREEN_WELLSECTION_HEAD_TEXT',
    defaultMessage: 'Peptide Sequences  ',
  },
  CONF_SCREEN_PRODUCT_WELLSECTION_SUBHEAD_TEXT: {
    id: 'CONF_SCREEN_PRODUCT_WELLSECTION_SUBHEAD_TEXT',
    defaultMessage:
      '(Click on the well below to view/modify individual peptide sequences)',
  },
  CONF_SEQUENCE_TEXT: { id: 'CONF_SEQUENCE_TEXT', defaultMessage: 'sequence' },
  CONF_OLIGO_NAME_KEY: { id: 'CONF_OLIGO_NAME_KEY', defaultMessage: 'name' },
  CONF_DNAPLATE_ISDFORM_WARNING_STEP1: {
    id: 'CONF_DNAPLATE_ISDFORM_WARNING_STEP1',
    defaultMessage:
      'Change made to your peptide sequence. Due to the modification location in your peptide, the C-terminal must be amidated [NH2].',
  },
  CONF_PEPSCREEN_PEPTIDE_SEQUENCE: {
    id: 'CONF_PEPSCREEN_PEPTIDE_SEQUENCE',
    defaultMessage: 'Peptide Sequence',
  },
  CONF_OLIGO_NAME_aqua: {
    id: 'CONF_OLIGO_NAME_aqua',
    defaultMessage: 'Peptide Name:',
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters.',
  },
  CONF_DNAPLATES_SEQUENCE: {
    id: 'CONF_DNAPLATES_SEQUENCE',
    defaultMessage: 'Sequence:',
  },
  CONF_DNAPLATES_MODIFICATIONS: {
    id: 'CONF_DNAPLATES_MODIFICATIONS',
    defaultMessage: 'Modifications:',
  },
  CONF_PEPSCREEN_PEPTIDE_PREVIEW: {
    id: 'CONF_PEPSCREEN_PEPTIDE_PREVIEW',
    defaultMessage: 'Sequence Preview:',
  },
  CONF_DNA_OLIGO_NAME_TOOLTIP: {
    id: 'CONF_DNA_OLIGO_NAME_TOOLTIP',
    defaultMessage:
      'Maximum character limit for technical datasheet is 30. Character size varies and the product name prefix on the tube label may be truncated if longer than 18 characters.',
  },
  CONF_PRODUCT_PEPSCREEN_PROPERTIES: {
    id: 'CONF_PRODUCT_PEPSCREEN_PROPERTIES',
    defaultMessage: 'Peptide Properties',
  },
  CONF_DNAPLATES_MOLECULAR_WEIGHT: {
    id: 'CONF_DNAPLATES_MOLECULAR_WEIGHT',
    defaultMessage: 'Molecular Weight:',
  },
  CONF_PEPSCREEN_NO_AMINO_ACIDS: {
    id: 'CONF_PEPSCREEN_NO_AMINO_ACIDS',
    defaultMessage: 'Number of Amino Acids:',
  },
  CONF_PEPSCREEN_ANALYTICAL_HPLC: {
    id: 'CONF_PEPSCREEN_ANALYTICAL_HPLC',
    defaultMessage: 'Analytical HPLC',
  },
  CONF_PRODUCT_PEPSCREEN_HPLC_HELP_TEXT: {
    id: 'CONF_PRODUCT_PEPSCREEN_HPLC_HELP_TEXT',
    defaultMessage: 'Analysis of peptide purity determined by analytical HPLC.',
  },
  CONF_PRODUCT_PEPSCREEN_HPLC_HELP_TEXT_END: {
    id: 'CONF_PRODUCT_PEPSCREEN_HPLC_HELP_TEXT_END',
    defaultMessage:
      'HPLC peak area information is supplied with product shipment.',
  },
  CONF_DNAPLATES_SELECTED_WELL: {
    id: 'CONF_DNAPLATES_SELECTED_WELL',
    defaultMessage: 'Selected Well: ',
  },
  CONF_DNAPLATES_UPDATE_WELL: {
    id: 'CONF_DNAPLATES_UPDATE_WELL',
    defaultMessage: 'Update Well',
  },
  CONF_DNAPLATES_CLEAR_WELL: {
    id: 'CONF_DNAPLATES_CLEAR_WELL',
    defaultMessage: 'Clear Well',
  },
  CONF_PEPSCREEN_OR_TEXT: {
    id: 'CONF_PEPSCREEN_OR_TEXT',
    defaultMessage: 'Or',
  },
  CONF_COPY_ENTRY_HEADING: {
    id: 'CONF_COPY_ENTRY_HEADING',
    defaultMessage: 'Copy your entries and paste and edit them here:',
  },
  CONF_PEPSCREEN_COPYPASTE_HELPTEXT1: {
    id: 'CONF_PEPSCREEN_COPYPASTE_HELPTEXT1',
    defaultMessage:
      'Download the Multiple Entry Template to view formatting requirements or type sequence information using the example format below. One record per line, comma or tab delimited. Do not include column headers. Minimum order size of 24 peptides.',
  },
  CONF_PEPSCREEN_COPYPASTE_HELPTEXT2: {
    id: 'CONF_PEPSCREEN_COPYPASTE_HELPTEXT2',
    defaultMessage: 'Comma delimited example:',
  },
  CONF_PEPSCREEN_COPYPASTE_HELPTEXT3: {
    id: 'CONF_PEPSCREEN_COPYPASTE_HELPTEXT3',
    defaultMessage:
      'Peptide Name,N-Terminal Modification,Sequence,C-Terminal Modification,Analytical HPLC',
  },
  CONF_PEPSCREEN_PLACEHOLDER: {
    id: 'CONF_PEPSCREEN_PLACEHOLDER',
    defaultMessage: 'Paste entries here and edit',
  },
  CONF_PEPSCREEN_MULTIPLE_ENTRY_TEMPLATE: {
    id: 'CONF_PEPSCREEN_MULTIPLE_ENTRY_TEMPLATE',
    defaultMessage: 'Multiple Entry Template',
  },
  CONF_PLATE_SEQUENCEUPLOAD_HEADER_TEXT: {
    id: 'CONF_PLATE_SEQUENCEUPLOAD_HEADER_TEXT',
    defaultMessage:
      'Follow the steps below to upload multiple plates using the pre-defined templates.',
  },
  CONF_CHOOSE_AMINO_ACID_STEP1: {
    id: 'CONF_CHOOSE_AMINO_ACID_STEP1',
    defaultMessage: 'Choose D-form amino acid settings',
  },
  CONF_PEPSCREEN_TOGGLE_HELP_TEXT: {
    id: 'CONF_PEPSCREEN_TOGGLE_HELP_TEXT',
    defaultMessage:
      'Lowercase letters indicate D-form amino acids. The default setting is for standard L-form amino acids and will convert from lowercase to uppercase',
  },
  CONF_PEPSCREEN_SWITCH_MESSAGE: {
    id: 'CONF_PEPSCREEN_SWITCH_MESSAGE',
    defaultMessage: 'Include D-form amino acids in the upload',
  },
  CONF_PEPSCREEN_DOWNLOAD_STEP2_TEXT: {
    id: 'CONF_PEPSCREEN_DOWNLOAD_STEP2_TEXT',
    defaultMessage: 'Download the Peptide Ordering Template:',
  },
  CONF_DNAPLATES_STEP4: {
    id: 'CONF_DNAPLATES_STEP4',
    defaultMessage: 'Step 4',
  },
  CONF_MULTIPLE_ENTRY_STEP_3: {
    id: 'CONF_MULTIPLE_ENTRY_STEP_3',
    defaultMessage: 'Upload your data with either of the methods below:',
  },
  CONF_PEPSCREEN_STEP5: {
    id: 'CONF_PEPSCREEN_STEP5',
    defaultMessage: 'Step 5',
  },
  CONF_PEPSCREEN_STEP4: {
    id: 'CONF_PEPSCREEN_STEP4',
    defaultMessage: 'Step 4',
  },
  CONF_PEPSCREEN_STEP3: {
    id: 'CONF_PEPSCREEN_STEP3',
    defaultMessage: 'Step 3',
  },
  CONF_PEPSCREEN_STEP2: {
    id: 'CONF_PEPSCREEN_STEP2',
    defaultMessage: 'Step 2',
  },
  CONF_PEPSCREEN_STEP1: {
    id: 'CONF_PEPSCREEN_STEP1',
    defaultMessage: 'Step 1',
  },
  CONF_UPLOAD_YOUR_DATA: {
    id: 'CONF_UPLOAD_YOUR_DATA',
    defaultMessage: 'Upload Your Data',
  },
  CONF_HOME_PEPSCREEN: { id: 'CONF_HOME_PEPSCREEN', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCT_PEPSCREEN: {
    id: 'CONF_CUSTOM_PRODUCT_PEPSCREEN',
    defaultMessage: customProductsStr,
  },
  CONF_PRODUCT_PEPSCREEN: {
    id: 'CONF_PRODUCT_PEPSCREEN',
    defaultMessage: 'Peptides',
  },
  CONF_PRODUCT_NAME_PEPSCREEN: {
    id: 'CONF_PRODUCT_NAME_PEPSCREEN',
    defaultMessage: 'PEPscreen',
  },
  CONF_DNAPLATES_SEQUENCE_UPLOAD: {
    id: 'CONF_DNAPLATES_SEQUENCE_UPLOAD',
    defaultMessage: 'Sequence Upload',
  },
  CONF_PEPSCREEN_BREADCRUMB_CONFIGURATION: {
    id: 'CONF_PEPSCREEN_BREADCRUMB_CONFIGURATION',
    defaultMessage: 'Peptide Configuration',
  },
  CONF_DNAPLATES_SPECIFICATION: {
    id: 'CONF_DNAPLATES_SPECIFICATION',
    defaultMessage: 'Specifications',
  },
  CONF_LABEL_HEADER_PEPSCREEN: {
    id: 'CONF_LABEL_HEADER_PEPSCREEN',
    defaultMessage: 'PEPscreen',
  },
  CONF_TRADEMARK: { id: 'CONF_TRADEMARK', defaultMessage: '®' },
  CONF_LABEL_HEADER_CUSTOM_PEPSCREEN: {
    id: 'CONF_LABEL_HEADER_CUSTOM_PEPSCREEN',
    defaultMessage: 'Custom Peptide Library',
  },
  CONF_MY_OLIGOS_SIDE_BAR_aqua: {
    id: 'CONF_MY_PEPTIDES_SIDE_BAR_aqua',
    defaultMessage: 'My Peptides ',
  },
  CONF_VIEW_ALL_PEPTIDE_NUMBER: {
    id: 'CONF_VIEW_ALL_PEPTIDE_NUMBER',
    defaultMessage: 'Well ID / Peptide Number',
  },
  PEPTIDE_NAME: { id: 'PEPTIDE_NAME', defaultMessage: 'Peptide Name' },
  CONF_CLOSE_BUTTON: { id: 'CONF_CLOSE_BUTTON', defaultMessage: 'Close ' },
  CONF_PACKAGING_PEPSCREEN_TUBE_SET: {
    id: 'CONF_PACKAGING_PEPSCREEN_TUBE_SET',
    defaultMessage: 'Tube Set ',
  },
  CONF_PACKAGING_PEPSCREEN_PRODUCTSUMMARY_PEPTIDE: {
    id: 'CONF_PACKAGING_PEPSCREEN_PRODUCTSUMMARY_PEPTIDE',
    defaultMessage: ', Peptides ',
  },
  CONF_VIEW_ALL_SIDE_BAR: {
    id: 'CONF_VIEW_ALL_SIDE_BAR',
    defaultMessage: 'View All ',
  },
  CONF_PROJECT_TYPE_antisera_REVIEW_AND_CONFIRM: {
    id: 'CONF_PROJECT_TYPE_antisera_REVIEW_AND_CONFIRM',
    defaultMessage: 'Project Type: ',
  },
  CONF_ANTISERA_NUMBER_OF_PEPTIDE: {
    id: 'CONF_ANTISERA_NUMBER_OF_PEPTIDE',
    defaultMessage: 'Number of Peptides: ',
  },
  CONF_ANTISERA_ADDITIONAL_SERVICE_COST: {
    id: 'CONF_ANTISERA_ADDITIONAL_SERVICE_COST',
    defaultMessage: 'Additional Services: ',
  },
  CONF_ANTISERA_PROJECT_COST: {
    id: 'CONF_ANTISERA_PROJECT_COST',
    defaultMessage: 'Project Cost:',
  },
  CONF_ANTISERA_ELISA_COST: {
    id: 'CONF_ANTISERA_ELISA_COST',
    defaultMessage: 'ELISA Fee:',
  },
  CONF_ANTISERA_COLUMN_CONSTRUCTION_COST: {
    id: 'CONF_ANTISERA_COLUMN_CONSTRUCTION_COST',
    defaultMessage: 'Column Construction Fee:',
  },
  CONF_ANTISERA_REFINING_COST: {
    id: 'CONF_ANTISERA_REFINING_COST',
    defaultMessage: 'Refining Fee',
  },
  CONF_ANTISERA_ABSORPTION_COST: {
    id: 'CONF_ANTISERA_ABSORPTION_COST',
    defaultMessage: 'Absorption Fee',
  },
  CONF_ANTISERA_PROJECT_SUBTOTAL_COST: {
    id: 'CONF_ANTISERA_PROJECT_SUBTOTAL_COST',
    defaultMessage: 'Project Subtotal:',
  },
  CONF_CONFIRM_ORDER_ANTISERA: {
    id: 'CONF_CONFIRM_ORDER_ANTISERA',
    defaultMessage: 'Review & Order',
  },
  CONF_ADD_PROJECT: { id: 'CONF_ADD_PROJECT', defaultMessage: 'Add Project' },
  CONF_EMAIL_CART_ERROR: {
    id: 'CONF_EMAIL_CART_ERROR',
    defaultMessage: 'Failed to Mail',
  },
  CONF_ANTISERA_AKNOWLEDGMENT: {
    id: 'CONF_ANTISERA_AKNOWLEDGMENT',
    defaultMessage:
      'Acknowledgment: I understand that custom-made products are non-returnable and non-refundable.',
  },
  CONF_ANTISERA_ADD_QUOTE_NOTE: {
    id: 'CONF_ANTISERA_ADD_QUOTE_NOTE',
    defaultMessage: 'Add Quote Note',
  },
  CONF_HOME_ANTISERA: { id: 'CONF_HOME_ANTISERA', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_ANTISERA: {
    id: 'CONF_CUSTOM_PRODUCTS_ANTISERA',
    defaultMessage: customProductsStr,
  },
  CONF_OLIGOS_PROBES_ANTISERA: {
    id: 'CONF_OLIGOS_PROBES_ANTISERA',
    defaultMessage: 'Peptides',
  },
  CONF_ANTISERA: { id: 'CONF_ANTISERA', defaultMessage: 'Antisera' },
  PC_LEFT_NAV_ENTRY_ANTISERA: {
    id: 'PC_LEFT_NAV_ENTRY_ANTISERA',
    defaultMessage: 'Project Specifications',
  },
  _PC_SH_MAIN_HEADER_ANTISERA: {
    id: '_PC_SH_MAIN_HEADER_ANTISERA',
    defaultMessage: 'Antisera',
  },
  CONF_ANTISERA_QUANTITY_ERROR_TEXT: {
    id: 'CONF_ANTISERA_QUANTITY_ERROR_TEXT',
    defaultMessage: 'Please enter the number from 1 to 5',
  },
  CONF_OLIGO_ERROR_POPUP_MSG: {
    id: 'CONF_OLIGO_ERROR_POPUP_MSG',
    defaultMessage: 'Please correct error(s) before adding a new item.',
  },
  CONF_PEPTIDE_1_ANTISERA: {
    id: 'CONF_PEPTIDE_1_ANTISERA',
    defaultMessage: 'Peptide 1',
  },
  CONF_ANTISERA_FOR_COLUMN_PREPARATION_ANTISERA: {
    id: 'CONF_ANTISERA_FOR_COLUMN_PREPARATION_ANTISERA',
    defaultMessage: 'Antigen for Column {columnCount} Preparation',
  },
  CONF_ANTISERA_PROJECT_NAME: {
    id: 'CONF_ANTISERA_PROJECT_NAME',
    defaultMessage: 'Project Name',
  },
  CONF_MAX_PROJECT_NAME_LENGTH_30_antisera: {
    id: 'CONF_MAX_PROJECT_NAME_LENGTH_30_antisera',
    defaultMessage: 'Maximum project name length is ',
  },
  CONF_PROJECT_NAME_INFO_ANTISERA: {
    id: 'CONF_PROJECT_NAME_INFO_ANTISERA',
    defaultMessage: 'Character limit is 30 including spaces.',
  },
  CONF_SELECT_PEPTIDE_ANTISERA: {
    id: 'CONF_SELECT_PEPTIDE_ANTISERA',
    defaultMessage: 'Select Peptide',
  },
  CONF_ANIMAL_TYPE_ANTISERA: {
    id: 'CONF_ANIMAL_TYPE_ANTISERA',
    defaultMessage: 'Animal Type',
  },
  CONF_NUMBER_OF_ANIMALS_ANTISERA: {
    id: 'CONF_NUMBER_OF_ANIMALS_ANTISERA',
    defaultMessage: 'Number of Animals',
  },
  CONF_ANIMAL_IMMUNIZATION_PERIOD_ANTISERA: {
    id: 'CONF_ANIMAL_IMMUNIZATION_PERIOD_ANTISERA',
    defaultMessage: 'Immunization Period',
  },
  CONF_OPTIONAL_SERVICES_ANTISERA: {
    id: 'CONF_OPTIONAL_SERVICES_ANTISERA',
    defaultMessage: 'Optional Services',
  },
  CONF_APPLIES_TO_ALL_SERVICES_ANTISERA: {
    id: 'CONF_APPLIES_TO_ALL_SERVICES_ANTISERA',
    defaultMessage: 'Applies To All',
  },
  CONF_ELISA_ANALYSIS_ANTISERA: {
    id: 'CONF_ELISA_ANALYSIS_ANTISERA',
    defaultMessage: 'ELISA Analysis',
  },
  CONF_ADDITIONAL_FEES_APPLY_ANTISERA: {
    id: 'CONF_ADDITIONAL_FEES_APPLY_ANTISERA',
    defaultMessage: 'Additional Fees may Apply',
  },
  CONF_COLUMN_CONSTRUCTION_ANTISERA: {
    id: 'CONF_COLUMN_CONSTRUCTION_ANTISERA',
    defaultMessage: 'Column Construction',
  },
  CONF_NUMBER_OF_COLUMNS_ANTISERA: {
    id: 'CONF_NUMBER_OF_COLUMNS_ANTISERA',
    defaultMessage: 'Number of Columns',
  },
  CONF_PURIFICATION_TYPE_ANTISERA: {
    id: 'CONF_PURIFICATION_TYPE_ANTISERA',
    defaultMessage: 'Purification Type',
  },
  CONF_NUMBER_OF_PURIFICATION_ANTISERA: {
    id: 'CONF_NUMBER_OF_PURIFICATION_ANTISERA',
    defaultMessage: 'Number of Purification',
  },
  CONF_COLUMN_USED_FOR_PURIFICATION_ANTISERA: {
    id: 'CONF_COLUMN_USED_FOR_PURIFICATION_ANTISERA',
    defaultMessage: 'Column Used For Purification',
  },
  ABSORPTION: { id: 'ABSORPTION', defaultMessage: 'Absorption' },
  CONF_ANTISERA_ABSORPTION_TYPE: {
    id: 'CONF_ANTISERA_ABSORPTION_TYPE',
    defaultMessage: 'Absorption type',
  },
  CONF_NUMBER_OF_ABSORPTION_ANTISERA: {
    id: 'CONF_NUMBER_OF_ABSORPTION_ANTISERA',
    defaultMessage: 'Number of Absorption',
  },
  CONF_COLUMN_USED_FOR_ABSORPTION_ANTISERA: {
    id: 'CONF_COLUMN_USED_FOR_ABSORPTION_ANTISERA',
    defaultMessage: 'Column Used For Absorption',
  },
  CONF_COMPANY_INSTITUTION_ANTISERA: {
    id: 'CONF_COMPANY_INSTITUTION_ANTISERA',
    defaultMessage: 'Company/Institution Name',
  },
  EMAIL: { id: 'EMAIL', defaultMessage: 'Email' },
  EMAIL_ADDRESS: { id: 'EMAIL_ADDRESS', defaultMessage: 'Email Address' },
  FULL_NAME: { id: 'FULL_NAME', defaultMessage: 'Full Name' },
  CONF_EMAIL_VALIDATION_ANTISERA: {
    id: 'CONF_EMAIL_VALIDATION_ANTISERA',
    defaultMessage: 'Invalid Email',
  },
  PHONE_NUMBER: { id: 'PHONE_NUMBER', defaultMessage: 'Phone Number' },
  CONF_PHONE_NUMBER_VALIDATION_ANTISERA: {
    id: 'CONF_PHONE_NUMBER_VALIDATION_ANTISERA',
    defaultMessage: 'Invalid Phone Number',
  },
  CONF_AQUA_CONTINUE_BUTTON: {
    id: 'CONF_AQUA_CONTINUE_BUTTON',
    defaultMessage: 'Continue',
  },
  CONF_PEPTIDE_NO_antisera: {
    id: 'CONF_PEPTIDE_NO_antisera',
    defaultMessage: 'Peptide No.{peptideNo}',
  },
  _PC_PEP_NAME_NOTE_antisera: {
    id: '_PC_PEP_NAME_NOTE_antisera',
    defaultMessage:
      'Character limit is 20 including spaces. Do not use ASCII characters.',
  },
  _PC_SPEC_PURITY_LEVEL: {
    id: '_PC_SPEC_PURITY_LEVEL',
    defaultMessage: 'Purity Level ',
  },
  _PC_N_TERMMOD_antisera: {
    id: '_PC_N_TERMMOD_antisera',
    defaultMessage: 'N-Terminal Modification',
  },
  _PC_PEP_SEQ_antisera: {
    id: '_PC_PEP_SEQ_antisera',
    defaultMessage: 'Sequence (N to C)',
  },
  _PC_PEP_AMINOACID_antisera: {
    id: '_PC_PEP_AMINOACID_antisera',
    defaultMessage: '# Amino Acids: ',
  },
  _PC_PEP_CTERM_MOD_antisera: {
    id: '_PC_PEP_CTERM_MOD_antisera',
    defaultMessage: 'C-Terminal Modification',
  },
  _PC_PEP_ADD_INTMOD_antisera: {
    id: '_PC_PEP_ADD_INTMOD_antisera',
    defaultMessage: 'Add Internal Modification',
  },
  _PC_SEQUENCE_PREVIEW: {
    id: '_PC_SEQUENCE_PREVIEW',
    defaultMessage: 'Sequence Preview',
  },
  PC_CONJUGATION: { id: 'PC_CONJUGATION', defaultMessage: 'Conjugation' },
  _PC_carrierProtein: {
    id: '_PC_carrierProtein',
    defaultMessage: 'Carrier Protein',
  },
  _PC_ADDSPEC_antisera: {
    id: '_PC_ADDSPEC_antisera',
    defaultMessage: 'Additional Specifications',
  },
  CONF_ADDITIONAL_SPEICIFCATION_SPECIAL_CHARACTER_MASSAGE: {
    id: 'CONF_ADDITIONAL_SPEICIFCATION_SPECIAL_CHARACTER_MASSAGE',
    defaultMessage: 'Additional Specification contains invalid character(s):',
  },
  _PC_SPEC_antisera: {
    id: '_PC_SPEC_antisera',
    defaultMessage: 'Specifications',
  },
  CONF_ANTISERA_ADD_PEPTIDE: {
    id: 'CONF_ANTISERA_ADD_PEPTIDE',
    defaultMessage: 'Add a Peptide',
  },
  CONF_ADD_PEPTIDE: { id: 'CONF_ADD_PEPTIDE', defaultMessage: 'Add Peptide' },
  _PC_PROJECT_TYPE_antisera: {
    id: '_PC_PROJECT_TYPE_antisera',
    defaultMessage: 'Project Type',
  },
  CONF_ANTISERA_VIEWING: {
    id: 'CONF_ANTISERA_VIEWING',
    defaultMessage: 'Viewing {index} of {count}',
  },
  CONF_HOME_SIMPLE_ANTISERA: {
    id: 'CONF_HOME_SIMPLE_ANTISERA',
    defaultMessage: 'Home',
  },
  CONF_CUSTOM_PRODUCTS_SIMPLE_ANTISERA: {
    id: 'CONF_CUSTOM_PRODUCTS_SIMPLE_ANTISERA',
    defaultMessage: customProductsStr,
  },
  CONF_OLIGOS_PROBES_SIMPLE_ANTISERA: {
    id: 'CONF_OLIGOS_PROBES_SIMPLE_ANTISERA',
    defaultMessage: 'Peptides',
  },
  CONF_SIMPLE_ANTISERA: {
    id: 'CONF_SIMPLE_ANTISERA',
    defaultMessage: 'Simple Antisera',
  },
  PC_LEFT_NAV_ENTRY_SIMPLE_ANTISERA: {
    id: 'PC_LEFT_NAV_ENTRY_SIMPLE_ANTISERA',
    defaultMessage: 'Project Specifications',
  },
  CONF_CONFIRM_ORDER_SIMPLE_ANTISERA: {
    id: 'CONF_CONFIRM_ORDER_SIMPLE_ANTISERA',
    defaultMessage: 'Review & Order',
  },
  _PC_SH_MAIN_HEADER_SIMPLE_ANTISERA: {
    id: '_PC_SH_MAIN_HEADER_SIMPLE_ANTISERA',
    defaultMessage: 'Simple Antisera',
  },
  CONF_PURIFICATION_FEE_DNA_PLATES: {
    id: 'CONF_PURIFICATION_FEE_DNA_PLATES',
    defaultMessage: 'Purification Fee:',
  },
  CONF_ANIMAL_TYPE_simpleantisera: {
    id: 'CONF_ANIMAL_TYPE_simpleantisera',
    defaultMessage: 'Animal Type : ',
  },
  CONF_NUMBER_OF_ANIMALS_simpleantisera: {
    id: 'CONF_NUMBER_OF_ANIMALS_simpleantisera',
    defaultMessage: 'Number of Animals : ',
  },
  CONF_ANIMAL_IMMUNIZATION_TERM_simpleantisera: {
    id: 'CONF_ANIMAL_IMMUNIZATION_PERIOD_simpleantisera',
    defaultMessage: 'Immunization Term : ',
  },
  CONF_NUMBER_OF_COLUMNS_simpleantisera: {
    id: 'CONF_NUMBER_OF_COLUMNS_simpleantisera',
    defaultMessage: 'Number of Columns :',
  },
  PC_SPEC_ANTIGEN_COLUMN: {
    id: 'PC_SPEC_ANTIGEN_COLUMN',
    defaultMessage: 'Antigen for Column 1 Preparation',
  },
  CONF_COLUMN_USED_FOR_PURIFICATION_simpleantisera: {
    id: 'CONF_COLUMN_USED_FOR_PURIFICATION_simpleantisera',
    defaultMessage: 'Column Used For Purification : ',
  },
  CONF_ANTISERA_PEPTIDE_NO: {
    id: 'CONF_ANTISERA_PEPTIDE_NO',
    defaultMessage: 'Peptide No.1',
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_aqua: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_aqua',
    defaultMessage: 'Maximum Peptide name length is ',
  },
  _PC_PEP_NTERM_MOD_simpleantisera: {
    id: '_PC_PEP_NTERM_MOD_simpleantisera',
    defaultMessage: 'N-Terminal Modification',
  },
  CONF_SEQUENCE_LABEL_simpleantisera: {
    id: 'CONF_SEQUENCE_LABEL_simpleantisera',
    defaultMessage: 'Sequence (N to C)',
  },
  _PC_PEP_AMINOACID_simpleantisera: {
    id: '_PC_PEP_AMINOACID_simpleantisera',
    defaultMessage: '# Amino Acid',
  },
  _PC_PEP_CTERM_MOD_simpleantisera: {
    id: '_PC_PEP_CTERM_MOD_simpleantisera',
    defaultMessage: 'C-Terminal Modification',
  },
  CONF_DELETE_ALL_ITEM_DNA_PLATES: {
    id: 'CONF_DELETE_ALL_ITEM_DNA_PLATES',
    defaultMessage: 'Delete All',
  },
  CONF_DELETE_ALL_ITEM_MSG_DNA_PLATES: {
    id: 'CONF_DELETE_ALL_ITEM_MSG_DNA_PLATES',
    defaultMessage:
      'Are you sure you want to remove ALL items from your order?',
  },
  CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES: {
    id: 'CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES',
    defaultMessage: 'Delete All',
  },
  CONF_DELETE_ITEM_DNA_PLATES: {
    id: 'CONF_DELETE_ITEM_DNA_PLATES',
    defaultMessage: 'Delete  Item Confirmation',
  },
  CONF_DELETE_ITEM_MSG_DNA_PLATES: {
    id: 'CONF_DELETE_ITEM_MSG_DNA_PLATES',
    defaultMessage:
      'Are you sure you want to remove the selected item from your order?',
  },
  CONF_DELETE_BUTTON_TEXT_DNA_PLATES: {
    id: 'CONF_DELETE_BUTTON_TEXT_DNA_PLATES',
    defaultMessage: 'Delete',
  },
  PC_START_OVER_milliplex: {
    id: 'PC_START_OVER_milliplex',
    defaultMessage: 'Start Over',
  },
  PC_START_OVER_MSG_milliplex: {
    id: 'PC_START_OVER_MSG_milliplex',
    defaultMessage:
      'Are you sure you want to remove all selections and start over?',
  },
  CONF_MY_SIMPLE_ANTISERA_PROJECTS: {
    id: 'CONF_MY_SIMPLE_ANTISERA_PROJECTS',
    defaultMessage: 'My Simple Antisera Projects',
  },
  CONF_MY_ANTISERA_PROJECTS: {
    id: 'CONF_MY_ANTISERA_PROJECTS',
    defaultMessage: 'My Antisera Projects',
  },
  CONF_NO_OF_ADDITIONAL_SERVICES: {
    id: 'CONF_NO_OF_ADDITIONAL_SERVICES',
    defaultMessage: 'Number of Additional Service(s)',
  },
  CONF_ANTISERA_NO_OF_PEPTIDE_TITLE: {
    id: 'CONF_ANTISERA_NO_OF_PEPTIDE_TITLE',
    defaultMessage: 'No of Peptides',
  },
  CONF_ORDER_INSTRUCTION: {
    id: 'CONF_ORDER_INSTRUCTION',
    defaultMessage: 'Order Instructions / Specifications',
  },
  CONF_ADD_COMMENT_ACK_TEXT: {
    id: 'CONF_ADD_COMMENT_ACK_TEXT',
    defaultMessage:
      'I acknowledge adding comments will slow the order processing.',
  },
  CONF_ADD_OLIGOS: { id: 'CONF_ADD_OLIGOS', defaultMessage: 'Add Oligos' },
  CONF_NGSO_APPLICATIONFREIGHT_TAX: {
    id: 'CONF_NGSO_APPLICATIONFREIGHT_TAX',
    defaultMessage:
      'Applicable freight, taxes & fees will be applied during checkout',
  },
  PREVIOUS_STEP: { id: 'PREVIOUS_STEP', defaultMessage: 'Previous Step' },
  ORDER_DETAILS: { id: 'ORDER_DETAILS', defaultMessage: 'Order Details' },
  CONF_FORMAT: { id: 'CONF_FORMAT', defaultMessage: 'Format' },
  _PC_SPEC_CONCENTRATION: {
    id: '_PC_SPEC_CONCENTRATION',
    defaultMessage: 'Concentration',
  },
  CONF_NGSO_OLIGO_LABEL: {
    id: 'CONF_NGSO_OLIGO_LABEL',
    defaultMessage: oligoNameStr,
  },
  CONF_SCALE_TEXT: { id: 'CONF_SCALE_TEXT', defaultMessage: 'scale' },
  CONF_OPTIONS_TEXT: { id: 'CONF_OPTIONS_TEXT', defaultMessage: 'options' },
  PRICE: { id: 'PRICE', defaultMessage: 'Price' },
  CONF_DNAPLATES_SCALE_MEASURE: {
    id: 'CONF_DNAPLATES_SCALE_MEASURE',
    defaultMessage: ' µmole',
  },
  QUOTE_ITEM: { id: 'QUOTE_ITEM', defaultMessage: 'Quote Item' },
  CONF_NGSO_EDIT_OLIGO_NAME: {
    id: 'CONF_NGSO_EDIT_OLIGO_NAME',
    defaultMessage: 'Edit Oligo Name',
  },
  CONF_OLIGO_NAME_NGSO: {
    id: 'CONF_OLIGO_NAME_NGSO',
    defaultMessage: oligoNameStr,
  },
  CONF_NGSO_WELL_ID: { id: 'CONF_NGSO_WELL_ID', defaultMessage: 'Well ID' },
  CONF_NGSO_PLATE_PRICE: {
    id: 'CONF_NGSO_PLATE_PRICE',
    defaultMessage: 'Plate Price:',
  },
  EDIT_PLATE_NAME: { id: 'EDIT_PLATE_NAME', defaultMessage: 'Edit Plate Name' },
  PLATE_NAME: { id: 'PLATE_NAME', defaultMessage: 'Plate Name' },
  SELECT: { id: 'SELECT', defaultMessage: 'Select' },
  SAVE: { id: 'SAVE', defaultMessage: 'Save' },
  CONF_DNAPLATES_ERROR_CONCENTRATION: {
    id: 'CONF_DNAPLATES_ERROR_CONCENTRATION',
    defaultMessage: 'Enter valid concentration.',
  },
  CONF_NGSO_GOLD_CONCENTRATION_POPUP_TITLE: {
    id: 'CONF_NGSO_GOLD_CONCENTRATION_POPUP_TITLE',
    defaultMessage: 'NGSO Gold Concentration',
  },
  CONF_NGSO_GOLD_CONCENTRATION_FIELD_HEADING: {
    id: 'CONF_NGSO_GOLD_CONCENTRATION_FIELD_HEADING',
    defaultMessage: 'Concentration (µM)',
  },
  CONF_NGSO_GOLD_CONCENTRATION_FIELD_HELP_TEXT: {
    id: 'CONF_NGSO_GOLD_CONCENTRATION_FIELD_HELP_TEXT',
    defaultMessage: 'Valid Length: 1 to 1000',
  },
  SUBMIT: { id: 'SUBMIT', defaultMessage: 'Submit' },
  CONFIRM_ORDER: { id: 'CONFIRM_ORDER', defaultMessage: 'Confirm Order' },
  CONF_NGSO_ADDITIONAL_SERVICES: {
    id: 'CONF_NGSO_ADDITIONAL_SERVICES',
    defaultMessage: 'Additional Services',
  },
  CONF_NGSO_ADDITIONAL_SERVICES_SUBTEXT: {
    id: 'CONF_NGSO_ADDITIONAL_SERVICES_SUBTEXT',
    defaultMessage:
      'Requesting these services requires your order to go to quotation.',
  },
  CONF_NGSO_ADDITIONAL_SERVICES_ANNEALING: {
    id: 'CONF_NGSO_ADDITIONAL_SERVICES_ANNEALING',
    defaultMessage: 'Annealing',
  },
  CONF_NGSO_ADDITIONAL_SERVICES_ANNEALING_POOLING: {
    id: 'CONF_NGSO_ADDITIONAL_SERVICES_ANNEALING_POOLING',
    defaultMessage: 'Annealing & Pooling',
  },
  CONF_NGSO_ADDITIONAL_SERVICES_ANNEALING_QC: {
    id: 'CONF_NGSO_ADDITIONAL_SERVICES_ANNEALING_QC',
    defaultMessage: 'Annealing QC',
  },
  CONF_NGSO_CERTIFICATE_OF_ANALYSIS: {
    id: 'CONF_NGSO_CERTIFICATE_OF_ANALYSIS',
    defaultMessage: 'Custom Certificate of Analysis',
  },
  CONF_NGSO_ANALYTICAL_HPLC: {
    id: 'CONF_NGSO_ANALYTICAL_HPLC',
    defaultMessage: 'Analytical HPLC',
  },
  CONF_NGSO_STEPS: { id: 'CONF_NGSO_STEPS', defaultMessage: 'Step {stepNo}' },
  CONF_HOME_ngso: { id: 'CONF_HOME_ngso', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_ngso: {
    id: 'CONF_CUSTOM_PRODUCTS_ngso',
    defaultMessage: customProductsStr,
  },
  CONF_OLIGOS_PROBES_ngso: {
    id: 'CONF_OLIGOS_PROBES_ngso',
    defaultMessage: oligosStr,
  },
  CONF_NGSO_ENTRY_METHOD: {
    id: 'CONF_NGSO_ENTRY_METHOD',
    defaultMessage: 'Entry Method',
  },
  CONF_NGSO_CONFIRM_ORDER: {
    id: 'CONF_NGSO_CONFIRM_ORDER',
    defaultMessage: 'Confirm Order',
  },
  CONF_NGSO_DOWNLOAD_TUBE_TEMPLATE: {
    id: 'CONF_NGSO_DOWNLOAD_TUBE_TEMPLATE',
    defaultMessage: 'Download Tube Template',
  },
  CONF_NGSO_DOWNLOAD_PLATE_TEMPLATE: {
    id: 'CONF_NGSO_DOWNLOAD_PLATE_TEMPLATE',
    defaultMessage: 'Download Plate Template',
  },
  CONF_CAUTION_HEADING: {
    id: 'CONF_CAUTION_HEADING',
    defaultMessage: 'Caution',
  },
  CONF_CAUTION_POPUP_TEXT_TUBES: {
    id: 'CONF_CAUTION_POPUP_TEXT_TUBES',
    defaultMessage:
      'Adding a new set of items will override any existing items in this session.',
  },
  SELECT_AN_ENTRY_METHOD: {
    id: 'SELECT_AN_ENTRY_METHOD',
    defaultMessage: 'SELECT AN ENTRY METHOD',
  },
  CONF_NGSO_TUBE: { id: 'CONF_NGSO_TUBE', defaultMessage: 'Tube' },
  CONF_NGSO_PLATE: { id: 'CONF_NGSO_PLATE', defaultMessage: 'Plate' },
  CONF_NGSO_FILE_UPLOAD_VALIDATION_ERROR: {
    id: 'CONF_NGSO_FILE_UPLOAD_VALIDATION_ERROR',
    defaultMessage:
      'Invalid entry: only one selection for scale and format is allowed. The selections made for the first oligo will be applied to all.',
  },
  CONF_NGSO_FILE_UPLOAD: {
    id: 'CONF_NGSO_FILE_UPLOAD',
    defaultMessage: 'File Upload',
  },
  CONF_NGSO_COPY_PASTE: {
    id: 'CONF_NGSO_COPY_PASTE',
    defaultMessage: 'Copy & Paste',
  },
  CONF_NGSO_FILE_UPLOAD_HEADING_TEXT: {
    id: 'CONF_NGSO_FILE_UPLOAD_HEADING_TEXT',
    defaultMessage:
      'To upload multiple sequences, download the template, enter the oligo sequence information and save as .xls or .xlsx file.',
  },
  CONF_NGSO_COPY_PASTE_HEADING_TEXT: {
    id: 'CONF_NGSO_COPY_PASTE_HEADING_TEXT',
    defaultMessage:
      'Copy and paste sequence information using the example format below. One sequence per line, comma delimited, with no spaces.',
  },
  CONF_CHINA_OLIGO_NAME_MAX_LENGTH: {
    id: 'CONF_CHINA_OLIGO_NAME_MAX_LENGTH',
    defaultMessage: '30',
  },
  CONF_OLIGO_NAME_MAX_LENGTH_MASSAGE: {
    id: 'CONF_OLIGO_NAME_MAX_LENGTH_MASSAGE',
    defaultMessage: maxStr,
  },
  CONF_ANTISENSE_SEQ_KEY: {
    id: 'CONF_ANTISENSE_SEQ_KEY',
    defaultMessage: 'antisencesequence',
  },
  CONF_ANTISENSE_NAME_KEY: {
    id: 'CONF_ANTISENSE_NAME_KEY',
    defaultMessage: 'antisenceName',
  },
  CONF_MAX_ITEMS_ALLOWED: {
    id: 'CONF_MAX_ITEMS_ALLOWED',
    defaultMessage: 'Maximum number of items per session is {maxItems}.',
  },
  CONF_ADD_OLIGO_SIDE_BAR: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR',
    defaultMessage: 'Add Oligo ',
  },
  CONF_ADD_DUPLEX_SIDE_BAR: {
    id: 'CONF_ADD_DUPLEX_SIDE_BAR',
    defaultMessage: 'Add Duplex ',
  },
  REVIEW_PAGE_ERROR_HEADER_MESSAGE: {
    id: 'REVIEW_PAGE_ERROR_HEADER_MESSAGE',
    defaultMessage:
      'Click on the link for the Item Name to correct the error(s) and proceed to the next step.',
  },
  CONF_VIEWALL_AMOUNT: { id: 'CONF_VIEWALL_AMOUNT', defaultMessage: 'Amount' },
  CONF_VIEWALL_TUBES: { id: 'CONF_VIEWALL_TUBES', defaultMessage: 'Tubes' },
  CONF_TOTAL_DUPLEX_COUNT: {
    id: 'CONF_TOTAL_DUPLEX_COUNT',
    defaultMessage: 'Total Duplex(es): ',
  },
  CONF_TOTAL_OLIGO_COUNT: {
    id: 'CONF_TOTAL_OLIGO_COUNT',
    defaultMessage: 'Total Oligo(s): ',
  },
  CONF_TOTAL_BASES: { id: 'CONF_TOTAL_BASES', defaultMessage: 'Total Bases: ' },
  CONF_ANTISENSE_SEQUENCE: {
    id: 'CONF_ANTISENSE_SEQUENCE',
    defaultMessage: 'Antisense Sequence',
  },
  CONF_SENSE_SEQUENCE: {
    id: 'CONF_SENSE_SEQUENCE',
    defaultMessage: 'Sense Sequence',
  },
  CONF_DONOR_lightcycler_sequence: {
    id: 'CONF_DONOR_lightcycler_sequence',
    defaultMessage: 'Donor Sequence',
  },
  CONF_PURIFICATION_REVIEW_AND_CONFIRM: {
    id: 'CONF_PURIFICATION_REVIEW_AND_CONFIRM',
    defaultMessage: 'Purification:',
  },
  CONF_FORMAT_REVIEW_AND_CONFIRM: {
    id: 'CONF_FORMAT_REVIEW_AND_CONFIRM',
    defaultMessage: 'Format:',
  },
  CONF_TUBES: { id: 'CONF_TUBES', defaultMessage: 'Tubes:' },
  CONF_ACCEPTOR_lightcycler_sequence: {
    id: 'CONF_ACCEPTOR_lightcycler_sequence',
    defaultMessage: 'Acceptor Sequence',
  },
  SHIPPING: { id: 'SHIPPING', defaultMessage: 'Shipping' },
  CONF_5_MOD_standard: {
    id: 'CONF_5_MOD_standard',
    defaultMessage: "5' Modifications",
  },
  CONF_OVERHANG_LABEL: {
    id: 'CONF_OVERHANG_LABEL',
    defaultMessage: 'Overhang',
  },
  CONF_3_MOD_standard: {
    id: 'CONF_3_MOD_standard',
    defaultMessage: "3' Modifications",
  },
  CONF_FASTDUPLEX_SEQ_INFO: {
    id: 'CONF_FASTDUPLEX_SEQ_INFO',
    defaultMessage:
      'RNA bases only: A,C,G,U. T bases will be converted to U bases.',
  },
  CONF_DUPLEX_ANTISENSE_STRAD: {
    id: 'CONF_DUPLEX_ANTISENSE_STRAD',
    defaultMessage: 'Antisense Strand',
  },
  CONF_AUTOGEN_NAME: {
    id: 'CONF_AUTOGEN_NAME',
    defaultMessage: 'Use Sense Name',
  },
  CONF_AUTOGEN_SEQUENCE: {
    id: 'CONF_AUTOGEN_SEQUENCE',
    defaultMessage: 'Auto-Generate Antisense Oligo',
  },
  CONF_ANTISENSE_NAME: {
    id: 'CONF_ANTISENSE_NAME',
    defaultMessage: 'Antisense Strand Name',
  },
  CONF_COPY_PASTE_TOOLTIP_MIRNA: {
    id: 'CONF_COPY_PASTE_TOOLTIP_MIRNA',
    defaultMessage:
      "Download the Multiple Entry Template to view formatting requirements or type sequence information using the example format below. One record per line, comma or tab delimited. Do not include column headers.Comma-delimited example: Oligo Name(Antisense), Sequence(Antisense), 3' Mod(Antisense), Oligo Name(Sense), 5' Mod(Sense), 3' Mod(Sense), Yield, Purification, Number of tubes.",
  },
  CONF_COPY_PASTE_TOOLTIP_FASTDUPLEX: {
    id: 'CONF_COPY_PASTE_TOOLTIP_FASTDUPLEX',
    defaultMessage:
      'Download the Multiple Entry Template to view formatting requirements or type sequence information using the example format below. One record per line, comma or tab delimited. Do not include column headers.Comma delimited example:Oligo Name (Sense), Sequence (Sense), Overhang (Sense), Oligo Name (Antisense), Sequence (Antisense), Overhang (Antisense), Amount',
  },
  CONF_PASTE_ENTRIES_HERE_EDIT: {
    id: 'CONF_PASTE_ENTRIES_HERE_EDIT',
    defaultMessage: 'Paste entries here and edit ',
  },
  CONF_MIRNA_NAME_MAX_LENGTH: {
    id: 'CONF_MIRNA_NAME_MAX_LENGTH',
    defaultMessage: '28',
  },
  CONF_SEQUENCE_INFORMATION: {
    id: 'CONF_SEQUENCE_INFORMATION',
    defaultMessage: sequenceInfoStr,
  },
  CONF_TOOLTIP_MIRNA_ANTISENCE: {
    id: 'CONF_TOOLTIP_MIRNA_ANTISENCE',
    defaultMessage:
      'Maximum character limit for technical datasheet is 28. Character size varies and the product name prefix on the tube label may be truncated if longer than 18 characters.',
  },
  CONF_DUPLEX_NAME_MAX_LENGTH: {
    id: 'CONF_DUPLEX_NAME_MAX_LENGTH',
    defaultMessage: '27',
  },
  CONF_DUPLEX_SENSE_STRAD: {
    id: 'CONF_DUPLEX_SENSE_STRAD',
    defaultMessage: 'Sense Strand',
  },
  CONF_SENSE_NAME: {
    id: 'CONF_SENSE_NAME',
    defaultMessage: 'Sense Strand Name',
  },
  CONF_CONCENTRATION_TEXT: {
    id: 'CONF_CONCENTRATION_TEXT',
    defaultMessage: 'concentration',
  },
  CONF_NO_OF_TUBES: {
    id: 'CONF_NO_OF_TUBES',
    defaultMessage: 'Number of Tubes',
  },
  CONF_NO_TUBES_POPUP_MSG: {
    id: 'CONF_NO_TUBES_POPUP_MSG',
    defaultMessage:
      'Amount will be split equally between number of tubes specified. Additional fees may apply.',
  },
  CONF_APPLY_TO_ALL: {
    id: 'CONF_APPLY_TO_ALL',
    defaultMessage: 'Apply to All ',
  },
  CONF_SEQUENCE_PROPERTIES_INFO_TEXT: {
    id: 'CONF_SEQUENCE_PROPERTIES_INFO_TEXT',
    defaultMessage: 'Data download available on Review & Confirm step',
  },
  CONF_MIRNA_AANTISENCE_PROPERTIES: {
    id: 'CONF_MIRNA_AANTISENCE_PROPERTIES',
    defaultMessage: "Antisense (5' to 3'):",
  },
  CONF_MIRNA_SENCE_PROPERTIES: {
    id: 'CONF_MIRNA_SENCE_PROPERTIES',
    defaultMessage: "Sense (3' to 5'):",
  },
  CONF_SENSE_PROP: { id: 'CONF_SENSE_PROP', defaultMessage: 'Sense:' },
  CONF_ANTISENSE_PROP: {
    id: 'CONF_ANTISENSE_PROP',
    defaultMessage: 'Antisense:',
  },
  CONF_DONAR_lightcycler: {
    id: 'CONF_DONAR_lightcycler',
    defaultMessage: 'Donor:',
  },
  CONF_ACCEPTOR_lightcycler: {
    id: 'CONF_ACCEPTOR_lightcycler',
    defaultMessage: 'Acceptor:',
  },
  CONF_DUPLEX_PROP_NAME: {
    id: 'CONF_DUPLEX_PROP_NAME',
    defaultMessage: 'Sense/Antisense Name',
  },
  CONF_OLIGO_NAME_standard: {
    id: 'CONF_OLIGO_NAME_standard',
    defaultMessage: 'Oligo Name',
  },
  CONF_MOLECULAR_WEIGHT: {
    id: 'CONF_MOLECULAR_WEIGHT',
    defaultMessage: 'Molecular Weight',
  },
  CONF_SECONDARY_STRUCTURE: {
    id: 'CONF_SECONDARY_STRUCTURE',
    defaultMessage: 'Secondary Structure',
  },
  CONF_PRIMER_DIMER: {
    id: 'CONF_PRIMER_DIMER',
    defaultMessage: 'Primer Dimer',
  },
  CONF_MELTING_TEMP: {
    id: 'CONF_MELTING_TEMP',
    defaultMessage: 'Melting Temp(°C) ',
  },
  CONF_GC_CONTENT: { id: 'CONF_GC_CONTENT', defaultMessage: 'GC Content(%) ' },
  CONF_MIRNA_FIVE_MODIFICATION_HELP_TEXT: {
    id: 'CONF_MIRNA_FIVE_MODIFICATION_HELP_TEXT',
    defaultMessage:
      "The 5' end of the sense strand must have a modification.  We recommend Amino-Modifier-C6 [AmC6] as this modification has been shown to help facilitate proper loading of the antisense (guide) strand into RISC.",
  },
  CONF_MIRNA_USE_ANTISENCE_NAME: {
    id: 'CONF_MIRNA_USE_ANTISENCE_NAME',
    defaultMessage: 'Use Antisense Name',
  },
  CONF_REVIEW_ERROR: { id: 'CONF_REVIEW_ERROR', defaultMessage: 'reviewError' },
  CONF_MULTIPLE_ENTRY_STEP_1: {
    id: 'CONF_MULTIPLE_ENTRY_STEP_1',
    defaultMessage: 'Download the Multiple Entry Template',
  },
  CONF_MULTIPLE_ENTRY_TEMPLATE: {
    id: 'CONF_MULTIPLE_ENTRY_TEMPLATE',
    defaultMessage: 'Multiple Entry Template ',
  },
  CONF_OR: { id: 'CONF_OR', defaultMessage: 'Or ' },
  CONF_MY_OLIGOS_SIDE_BAR: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR',
    defaultMessage: 'My Oligos',
  },
  CONF_MY_DUPLEXES_SIDE_BAR: {
    id: 'CONF_MY_DUPLEXES_SIDE_BAR',
    defaultMessage: 'My Duplexes',
  },
  CONF_VIEW_ALL_TOTAL_OLIGOS: {
    id: 'CONF_VIEW_ALL_TOTAL_OLIGOS',
    defaultMessage: 'My Duplexes ({noOfOligos})',
  },
  CONF_MIRNA_VIEW_ALL_POPUP_SEQUENCE: {
    id: 'CONF_MIRNA_VIEW_ALL_POPUP_SEQUENCE',
    defaultMessage: "Sequence(5'-3')",
  },
  CONF_DNAPLATES_PACKING_SHIPPING: {
    id: 'CONF_DNAPLATES_PACKING_SHIPPING',
    defaultMessage: 'Packing & Shipping',
  },
  CONF_DNAPLATES_PLATE_TYPE: {
    id: 'CONF_DNAPLATES_PLATE_TYPE',
    defaultMessage: 'Plate Type',
  },
  CONF_DNAPLATES_RECOMMENDATION_TEXT: {
    id: 'CONF_DNAPLATES_RECOMMENDATION_TEXT',
    defaultMessage:
      'To receive the maximum volume per oligo, we recommend the 800µL deep well plate, or you can proceed with your selected option and receive the maximum volume the plate will allow.',
  },
  CONF_SHIPPING_OPTION_DNA_PLATES: {
    id: 'CONF_SHIPPING_OPTION_DNA_PLATES',
    defaultMessage: 'Shipping Options ',
  },
  CONF_OLIGO_MATERIAL_DNA_PLATES: {
    id: 'CONF_OLIGO_MATERIAL_DNA_PLATES',
    defaultMessage: 'Include Excess Oligo Material (Stock Plate)',
  },
  _PC_PLATE_SH_No_dnaplate: {
    id: '_PC_PLATE_SH_No_dnaplate',
    defaultMessage: 'No, do not send',
  },
  _PC_PLATE_SH_Yes_dnaplate: {
    id: '_PC_PLATE_SH_Yes_dnaplate',
    defaultMessage: 'Yes, send remaining material (Additional fees may apply)',
  },
  CONF_DNAPLATES_ERROR_AMOUNT: {
    id: 'CONF_DNAPLATES_ERROR_AMOUNT',
    defaultMessage: 'Enter valid amount.',
  },
  CONF_DNAPLATES_ERROR_VOLUME: {
    id: 'CONF_DNAPLATES_ERROR_VOLUME',
    defaultMessage: 'Enter valid volume.',
  },
  CONF_DNAPLATE_CONCENTRATION_ERROR_MESSAGE: {
    id: 'CONF_DNAPLATE_CONCENTRATION_ERROR_MESSAGE',
    defaultMessage: 'Please enter numeric values.',
  },
  CONF_DNAPLATE_OTHER: {
    id: 'CONF_DNAPLATE_OTHER',
    defaultMessage: 'In Solution (Other)',
  },
  CONF_DAUGHTER_PLATES_DNA_PLATES: {
    id: 'CONF_DAUGHTER_PLATES_DNA_PLATES',
    defaultMessage: 'Plate Copies (optional)',
  },
  CONF_DNAPLATE_PLATE_COPIES_HELPTEXT: {
    id: 'CONF_DNAPLATE_PLATE_COPIES_HELPTEXT',
    defaultMessage: 'Select the number of plate copies (Daughter Plates)',
  },
  CONF_DNAPLATES_SCALE_PNG: {
    id: 'CONF_DNAPLATES_SCALE_PNG',
    defaultMessage: '_mole.png',
  },
  CONF_DNAPLATES_SYNTHESIS_SCALE: {
    id: 'CONF_DNAPLATES_SYNTHESIS_SCALE',
    defaultMessage: 'Your Synthesis Scale: ',
  },
  CONF_DNAPLATES_MINIMUM_AMOUNT_PER_WELL: {
    id: 'CONF_DNAPLATES_MINIMUM_AMOUNT_PER_WELL',
    defaultMessage: 'Minimum Amount Per Well: ',
  },
  CONF_DNAPLATES_MINIMUM_VOLUME_PER_WELL: {
    id: 'CONF_DNAPLATES_MINIMUM_VOLUME_PER_WELL',
    defaultMessage: 'Minimum Volume Per Well: ',
  },
  CONF_DNAPLATES_AMOUNT_MOLES: {
    id: 'CONF_DNAPLATES_AMOUNT_MOLE',
    defaultMessage: '  nmoles',
  },
  CONF_DNAPLATES_VOLUME_MEASURE: {
    id: 'CONF_DNAPLATES_VOLUME_MEASURE',
    defaultMessage: ' µL',
  },
  CONF_DNAPLATES_AMOUNT_PER_WELL: {
    id: 'CONF_DNAPLATES_AMOUNT_PER_WELL',
    defaultMessage: '(Amount per well will vary)',
  },
  CONF_DNAPLATES_VOLUME_PER_WELL: {
    id: 'CONF_DNAPLATES_VOLUME_PER_WELL',
    defaultMessage: '(Volume per well will vary)',
  },
  CONF_EXPECTED_YIELDS_POPUP_SCALE: {
    id: 'CONF_EXPECTED_YIELDS_POPUP_SCALE',
    defaultMessage: 'Scale :',
  },
  CONF_DNAPLATE_SCALE_ERROR_MESSAGE: {
    id: 'CONF_DNAPLATE_SCALE_ERROR_MESSAGE',
    defaultMessage:
      'The selected configuration(s) does not allow you to select a valid scale. Please edit the entered sequence or override validations.',
  },
  CONF_DNAPLATES_VOLUME_WELL: {
    id: 'CONF_DNAPLATES_VOLUME_WELL',
    defaultMessage: 'Volume per Well (µL)',
  },
  CONF_DNAPLATE_VOLUME_MIXED_HELP_TEXT: {
    id: 'CONF_DNAPLATE_VOLUME_MIXED_HELP_TEXT',
    defaultMessage:
      'Please enter the final volume per well (µL) for your mixed oligos.  ',
  },
  CONF_DNAPLATES_VOLUME_RANGE: {
    id: 'CONF_DNAPLATES_VOLUME_RANGE',
    defaultMessage: 'Valid range: {minVolume} to ',
  },
  CONF_DNAPLATES_AMOUNT_OLIGO: {
    id: 'CONF_DNAPLATES_AMOUNT_OLIGO',
    defaultMessage: 'Amount Per Oligo (nmol)',
  },
  CONF_DNAPLATE_AMOUNT_HELPTEXT: {
    id: 'CONF_DNAPLATE_AMOUNT_HELPTEXT',
    defaultMessage:
      'Enter the final amount in nmoles for the individual oligo in the mix',
  },
  CONF_DNAPLATES_AMOUNT_RANGE: {
    id: 'CONF_DNAPLATES_AMOUNT_RANGE',
    defaultMessage: 'Valid range: 1 to  ',
  },
  CONF_DNAPLATES_FIXED_VOLUME_PER_WELL: {
    id: 'CONF_DNAPLATES_FIXED_VOLUME_PER_WELL',
    defaultMessage: 'Fixed Volume Per Well',
  },
  CONF_DNAPLATES_FIXED_WELL_YES: {
    id: 'CONF_DNAPLATES_FIXED_WELL_YES',
    defaultMessage: 'Yes, I want to specify the volume per well',
  },
  CONF_DNAPLATES_FIXED_WELL_NO: {
    id: 'CONF_DNAPLATES_FIXED_WELL_NO',
    defaultMessage: 'No, I want to specify the synthesis scale',
  },
  CONF_DNAPLATES_WELL_NORMALIZATION: {
    id: 'CONF_DNAPLATES_WELL_NORMALIZATION',
    defaultMessage: 'Well Normalization Type',
  },
  CONF_DNAPLATES_WELL_NORMALIZATION_AMOUNT: {
    id: 'CONF_DNAPLATES_WELL_NORMALIZATION_AMOUNT',
    defaultMessage: 'Amount per Well',
  },
  _PC_SPEC_SYNTHESIS_SCALE: {
    id: '_PC_SPEC_SYNTHESIS_SCALE',
    defaultMessage: 'Synthesis Scale',
  },
  CONF_DNAPLATES_CONCENTRATION: {
    id: 'CONF_DNAPLATES_CONCENTRATION',
    defaultMessage: 'Concentration (µM)',
  },
  CONF_DNAPLATE_CONCENTRATION_MIXED_HELP_TEXT_STEP1: {
    id: 'CONF_DNAPLATE_CONCENTRATION_MIXED_HELP_TEXT_STEP1',
    defaultMessage: 'Please enter the final µM concentration per oligo.',
  },
  CONF_DNAPLATE_CONCENTRATION_MIXED_HELP_TEXT_STEP2: {
    id: 'CONF_DNAPLATE_CONCENTRATION_MIXED_HELP_TEXT_STEP2',
    defaultMessage:
      '(Example: Enter 50 if you require 50µM of each oligo within the well, combined well concentration is 100µM)',
  },
  CONF_DNAPLATES_CONCENTRATION_RANGE: {
    id: 'CONF_DNAPLATES_CONCENTRATION_RANGE',
    defaultMessage: 'Valid range: 5 to ',
  },
  CONF_DNAPLATES_CONCENTRATION_MEASURE: {
    id: 'CONF_DNAPLATES_CONCENTRATION_MEASURE',
    defaultMessage: ' µM',
  },
  CONF_DNAPLATE_SPECIFICATIONS_HELP_TEXT: {
    id: 'CONF_DNAPLATE_SPECIFICATIONS_HELP_TEXT',
    defaultMessage: 'Selections will apply to all Oligos in this upload.',
  },
  CONF_FORMAT_INFO_standard: {
    id: 'FORMAT_INFO_standard',
    defaultMessage:
      'TE: 10 mM Tris, pH 7.5-8.0, 1 mM EDTA Tris: 10mM Tris-HCL, pH 8',
  },
  CONF_DNAPLATES_FORMATE_HELPTEXT: {
    id: 'CONF_DNAPLATES_FORMATE_HELPTEXT',
    defaultMessage:
      'Your oligos can be supplied dry or normalized in solution.',
  },
  CONF_DUPLEXPLATE_SPECIFICATIONS_HELP_TEXT: {
    id: 'CONF_DUPLEXPLATE_SPECIFICATIONS_HELP_TEXT',
    defaultMessage: 'Selections will apply to all Duplexes in this upload.',
  },
  PC_SPEC_DRY_duplexplate: {
    id: 'PC_SPEC_DRY_duplexplate',
    defaultMessage: 'Dry',
  },
  CONF_DNAPLATE_MINIMUM_WELLS_TEXT: {
    id: 'CONF_DNAPLATE_MINIMUM_WELLS_TEXT',
    defaultMessage: 'Minimum order size is 24 oligos.',
  },
  CONF_DNAPLATE_MINIMUM_WELLS_TEXT_JP: {
    id: 'CONF_DNAPLATE_MINIMUM_WELLS_TEXT_JP',
    defaultMessage: 'Minimum order size is 48 oligos.',
  },
  CONF_DNAPLATE_MINIMUM_WELLS_TEXT_AUSTRALIAN_COUNTRIES: {
    id: 'CONF_DNAPLATE_MINIMUM_WELLS_TEXT_AUSTRALIAN_COUNTRIES',
    defaultMessage: 'Minimum order size is 40 oligos.',
  },
  CONF_DNAPLATE_PLATE_TYPE_STNADARD: {
    id: 'CONF_DNAPLATE_PLATE_TYPE_STNADARD',
    defaultMessage: 'Standard',
  },
  CONF_DNAPLATE_PLATE_TYPE_MIXED: {
    id: 'CONF_DNAPLATE_PLATE_TYPE_MIXED',
    defaultMessage: 'Mixed',
  },
  CONF_DNAPLATES_PLATE_NAME: {
    id: 'CONF_DNAPLATES_PLATE_NAME',
    defaultMessage: 'Plate Name:',
  },
  CONF_DNAPLATES_RESEARCHER: {
    id: 'CONF_DNAPLATES_RESEARCHER',
    defaultMessage: 'Researcher:',
  },
  CONF_DNAPLATE_CONFIGURATION_WELL_TEXT: {
    id: 'CONF_DNAPLATE_CONFIGURATION_WELL_TEXT',
    defaultMessage: '{wellType}-Well ({channelType}-Channel), {plateType}',
  },
  CONF_DUPLEXPLATE_WELLSECTION_HEAD_TEXT: {
    id: 'CONF_DUPLEXPLATE_WELLSECTION_HEAD_TEXT',
    defaultMessage: 'Duplexes in ',
  },
  CONF_DUPLEXPLATE_PRODUCT_WELLSECTION_SUBHEAD_TEXT: {
    id: 'CONF_DUPLEXPLATE_PRODUCT_WELLSECTION_SUBHEAD_TEXT',
    defaultMessage:
      '(Click on the well below to view/modify individual sequences)',
  },
  CONF_DNAPLATE_WELLSECTION_HEAD_TEXT: {
    id: 'CONF_DNAPLATE_WELLSECTION_HEAD_TEXT',
    defaultMessage: 'Oligos in ',
  },
  CONF_PLATE_PRODUCT_WELLSECTION_SUBHEAD_TEXT: {
    id: 'CONF_PLATE_PRODUCT_WELLSECTION_SUBHEAD_TEXT',
    defaultMessage:
      '(Click on the well below to view/modify individual oligo sequences)',
  },
  CONF_OLIGO_NAME_PLATE_WARNING: {
    id: 'CONF_OLIGO_NAME_PLATE_WARNING',
    defaultMessage:
      'Character size varies and oligo name may be truncated on outputs if more than 18 characters.',
  },
  CONF_DNAPLATES_PLATE: { id: 'CONF_DNAPLATES_PLATE', defaultMessage: 'Plate' },
  CONF_DNAPLATES_QUADRANT: {
    id: 'CONF_DNAPLATES_QUADRANT',
    defaultMessage: 'Quadrant',
  },
  CONF_DNAPLATES_1: { id: 'CONF_DNAPLATES_1', defaultMessage: '1' },
  CONF_DNAPLATES_3: { id: 'CONF_DNAPLATES_3', defaultMessage: '3' },
  CONF_DNAPLATES_2: { id: 'CONF_DNAPLATES_2', defaultMessage: '2' },
  CONF_DNAPLATES_4: { id: 'CONF_DNAPLATES_4', defaultMessage: '4' },
  CONF_DNAPLATES_MISMATCH_SEQUENCE: {
    id: 'CONF_DNAPLATES_MISMATCH_SEQUENCE',
    defaultMessage: 'Mismatch Sequence',
  },
  CONF_DUPLEX_SENSE_OLIGO_NAME: {
    id: 'CONF_DUPLEX_SENSE_OLIGO_NAME',
    defaultMessage: 'Sense Oligo Name:',
  },
  CONF_DNAPLATE_OLIGONAME_HELPTEXT: {
    id: 'CONF_DNAPLATE_OLIGONAME_HELPTEXT',
    defaultMessage:
      'Character limit is 30 including spaces. Do not use ASCII characters.',
  },
  CONF_DUPLEX_SENSE_OLIGO_SEQUENCE: {
    id: 'CONF_DUPLEX_SENSE_OLIGO_SEQUENCE',
    defaultMessage: 'Sense Sequence:',
  },
  CONF_DUPLEX_SENSE_OLIGO_OVERHANG: {
    id: 'CONF_DUPLEX_SENSE_OLIGO_OVERHANG',
    defaultMessage: 'Sense Overhang:',
  },
  CONF_DUPLEX_ANTISENSE_OLIGO_NAME: {
    id: 'CONF_DUPLEX_ANTISENSE_OLIGO_NAME',
    defaultMessage: 'Antisense Oligo Name:',
  },
  CONF_DUPLEX_ANTISENSE_OLIGO_AUTOGENERATE: {
    id: 'CONF_DUPLEX_ANTISENSE_OLIGO_AUTOGENERATE',
    defaultMessage: 'Auto Generate Antisense Oligo',
  },
  CONF_DUPLEX_ANTISENSE_OLIGO_SEQUENCE: {
    id: 'CONF_DUPLEX_ANTISENSE_OLIGO_SEQUENCE',
    defaultMessage: 'Antisense Sequence:',
  },
  CONF_DUPLEX_ANTISENSE_SEQUENCE_AUTOGENERATE: {
    id: 'CONF_DUPLEX_ANTISENSE_SEQUENCE_AUTOGENERATE',
    defaultMessage: 'Auto Generate Antisense Sequence',
  },
  CONF_DUPLEX_ANTISENSE_OLIGO_MODIFICATIONS: {
    id: 'CONF_DUPLEX_ANTISENSE_OLIGO_MODIFICATIONS',
    defaultMessage: 'Antisense Modifications:',
  },
  CONF_DUPLEX_ANTISENSE_OLIGO_OVERHANG: {
    id: 'CONF_DUPLEX_ANTISENSE_OLIGO_OVERHANG',
    defaultMessage: 'Antisense Overhang:',
  },
  CONF_DNAPLATES_FORWARD_OLIGO: {
    id: 'CONF_DNAPLATES_FORWARD_OLIGO',
    defaultMessage: 'Forward Oligo',
  },
  CONF_DNAPLATE_JP_96WELLTYPE_MIXED_PLACEHOLDER: {
    id: 'CONF_DNAPLATE_JP_96WELLTYPE_MIXED_PLACEHOLDER',
    defaultMessage: 'Valid length: 6 - 160 bases',
  },
  CONF_DNAPLATES_OLIGO_PREVIEW: {
    id: 'CONF_DNAPLATES_OLIGO_PREVIEW',
    defaultMessage: 'Oligo Preview:',
  },
  CONF_DNAPLATES_FORWARD_OLIGO_PROPERTIES: {
    id: 'CONF_DNAPLATES_FORWARD_OLIGO_PROPERTIES',
    defaultMessage: 'Forward Oligo Properties',
  },
  CONF_DNAPLATES_SECOUNDARY_STRUCTURE: {
    id: 'CONF_DNAPLATES_SECOUNDARY_STRUCTURE',
    defaultMessage: 'Secondary Structures:',
  },
  CONF_DNAPLATES_MELTING_TEMPERATURE: {
    id: 'CONF_DNAPLATES_MELTING_TEMPERATURE',
    defaultMessage: 'Melting Temperature (℃):',
  },
  CONF_DNAPLATES_GC_CONTENT: {
    id: 'CONF_DNAPLATES_GC_CONTENT',
    defaultMessage: 'GC Content (%):',
  },
  CONF_DNAPLATES_PRIMER_DIMER: {
    id: 'CONF_DNAPLATES_PRIMER_DIMER',
    defaultMessage: 'Primer Dimer:',
  },
  CONF_DNAPLATES_REVERSE_OLIGO: {
    id: 'CONF_DNAPLATES_REVERSE_OLIGO',
    defaultMessage: 'Reverse Oligo',
  },
  CONF_DNAPLATES_REVERSE_OLIGO_PROPERTIES: {
    id: 'CONF_DNAPLATES_REVERSE_OLIGO_PROPERTIES',
    defaultMessage: 'Reverse Oligo Properties',
  },
  CONF_DNAPLATES_OLIGO_SEQUENCE: {
    id: 'CONF_DNAPLATES_OLIGO_SEQUENCE',
    defaultMessage: 'Oligo Sequence',
  },
  CONF_OLIGO_LABEL: { id: 'CONF_OLIGO_LABEL', defaultMessage: 'Oligo Name:' },
  CONF_DNAPLATE_JP_96WELLTYPE_PLACEHOLDER: {
    id: 'CONF_DNAPLATE_JP_96WELLTYPE_PLACEHOLDER',
    defaultMessage: 'Valid length: 6 - 160 bases',
  },
  CONF_DNAPLATES_OLIGO_PROPERTIES: {
    id: 'CONF_DNAPLATES_OLIGO_PROPERTIES',
    defaultMessage: 'Oligo Properties',
  },
  CONF_DNAPLATE_VIEWALL_WELL: {
    id: 'CONF_DNAPLATE_VIEWALL_WELL',
    defaultMessage: '-Well, ',
  },
  CONF_DNAPLATE_CONFIRM_CHANNEL_TEXT: {
    id: 'CONF_DNAPLATE_CONFIRM_CHANNEL_TEXT',
    defaultMessage: '-Channel',
  },
  CONF_MODIFICATION_FEE_DNA_PLATES: {
    id: 'CONF_MODIFICATION_FEE_DNA_PLATES',
    defaultMessage: 'Modification Fee:',
  },
  CONF_PLATE_COPY_FEE_DNA_PLATES: {
    id: 'CONF_PLATE_COPY_FEE_DNA_PLATES',
    defaultMessage: 'Plate Copy Fee:',
  },
  CONF_OTHERS_DNA_PLATES: {
    id: 'CONF_OTHERS_DNA_PLATES',
    defaultMessage: 'Others:',
  },
  CONF_PLATE_SUBTOTAL_DNA_PLATES: {
    id: 'CONF_PLATE_SUBTOTAL_DNA_PLATES',
    defaultMessage: 'Plate Subtotal:',
  },
  CONF_WARNING_MESSAGE: {
    id: 'CONF_WARNING_MESSAGE',
    defaultMessage: 'Warning :',
  },
  CONF_PLATE_TOTAL_COUNT: {
    id: 'CONF_PLATE_TOTAL_COUNT',
    defaultMessage: 'Total Plate(s): ',
  },
  CONF_DNAPLATES_ORDER_SUMMARY_PLATE_SPECIFICATIONS: {
    id: 'CONF_DNAPLATES_ORDER_SUMMARY_PLATE_SPECIFICATIONS',
    defaultMessage: 'Plate Specifications',
  },
  CONF_DUPLEX_AMOUNT_MOLES: {
    id: 'CONF_DUPLEX_AMOUNT_MOLES',
    defaultMessage: '  nmol',
  },
  CONF_CONCENTRATION_DNA_PLATES: {
    id: 'CONF_CONCENTRATION_DNA_PLATES',
    defaultMessage: 'Concentration:',
  },
  CONF_VOLUME_DNA_PLATES: {
    id: 'CONF_VOLUME_DNA_PLATES',
    defaultMessage: 'Volume:',
  },
  CONF_SCALE_DNA_PLATES: {
    id: 'CONF_SCALE_DNA_PLATES',
    defaultMessage: ' Scale:',
  },
  _PC_SPEC_0_025UM: { id: '_PC_SPEC_0_025UM', defaultMessage: '0.025 µmole' },
  _PC_SPEC_0_05UM: { id: '_PC_SPEC_0_05UM', defaultMessage: '0.05 µmole' },
  _PC_SPEC_0_2UM: { id: '_PC_SPEC_0_2UM', defaultMessage: '0.2 µmole' },
  _PC_SPEC_1_0UM: { id: '_PC_SPEC_1_0UM', defaultMessage: '1 µmole' },
  CONF_DNAPLATES_ORDER_SUMMARY_DAUGHTER_PLATES: {
    id: 'CONF_DNAPLATES_ORDER_SUMMARY_DAUGHTER_PLATES',
    defaultMessage: 'Daughter Plates:',
  },
  PLATE_96_DEEP_800: {
    id: 'PLATE_96_DEEP_800',
    defaultMessage: 'Deep Well (800 μL)',
  },
  _PC_PLATE_SPECIFICATIONS_AMBIENT: {
    id: '_PC_PLATE_SPECIFICATIONS_AMBIENT',
    defaultMessage: 'Ambient (Room Temperature)',
  },
  _PC_PLATE_SPECIFICATIONS_ICE: {
    id: '_PC_PLATE_SPECIFICATIONS_ICE',
    defaultMessage: 'Ice Packs (Cool)',
  },
  _PC_PLATE_SPECIFICATIONS_DRY_ICE: {
    id: '_PC_PLATE_SPECIFICATIONS_DRY_ICE',
    defaultMessage: 'Dry Ice (Frozen)',
  },
  CONF_DUPLEX_SUMMARY_AKNOWLEDGEMENT: {
    id: 'CONF_DUPLEX_SUMMARY_AKNOWLEDGEMENT',
    defaultMessage:
      'I acknowledge some siRNA duplexes contain greater than 20% mismatch.',
  },
  CONF_DNAPLATES_PLATE_WELL_NUMBER96: {
    id: 'CONF_DNAPLATES_PLATE_WELL_NUMBER96',
    defaultMessage: '96',
  },
  CONF_DNAPLATES_PLATE_CHANNEL_NUMBER8: {
    id: 'CONF_DNAPLATES_PLATE_CHANNEL_NUMBER8',
    defaultMessage: '8',
  },
  CONF_DNAPLATES_PLATE_CHANNEL_NUMBER12: {
    id: 'CONF_DNAPLATES_PLATE_CHANNEL_NUMBER12',
    defaultMessage: '12',
  },
  CONF_DNAPLATES_PLATE_WELL_NUMBER384: {
    id: 'CONF_DNAPLATES_PLATE_WELL_NUMBER384',
    defaultMessage: '384',
  },
  CONF_DNAPLATES_PLATE_CHANNEL_NUMBER16: {
    id: 'CONF_DNAPLATES_PLATE_CHANNEL_NUMBER16',
    defaultMessage: '16',
  },
  DOWNLOAD: { id: 'DOWNLOAD', defaultMessage: 'Download' },
  CONF_DNAPLATES_WELL: { id: 'CONF_DNAPLATES_WELL', defaultMessage: 'Wells' },
  CONF_DNAPLATES_CHANNELS: {
    id: 'CONF_DNAPLATES_CHANNELS',
    defaultMessage: 'Channels',
  },
  CONF_DNAPLATES_TYPE: { id: 'CONF_DNAPLATES_TYPE', defaultMessage: 'Type' },
  CONF_DUPLEX_PLATE_SWITCH_MESSAGE: {
    id: 'CONF_DUPLEX_PLATE_SWITCH_MESSAGE',
    defaultMessage: 'Generate Antisense Name and Sequence',
  },
  CONF_DNA_PLATE_COPYPASTE_HELP_TEXT1: {
    id: 'CONF_DNA_PLATE_COPYPASTE_HELP_TEXT1',
    defaultMessage:
      'Copy and paste your specifications from the template provided or using the example format below. Enter one sequence per line, comma delimited or tab delimited.',
  },
  CONF_DNA_PLATE_COPYPASTE_HELP_TEXT2: {
    id: 'CONF_DNA_PLATE_COPYPASTE_HELP_TEXT2',
    defaultMessage:
      "Comma delimited example: Row, Column, Name, 5' Mod, Sequence (5' to 3'), 3' Mod",
  },
  CONF_DUPLEX_PLATE_COPYPASTE_HELP_TEXT: {
    id: 'CONF_DUPLEX_PLATE_COPYPASTE_HELP_TEXT',
    defaultMessage:
      "Row, Column, Name (Sense), 5' Modification, Sequence (Sense) 5' to 3', Overhang, 3' Modification, Name (Antisense), 5' Modification, Sequence (Antisense) 5' to 3', Overhang, 3' Modification",
  },
  CONF_DNAPLATES_OLIGO_CONFIGURATION: {
    id: 'CONF_DNAPLATES_OLIGO_CONFIGURATION',
    defaultMessage: 'Oligo Configuration',
  },
  CONF_DNAPLATES_ORDER_CONFIRMATION: {
    id: 'CONF_DNAPLATES_ORDER_CONFIRMATION',
    defaultMessage: 'Order Confirmation',
  },
  MINIMUM_SEQUENCE_LENGTH: {
    id: 'MINIMUM_SEQUENCE_LENGTH',
    defaultMessage: ' Minimum sequence length: 13',
  },
  MINIMUM_SEQUENCE_LENGTH_JA: {
    id: 'MINIMUM_SEQUENCE_LENGTH_JA',
    defaultMessage: ' 最小の配列の長さは13です',
  },
  MAXIMUM_SEQUENCE_LENGTH: {
    id: 'MAXIMUM_SEQUENCE_LENGTH',
    defaultMessage: ' Maximum sequence length: 35',
  },
  MAXIMUM_SEQUENCE_LENGTH_JA: {
    id: 'MAXIMUM_SEQUENCE_LENGTH_JA',
    defaultMessage: ' 配列の最長の長さは35',
  },
  CONF_AMINO_ACIDS: { id: 'CONF_AMINO_ACIDS', defaultMessage: 'Amino Acids' },
  CONF_SCALE: { id: 'CONF_SCALE', defaultMessage: 'Scale(µmole)' },
  SERVICES: { id: 'SERVICES', defaultMessage: 'Services' },
  PREVIOUS_TEXT: { id: 'PREVIOUS_TEXT', defaultMessage: 'Previous' },
  CONF_TOTAL_AMINO_ACID: {
    id: 'CONF_TOTAL_AMINO_ACID',
    defaultMessage: 'Total Amino Acids: ',
  },
  CONF_POPUP_SCALE: { id: 'CONF_POPUP_SCALE', defaultMessage: 'Scale:' },
  CONF_PURITY_LEVEL_REVIEW_AND_CONFIRM: {
    id: 'CONF_PURITY_LEVEL_REVIEW_AND_CONFIRM',
    defaultMessage: 'Purity Level:',
  },
  TE: { id: 'TE', defaultMessage: 'In Solution (TE)' },
  CONF_CONCENTRATION_EASY_OLIGO_REVIEW_AND_CONFIRM: {
    id: 'CONF_CONCENTRATION_EASY_OLIGO_REVIEW_AND_CONFIRM',
    defaultMessage: 'Concentration:',
  },
  CONF_CONJUGATION: { id: 'CONF_CONJUGATION', defaultMessage: 'Conjugation:' },
  CONF_CONJUGATION_AMOUNT: {
    id: 'CONF_CONJUGATION_AMOUNT',
    defaultMessage: 'Conjugation Amount:',
  },
  CONF_CONJUGATION_CHEMISTRY: {
    id: 'CONF_CONJUGATION_CHEMISTRY',
    defaultMessage: 'Conjugation Chemistry:',
  },
  CONF_ADDITIONAL_CARRIER_PROTEIN: {
    id: 'CONF_ADDITIONAL_CARRIER_PROTEIN',
    defaultMessage: 'Additional Carrier Protein:',
  },
  CONF_QUANTITATION: {
    id: 'CONF_QUANTITATION',
    defaultMessage: 'Quantitation:',
  },
  CONF_MIN_YIELD: { id: 'CONF_MIN_YIELD', defaultMessage: 'Minimum yield:' },
  CONF_SERVICES_REVIEW_AND_CONFIRM: {
    id: 'CONF_SERVICES_REVIEW_AND_CONFIRM',
    defaultMessage: 'Services:',
  },
  CONF_ISO_CODE: { id: 'CONF_ISO_CODE', defaultMessage: 'ISO13485' },
  CONF_CPEPTIDE_PROPERTIES_AMINO_ACIDS: {
    id: 'CONF_CPEPTIDE_PROPERTIES_AMINO_ACIDS',
    defaultMessage: '# Amino Acids',
  },
  CONF_CPEPTIDE_PROPERTIES: {
    id: 'CONF_CPEPTIDE_PROPERTIES',
    defaultMessage: 'Peptide Properties',
  },
  CONF_SEQUENCE_PROPERTIES: {
    id: 'CONF_SEQUENCE_PROPERTIES',
    defaultMessage: 'Sequence Properties ',
  },
  CONF_PREVIEW: { id: 'CONF_PREVIEW', defaultMessage: 'Preview: ' },
  CONF_YIELDS_TABLE: { id: 'CONF_YIELDS_TABLE', defaultMessage: 'Yield Table' },
  CONF_NON_MODIFIED_RNA_OLIGOS: {
    id: 'CONF_NON_MODIFIED_RNA_OLIGOS',
    defaultMessage: 'Non-Modified RNA Oligos (O.D./μg)*',
  },
  _PC_SPEC_NON_MODIFIED_OLIGOS_ST: {
    id: '_PC_SPEC_NON_MODIFIED_OLIGOS_ST',
    defaultMessage: 'Non-Modified Phosphorothioates(S-Oligos)(O.D./µg)*',
  },
  CONF_NON_MODIFIED_OLIGOS: {
    id: 'CONF_NON_MODIFIED_OLIGOS',
    defaultMessage: 'Non-Modified Oligos (O.D./μg)*',
  },
  CONF_DESALT: { id: 'CONF_DESALT', defaultMessage: 'Desalt' },
  CONF_CARTRIDGE: { id: 'CONF_CARTRIDGE', defaultMessage: 'Cartridge' },
  HPLC: { id: 'HPLC', defaultMessage: 'HPLC' },
  CONF_POPUP_PAGE: { id: 'CONF_POPUP_PAGE', defaultMessage: 'PAGE' },
  CONF_RNA_EXPECTED_YIELDS_FOOTER_TEXT: {
    id: 'CONF_RNA_EXPECTED_YIELDS_FOOTER_TEXT',
    defaultMessage:
      '* Guarantee is for oligos 20 bases or longer, shorter oligos may have fewer ODs. Microgram amounts are calculated based on a 30 µg/OD value. If the µg/OD value is less than 30, the reported µg value will be proportionally less. Phosphorothioated yields are 70% of the above stated values.',
  },
  CONF_EXPECTED_YIELDS_FOOTER_TEXT: {
    id: 'CONF_EXPECTED_YIELDS_FOOTER_TEXT',
    defaultMessage:
      '* Guarantee is for 20 mers or longer. Shorter oligos may have fewer ODs.',
  },
  CONF_AMOUNT_EASY_OLIGO: {
    id: 'CONF_AMOUNT_EASY_OLIGO',
    defaultMessage: 'Amount: ',
  },
  CONF_PURIFICATION_EASY_OLIGO: {
    id: 'CONF_PURIFICATION_EASY_OLIGO',
    defaultMessage: 'Purification:',
  },
  CONF_FORMAT_EASY_OLIGO: {
    id: 'CONF_FORMAT_EASY_OLIGO',
    defaultMessage: 'Format:',
  },
  CONF_CONCENTRATION_EASY_OLIGO: {
    id: 'CONF_CONCENTRATION_EASY_OLIGO',
    defaultMessage: 'Concentration:',
  },
  CONF_SHIPPING_EASY_OLIGO: {
    id: 'CONF_SHIPPING_EASY_OLIGO',
    defaultMessage: 'Shipping Options',
  },
  CONF_ROOM_TEMPERATURE_EASY_OLIGO: {
    id: 'CONF_ROOM_TEMPERATURE_EASY_OLIGO',
    defaultMessage: '(Room Temperature)',
  },
  CONF_SEQUENCE_MESSAGE: {
    id: 'CONF_SEQUENCE_MESSAGE',
    defaultMessage:
      "Insert an asterisk '*' between bases that are to be phosphorothioated.",
  },
  CONF_AQUA_SEQUENCE_INFO_ICON_MESSAGE: {
    id: 'CONF_AQUA_SEQUENCE_INFO_ICON_MESSAGE',
    defaultMessage: 'L-form amino acids only',
  },
  CONF_FULL_OLIGO: {
    id: 'CONF_FULL_OLIGO',
    defaultMessage: 'Full S-Oligo Backbone: ',
  },
  CONF_FULL_OLIGO_INFO_ISCALE: {
    id: 'CONF_FULL_OLIGO_INFO_ISCALE',
    defaultMessage:
      'This will automatically insert an asterisk between each bases',
  },
  CONF_FULL_OLIGO_INFO: {
    id: 'CONF_FULL_OLIGO_INFO',
    defaultMessage:
      'This will automatically insert an asterisk between each base',
  },
  _PC_SPEC_OTHER: { id: '_PC_SPEC_OTHER', defaultMessage: 'Other' },
  CONF_LARGE_AMOUNT_STANDARD: {
    id: 'CONF_LARGE_AMOUNT_STANDARD',
    defaultMessage: 'Larger Amount',
  },
  CONF_ISCALEDNA_PURIFICATION_POPUP_TEXT: {
    id: 'CONF_ISCALEDNA_PURIFICATION_POPUP_TEXT',
    defaultMessage:
      'In Vivo Treatment - A treatment of the final product in efforts to minimize the risk of non-specific reaction in in vivo testing.  This is not cGMP nor sterile conditions.',
  },
  CONF_SPECIFICATION_POPUP_MSG: {
    id: 'CONF_SPECIFICATION_POPUP_MSG',
    defaultMessage:
      'Greyed out options are unavailable based upon your sequence ',
  },
  CONF_NOTE_JP_cpeptide: {
    id: 'CONF_NOTE_JP_cpeptide',
    defaultMessage:
      'Please contact jpts@merckgroup.com if your desired combination does not appear here.',
  },
  CONF_NOTE_cpeptide: {
    id: 'CONF_NOTE_cpeptide',
    defaultMessage:
      'Please contact isrcustserv@merckgroup.com if your desired combination does not appear here.',
  },
  CONF_INVALID_SPECIFICATION_ERROR: {
    id: 'CONF_INVALID_SPECIFICATION_ERROR',
    defaultMessage:
      'The sequence(s) and modification(s) combination does not allow you to select a valid specification. Please edit the entered configuration.',
  },
  CONF_TUBES_PER_OLIGO: {
    id: 'CONF_TUBES_PER_OLIGO',
    defaultMessage: 'Tubes Per Oligo ',
  },
  CONF_MIN_YIELD_PER_TUBE: {
    id: 'CONF_MIN_YIELD_PER_TUBE',
    defaultMessage: 'Minimum yield per tube = ',
  },
  SINGLE_PRODUCT_ENTRY_PAGE_LEVEL_ERROR_MESSAGE: {
    id: 'SINGLE_PRODUCT_ENTRY_PAGE_LEVEL_ERROR_MESSAGE',
    defaultMessage: 'Please correct error(s) before adding a new item.',
  },
  PC_VALID_RANGE_ERROR: {
    id: 'PC_VALID_RANGE_ERROR',
    defaultMessage: 'Valid range is 1-999',
  },
  UNIT_PRICE: { id: 'UNIT_PRICE', defaultMessage: 'Unit Price' },
  QUANTITY: { id: 'QUANTITY', defaultMessage: 'Quantity' },
  PC_ANALYTE_milliplex: {
    id: 'PC_ANALYTE_milliplex',
    defaultMessage: 'Analytes',
  },
  EDIT: { id: 'EDIT', defaultMessage: 'Edit' },
  CONF_SAMPLE_TYPE: { id: 'CONF_SAMPLE_TYPE', defaultMessage: 'Sample Type' },
  CONF_ADDITIONAL_DETAILS: {
    id: 'CONF_ADDITIONAL_DETAILS',
    defaultMessage: 'Additional Details',
  },
  CONF_MILLIPLEX_CUSTOM_PREMIX_LABEL_milliplex: {
    id: 'CONF_MILLIPLEX_CUSTOM_PREMIX_LABEL_milliplex',
    defaultMessage: 'Custom Premixing',
  },
  CONF_SPACE_SAVER_OPTION: {
    id: 'CONF_SPACE_SAVER_OPTION',
    defaultMessage: 'Space Saver Option',
  },
  CONF_APPLICABLE_FREIGHT_TAX_AND_FEES_DURING_CHECKOUT: {
    id: 'CONF_APPLICABLE_FREIGHT_TAX_AND_FEES_DURING_CHECKOUT',
    defaultMessage:
      'Applicable freight, taxes & fees will be applied during checkout.',
  },
  CONF_ORDER_ACKNOWLEDGEMENT_ONCE_ORDER_PLACED_MESSAGE: {
    id: 'CONF_ORDER_ACKNOWLEDGEMENT_MESSAGE',
    defaultMessage:
      'You will receive an order acknowledgement once the order has been entered into our system.',
  },
  CONF_SERVICE_FEE_FOR_EACH_KIT_MESSAGE: {
    id: 'CONF_SERVICE_FEE_FOR_EACH_KIT_MESSAGE',
    defaultMessage:
      'There is a service fee added for each kit where the custom premix option is selected.',
  },
  PC_SELECT_ANALYTES_FOR_SEARCH_milliplex: {
    id: 'PC_SELECT_ANALYTES_FOR_SEARCH_milliplex',
    defaultMessage: 'Select Analytes for Search',
  },
  PC_SELECT_ANALYTES_LIST_milliplex: {
    id: 'PC_SELECT_ANALYTES_LIST_milliplex',
    defaultMessage: 'Select Analytes From The List Below',
  },
  CONF_NOTE_DNA_PLATES: { id: 'CONF_NOTE_DNA_PLATES', defaultMessage: 'Note:' },
  PC_SPEC_GRAYEDOUT_WARNING_milliplex: {
    id: 'PC_SPEC_GRAYEDOUT_WARNING_milliplex',
    defaultMessage:
      'Greyed out analytes cannot be plexed with your selected analyte',
  },
  CANCEL: { id: 'CANCEL', defaultMessage: 'Cancel' },
  SEARCH: { id: 'SEARCH', defaultMessage: 'Search' },
  CONF_MILLIPLEX_PRODUCT_ID_LABEL_milliplex: {
    id: 'CONF_MILLIPLEX_PRODUCT_ID_LABEL_milliplex',
    defaultMessage: 'Product ID',
  },
  CONF_MILLIPLEX_PRODUCT_NAME_LABEL_milliplex: {
    id: 'CONF_MILLIPLEX_PRODUCT_NAME_LABEL_milliplex',
    defaultMessage: 'Product Name',
  },
  CONF_MILLIPLEX_SPACE_SAVER_LABEL_milliplex: {
    id: 'CONF_MILLIPLEX_SPACE_SAVER_LABEL_milliplex',
    defaultMessage: 'Space Saver',
  },
  CONF_MILLIPLEX_PRICE_LABEL_milliplex: {
    id: 'CONF_MILLIPLEX_PRICE_LABEL_milliplex',
    defaultMessage: 'Price',
  },
  PC_ADD_ANALYTE_milliplex: {
    id: 'PC_ADD_ANALYTE_milliplex',
    defaultMessage: 'Add/Edit Analytes',
  },
  PC_SELECT_KITS_FROM_BELOW_milliplex: {
    id: 'PC_SELECT_KITS_FROM_BELOW_milliplex',
    defaultMessage: 'Select Kits from the results below',
  },
  SHOWING: { id: 'SHOWING', defaultMessage: 'Showing' },
  OF: { id: 'OF', defaultMessage: 'of' },
  SEMICONF_PAGINATION_RESULTS_TEXT_crisprgrna: {
    id: 'SEMICONF_PAGINATION_RESULTS_TEXT_crisprgrna',
    defaultMessage: 'Results',
  },
  PC_START_OVER: { id: 'PC_START_OVER', defaultMessage: 'Start Over' },
  CONF_SELECT_SPECIES_TEXT: {
    id: 'CONF_SELECT_SPECIES_TEXT',
    defaultMessage: 'Select Species',
  },
  PC_RESEARCH_AREAS_milliplex: {
    id: 'PC_RESEARCH_AREAS_milliplex',
    defaultMessage: 'Research Areas',
  },
  PC_RESEARCH_AREA_HT_milliplex: {
    id: 'PC_RESEARCH_AREA_HT_milliplex',
    defaultMessage: '(Optional: may be used to limit analyte choice.)',
  },
  PC_ANALYTES_milliplex: {
    id: 'PC_ANALYTES_milliplex',
    defaultMessage: 'Select Analytes',
  },
  PC_SELECT_ANALYTES_DESC_milliplex: {
    id: 'PC_SELECT_ANALYTES_DESC_milliplex',
    defaultMessage:
      'No analytes selected. Please make the selections for above required fields.',
  },
  PC_EDIT_ANALYTE_milliplex: {
    id: 'PC_EDIT_ANALYTE_milliplex',
    defaultMessage: 'Edit Analytes',
  },
  CONF_SEARCH_CRITERIA: {
    id: 'CONF_SEARCH_CRITERIA',
    defaultMessage: ' Select Search Criteria',
  },
  PC_SELECT_ANALYTES_TEXT_milliplex: {
    id: 'PC_SELECT_ANALYTES_TEXT_milliplex',
    defaultMessage:
      'Select additional analytes available from this panel, or deselect the ones you would like to remove. Many analytes have multiple names. If you dont see them here, please contact technical service',
  },
  PC_SELECT_ANALYTES_DESELECT_ALL_milliplex: {
    id: 'PC_SELECT_ANALYTES_DESELECT_ALL_milliplex',
    defaultMessage: 'Deselect All',
  },
  CONF_SELECT_ALL_TEXT: {
    id: 'CONF_SELECT_ALL_TEXT',
    defaultMessage: 'Select All',
  },
  MILLIPLEX_KIT_ERROR_MESSAGE: {
    id: 'MILLIPLEX_KIT_ERROR_MESSAGE',
    defaultMessage: 'Please select a kit before proceeding to next step.',
  },
  CONF_HOME_milliplex: { id: 'CONF_HOME_milliplex', defaultMessage: 'Home' },
  CONF_IMMUNOSSAY_PLATFORM_SOLUTIONS: {
    id: 'CONF_CONF_IMMUNOSSAY_PLATFORM_SOLUTIONS',
    defaultMessage: 'Immunoassay Platform Solutions',
  },
  CONF_MILLIPLEX_MULTIPLEX_LUMINEX: {
    id: 'CONF_MILLIPLEX_MULTIPLEX_LUMINEX',
    defaultMessage:
      'MILLIPLEX{registered} Multiplex Assays for Luminex{registered}',
  },
  CONF_MILLIPLEX_ANALYTE_KIT_FINDER_TEXT: {
    id: 'CONF_MILLIPLEX_ANALYTE_KIT_FINDER_TEXT',
    defaultMessage: 'MILLIPLEX{registered} Analyte Kit Finder',
  },
  PC_LEFT_NAV_ENTRY_milliplex: {
    id: 'PC_LEFT_NAV_ENTRY_milliplex',
    defaultMessage: 'Select Kits',
  },
  CONF_CONFIRM_ORDER_milliplex: {
    id: 'CONF_CONFIRM_ORDER_milliplex',
    defaultMessage: 'Review & Order',
  },
  ANALYTICAL_CHROMATOGRAPHY: {
    id: 'ANALYTICAL_CHROMATOGRAPHY',
    defaultMessage: 'Analytical Chromatography',
  },
  ANALYTICAL_REAGENTS: {
    id: 'ANALYTICAL_REAGENTS',
    defaultMessage: 'Analytical Reagents',
  },
  ANALYTICAL_STANDARDS: {
    id: 'ANALYTICAL_STANDARDS',
    defaultMessage: 'Analytical Standards',
  },
  FOOD_ANALYSIS: { id: 'FOOD_ANALYSIS', defaultMessage: 'Food Analysis' },
  GAS_CHROMATOGRAPHY: {
    id: 'GAS_CHROMATOGRAPHY',
    defaultMessage: 'Gas Chromatography',
  },
  SAMPLE_PREPARATION: {
    id: 'SAMPLE_PREPARATION',
    defaultMessage: 'Sample Preparation',
  },
  TITRATION: { id: 'TITRATION', defaultMessage: 'Titration' },
  CHEMISTRY: { id: 'CHEMISTRY', defaultMessage: 'Chemistry' },
  CHEMICAL_SYNTHESIS: {
    id: 'CHEMICAL_SYNTHESIS',
    defaultMessage: 'Chemical Synthesis',
  },
  SOLVENTS: { id: 'SOLVENTS', defaultMessage: 'Solvents' },
  STABLE_ISOTOPES: { id: 'STABLE_ISOTOPES', defaultMessage: 'Stable Isotopes' },
  STOCKROOM_REAGENTS: {
    id: 'STOCKROOM_REAGENTS',
    defaultMessage: 'Stockroom Reagents',
  },
  LIFE_SCIENCE: { id: 'LIFE_SCIENCE', defaultMessage: 'Life Science' },
  THREE_D_CELL_CULTURE: {
    id: 'THREE_D_CELL_CULTURE',
    defaultMessage: '3D Cell Culture',
  },
  ANTIBIOTICS: { id: 'ANTIBIOTICS', defaultMessage: 'Antibiotics' },
  ANTIBODIES: { id: 'ANTIBODIES', defaultMessage: 'Antibodies' },
  BIOCHEMICALS: { id: 'BIOCHEMICALS', defaultMessage: 'Biochemicals' },
  CELL_ANALYSIS: { id: 'CELL_ANALYSIS', defaultMessage: 'Cell Analysis' },
  CELL_BIOLOGY: { id: 'CELL_BIOLOGY', defaultMessage: 'Cell Biology' },
  CELL_CULTURE: { id: 'CELL_CULTURE', defaultMessage: 'Cell Culture' },
  MATERIALS_SCIENCE: {
    id: 'MATERIALS_SCIENCE',
    defaultMessage: 'Materials Science',
  },
  NANOMATERIALS: { id: 'NANOMATERIALS', defaultMessage: 'Nanomaterials' },
  POLYMER_SCIENCE: { id: 'POLYMER_SCIENCE', defaultMessage: 'Polymer Science' },
  VETEC: { id: 'VETEC', defaultMessage: 'Vetec' },
  WESTERN_BLOT: { id: 'WESTERN_BLOT', defaultMessage: 'Western Blot' },
  CONF_UNAUTHORIZED_TEXT_DESC: {
    id: 'CONF_UNAUTHORIZED_TEXT_DESC',
    defaultMessage:
      'For online orders, you will need to log in to the web. Login to order and order custom peptides, siRNAs, qPCR probes, and DNA oligos.',
  },
  CONF_UNAUTHORIZED_TEXT_DESC_V2: {
    id: 'CONF_UNAUTHORIZED_TEXT_DESC_V2',
    defaultMessage:
      'For online orders of configurable products, you must sign in with your username and password to access the product configurator.',
  },
  CONF_MILLIPLEX_LUMINEX_IMMUNOASSAYS: {
    id: 'CONF_MILLIPLEX_LUMINEX_IMMUNOASSAYS',
    defaultMessage:
      'MILLIPLEX{registered} Multiplex for Luminex{registered} Immunoassays',
  },
  CONF_UNAUTHORIZED_DESC: {
    id: 'CONF_UNAUTHORIZED_DESC',
    defaultMessage:
      'If you have not registered as a user, please {link} first.',
  },
  CONF_REGISTER: { id: 'CONF_REGISTER', defaultMessage: 'register' },
  CONF_PRODUCT_NOT_VALID: {
    id: 'CONF_PRODUCT_NOT_VALID',
    defaultMessage: 'This product ordering tool is no longer supported.',
  },
  CONF_INVALID_PRODUCT: {
    id: 'CONF_INVALID_PRODUCT',
    defaultMessage:
      'Sorry, this ordering tool is not supported in your country',
  },
  CONF_INVALID_PRODUCT_DESC_1: {
    id: 'CONF_INVALID_PRODUCT_DESC_1',
    defaultMessage: 'Please contact',
  },
  CONF_CUSTOMER_SUPPORT: {
    id: 'CONF_CUSTOMER_SUPPORT',
    defaultMessage: 'Customer Support',
  },
  CONF_INVALID_PRODUCT_DESC_2: {
    id: 'CONF_INVALID_PRODUCT_DESC_2',
    defaultMessage: 'to obtain a quote.',
  },
  CONF_USER_CANNOT_ORDER: {
    id: 'CONF_USER_CANNOT_ORDER',
    defaultMessage: 'To order products, please {link} your local dealer.',
  },
  CONTACT: { id: 'CONTACT', defaultMessage: 'contact' },
  CONF_SIMILAR_PRODUCTS: {
    id: 'CONF_SIMILAR_PRODUCTS',
    defaultMessage: 'Similar Products',
  },
  CONF_SHOP_PRODUCT_CATEGORIES: {
    id: 'CONF_SHOP_PRODUCT_CATEGORIES',
    defaultMessage: 'Shop by Product Categories',
  },
  CONTACT_US: { id: 'CONTACT_US', defaultMessage: 'Contact Us' },
  PHONE: { id: 'PHONE', defaultMessage: 'Phone' },
  CART_EMAIL: { id: 'CART_EMAIL', defaultMessage: 'Email' },
  CONF_PRODUCT_SUGGESTION: {
    id: 'CONF_PRODUCT_SUGGESTION',
    defaultMessage: 'Product Suggestion',
  },
  CONF_PRODUCT_SUGGESTION_DESC_1: {
    id: 'CONF_PRODUCT_SUGGESTION_DESC_1',
    defaultMessage:
      'If you are unable to find a product you need in our web catalog, you can',
  },
  CONF_MAKE_A_SUGGESTION: {
    id: 'CONF_MAKE_A_SUGGESTION',
    defaultMessage: 'make a suggestion',
  },
  CONF_PRODUCT_SUGGESTION_DESC_2: {
    id: 'CONF_PRODUCT_SUGGESTION_DESC_2',
    defaultMessage: 'for the item through our site.',
  },
  CONF_MARKET_SELECT: {
    id: 'CONF_MARKET_SELECT',
    defaultMessage: 'Market Select',
  },
  CONF_VISIT: { id: 'CONF_VISIT', defaultMessage: 'Visit' },
  CONF_ALDRICH_MARKET_SELECT: {
    id: 'CONF_ALDRICH_MARKET_SELECT',
    defaultMessage: 'Aldrich® Market Select',
  },
  CONF_MARKET_SELECT_DESC: {
    id: 'CONF_MARKET_SELECT_DESC',
    defaultMessage:
      ', your comprehensive solution for the identificaiton and procurement of readily available screening compounds and building blocks.',
  },
  CONF_DNA_OLIGOS_IN_TUBES_standard: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_standard',
    defaultMessage: 'DNA Oligos In Tubes',
  },
  CONF_DNA_OLIGOS_IN_TUBES_iscaledna: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_iscaledna',
    defaultMessage: 'iScale Oligos™ (mg & g quantity)',
  },
  CONF_ISCALE_DNA_DESC: {
    id: 'CONF_ISCALE_DNA_DESC',
    defaultMessage:
      'Larger quantities for in vivo, high throughput and commercial projects.',
  },
  CONF_DNA_OLIGOS_IN_TUBES_PROBE: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_PROBE',
    defaultMessage: 'Dual-Labeled Probes',
  },
  CONF_DNA_OLIGOS_IN_TUBES_PROBE_NEW: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_PROBE_NEW',
    defaultMessage: 'Dual-Labeled, Internal-Quenched & Dual-Quenched Probes',
  },

  CONF_DUAL_LABELED_PROBES_SUB_HEADING: {
    id: 'CONF_DUAL_LABELED_PROBES_SUB_HEADING',
    defaultMessage:
      "The most common probe type, linear hydrolysis probes are used in the 5' nuclease assay.",
  },
  CONF_STANDARD_TUBES_BEACON: {
    id: 'CONF_STANDARD_TUBES_BEACON',
    defaultMessage: 'Molecular Beacons',
  },
  CONF_STANDARD_TUBES_scorpuni: {
    id: 'CONF_STANDARD_TUBES_scorpuni',
    defaultMessage: 'Scorpions{registered} Uni-Probes',
  },
  CONF_PRODUCT_DNAPLATE: {
    id: 'CONF_PRODUCT_DNAPLATE',
    defaultMessage: 'dnaplate',
  },
  CONF_PRODUCT_DUPLEXPLATE: {
    id: 'CONF_PRODUCT_DUPLEXPLATE',
    defaultMessage: 'Custom siRNA oligos in Plates',
  },
  PC_PRODUCT_DISPLAY_NAME_duplexplate_desc: {
    id: 'PC_PRODUCT_DISPLAY_NAME_duplexplate_desc',
    defaultMessage:
      'Human and Rat Druggable Libraries and Mouse Kinase Panels.',
  },
  CONF_TITLE_rna: { id: 'CONF_TITLE_rna', defaultMessage: 'RNA Oligos' },
  CONF_DNA_OLIGOS_IN_TUBES_easyoligo: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_easyoligo',
    defaultMessage: 'Easy Oligos',
  },
  CONF_TITLE_puresimple: {
    id: 'CONF_TITLE_puresimple',
    defaultMessage: 'Pure & Simple Primers',
  },
  CONF_DNA_OLIGOS_IN_TUBES_aqua: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_aqua',
    defaultMessage: 'AQUA™ Peptides',
  },
  CONF_DNA_OLIGOS_IN_TUBES_wellred: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_wellred',
    defaultMessage: 'WellRED Oligos',
  },
  PC_PRODUCT_DISPLAY_NAME_cpeptide: {
    id: 'PC_PRODUCT_DISPLAY_NAME_cpeptide',
    defaultMessage: 'Custom Peptides',
  },
  PC_PRODUCT_DISPLAY_NAME_cpeptide_desc: {
    id: 'PC_PRODUCT_DISPLAY_NAME_cpeptide_desc',
    defaultMessage:
      'Milligram to gram quantities with a variety of options to meet your research needs.',
  },
  PC_PRODUCT_DISPLAY_NAME_fastduplex: {
    id: 'PC_PRODUCT_DISPLAY_NAME_fastduplex',
    defaultMessage: 'FAST siRNA',
  },
  PC_PRODUCT_DISPLAY_NAME_fastduplex_desc: {
    id: 'PC_PRODUCT_DISPLAY_NAME_fastduplex_desc',
    defaultMessage:
      'Expedite your siRNA order! Orders are prioritized in the production process with a turn-around-time of only 3 days.',
  },
  PC_PRODUCT_DISPLAY_NAME_duplex: {
    id: 'PC_PRODUCT_DISPLAY_NAME_duplex',
    defaultMessage: 'siRNA',
  },
  PC_PRODUCT_DISPLAY_NAME_duplex_desc: {
    id: 'PC_PRODUCT_DISPLAY_NAME_duplex_desc',
    defaultMessage:
      'Custom siRNA sequences with a wide range of modifications, purifications and quantities to tailor your unique sequence.',
  },
  CONF_TITLE_mirna: {
    id: 'CONF_TITLE_mirna',
    defaultMessage: 'Custom miRNA in Tubes',
  },
  PC_PRODUCT_DISPLAY_NAME_screen: {
    id: 'PC_PRODUCT_DISPLAY_NAME_screen',
    defaultMessage: 'PEPscreen Peptide Libraries',
  },
  PC_PRODUCT_DISPLAY_NAME_screen_desc: {
    id: 'PC_PRODUCT_DISPLAY_NAME_screen_desc',
    defaultMessage: 'Small scale peptides delivered in a 96 tube rack format.',
  },
  PC_PRODUCT_DISPLAY_NAME_mpdsirna: {
    id: 'PC_PRODUCT_DISPLAY_NAME_mpdsirna',
    defaultMessage: 'Predesigned siRNA',
  },
  PC_PRODUCT_DISPLAY_NAME_mpdsirna_desc: {
    id: 'PC_PRODUCT_DISPLAY_NAME_mpdsirna_desc',
    defaultMessage:
      'Extensive collection of human, mouse and rat siRNA. Multiple sequences are available for every gene, with rankings to indicate performance.',
  },
  CONF_CRISPR_gRNA_HEADER_crisprgrna: {
    id: 'CONF_CRISPR_gRNA_HEADER_crisprgrna',
    defaultMessage: 'Guaranteed Predesigned CRISPR gRNA',
  },
  COMPANION_PRODUCT_TRACRRNAMOD_crisprgrna: {
    id: 'COMPANION_PRODUCT_TRACRRNAMOD_crisprgrna',
    defaultMessage: 'TRACRRNAMOD',
  },
  COMPANION_PRODUCT_TRACRRNAMOD_DESC_crisprgrna: {
    id: 'COMPANION_PRODUCT_TRACRRNAMOD_DESC_crisprgrna',
    defaultMessage: 'SygRNA® Cas9 Synthetic Modified tracrRNA',
  },
  COMPANION_PRODUCT_CAS9PROT_crisprgrna: {
    id: 'COMPANION_PRODUCT_CAS9PROT_crisprgrna',
    defaultMessage: 'CAS9PROT',
  },
  COMPANION_PRODUCT_CAS9_PROTEIN_DESC_crisprgrna: {
    id: 'COMPANION_PRODUCT_CAS9_PROTEIN_DESC_crisprgrna',
    defaultMessage: 'CAS9 Protein',
  },
  COMPANION_PRODUCT_ESPCAS9PRO_crisprgrna: {
    id: 'COMPANION_PRODUCT_ESPCAS9PRO_crisprgrna',
    defaultMessage: 'ESPCAS9PRO',
  },
  COMPANION_PRODUCT_ESPCAS9_PROTEIN_DESC_crisprgrna: {
    id: 'COMPANION_PRODUCT_ESPCAS9_PROTEIN_DESC_crisprgrna',
    defaultMessage: 'ESPCAS9 Protein',
  },
  COMPANION_PRODUCT_FNCAS9TRACR_crisprgrna: {
    id: 'COMPANION_PRODUCT_FNCAS9TRACR_crisprgrna',
    defaultMessage: 'FNCAS9TRACR',
  },
  COMPANION_PRODUCT_FNCAS9TRACR_DESC_crisprgrna: {
    id: 'COMPANION_PRODUCT_FNCAS9TRACR_DESC_crisprgrna',
    defaultMessage: 'SygRNA® FnCas9 Synthetic tracrRNA',
  },
  COMPANION_PRODUCT_FNCAS9PROT_crisprgrna: {
    id: 'COMPANION_PRODUCT_FNCAS9PROT_crisprgrna',
    defaultMessage: 'FNCAS9PROT',
  },
  COMPANION_PRODUCT_FNCAS9PROT_PROTEIN_DESC_crisprgrna: {
    id: 'COMPANION_PRODUCT_FNCAS9PROT_PROTEIN_DESC_crisprgrna',
    defaultMessage: 'FnCas9 Protein',
  },
  COMPANION_PRODUCT_MODIFIED_FNCAS9TRACR_crisprgrna: {
    id: 'COMPANION_PRODUCT_MODIFIED_FNCAS9TRACR_crisprgrna',
    defaultMessage: 'Modified FNCAS9TRACR',
  },
  COMPANION_PRODUCT_MODIFIED_FNCAS9TRACR_DESC_crisprgrna: {
    id: 'COMPANION_PRODUCT_MODIFIED_FNCAS9TRACR_DESC_crisprgrna',
    defaultMessage: 'SygRNA® FnCas9 Synthetic Modified tracrRNA',
  },
  COMPANION_PRODUCT_TRACRRNA05N_crisprgrna: {
    id: 'COMPANION_PRODUCT_TRACRRNA05N_crisprgrna',
    defaultMessage: 'TRACRRNA05N',
  },
  COMPANION_PRODUCT_TRACRRNA05N_DESC_crisprgrna: {
    id: 'COMPANION_PRODUCT_TRACRRNA05N_DESC_crisprgrna',
    defaultMessage: 'SygRNA® SpCas9 tracrRNA',
  },
  INVALID_INPUT_VIEW_MORE: {
    id: 'INVALID_INPUT_VIEW_MORE',
    defaultMessage: '(view {remaining} more errors)',
  },
  SET_AS_PREFERRED_DEALER: {
    id: 'SET_AS_PREFERRED_DEALER',
    defaultMessage: 'Set as Preferred Dealer',
  },
  CONF_ADDTIONAL_QUOTE_ANTISERA: {
    id: 'CONF_ADDTIONAL_QUOTE_ANTISERA',
    defaultMessage: 'Additional Quote Note for Antisera',
  },
  CONF_ADDTIONAL_COMMENT: {
    id: 'CONF_ADDTIONAL_COMMENT',
    defaultMessage: 'Please enter additional comments below',
  },
  CONF_SPL_CHAR_VALIDATION_MSG_ANTISERA: {
    id: 'CONF_SPL_CHAR_VALIDATION_MSG_ANTISERA',
    defaultMessage: 'Comments contains invalid character(s): ',
  },
  CONF_MAXIMUM_CHAR_300: {
    id: 'CONF_MAXIMUM_CHAR_300',
    defaultMessage: 'Maximum length is 300 characters',
  },
  PAGINATION_GOTO_TEXT: {
    id: 'PAGINATION_GOTO_TEXT',
    defaultMessage: 'Go to page ',
  },
  PAGINATION_GOTO_FIRST_TEXT: {
    id: 'PAGINATION_GOTO_FIRST_TEXT',
    defaultMessage: 'Go to first page',
  },
  PAGINATION_LABEL_PREVIOUS: {
    id: 'PAGINATION_LABEL_PREVIOUS',
    defaultMessage: 'Go to previous page',
  },
  PAGINATION_LABEL_NEXT: {
    id: 'PAGINATION_LABEL_NEXT',
    defaultMessage: 'Go to next page',
  },
  PAGINATION_GOTO_LAST_TEXT: {
    id: 'PAGINATION_GOTO_LAST_TEXT',
    defaultMessage: 'Go to last page',
  },
  CONF_CONFIRMATION_TITLE_MSG_Antisera: {
    id: 'CONF_CONFIRMATION_TITLE_MSG_Antisera',
    defaultMessage: 'Change Project Type',
  },
  CONF_CONFIRMATION_MSG_Antisera: {
    id: 'CONF_CONFIRMATION_MSG_Antisera',
    defaultMessage: 'Data you entered will be reset. Are you sure?',
  },
  YES: { id: 'YES', defaultMessage: 'Yes' },
  CONF_PROBE_OD_YIELD_POPUP_LABEL: {
    id: 'CONF_PROBE_OD_YIELD_POPUP_LABEL',
    defaultMessage: 'Guaranteed Yields',
  },
  CONF_PROBE_OD_YIELD_POPUP_FIRST_COLUMN: {
    id: 'CONF_PROBE_OD_YIELD_POPUP_FIRST_COLUMN',
    defaultMessage: 'Guaranteed OD Yield',
  },
  CONF_PROBE_OD_YIELD_POPUP_SECOND_COLUMN: {
    id: 'CONF_PROBE_OD_YIELD_POPUP_SECOND_COLUMN',
    defaultMessage: 'Approx. No. of nmoles',
  },
  CONF_PROBE_OD_YIELD_POPUP_THIRD_COLUMN: {
    id: 'CONF_PROBE_OD_YIELD_POPUP_THIRD_COLUMN',
    defaultMessage: 'Approx. No. of µg',
  },
  CONF_PROBE_OD_YIELD_POPUP_FOURTH_COLUMN: {
    id: 'CONF_PROBE_OD_YIELD_POPUP_FOURTH_COLUMN',
    defaultMessage: 'Approx. No. of Reactions*',
  },
  CONF_PROBE_OD_YIELD_POPUP_NOTICE: {
    id: 'CONF_PROBE_OD_YIELD_POPUP_NOTICE',
    defaultMessage:
      '*Estimate is based on 4 nmoles or 32 µg for 1 OD and 200 nM in 25 µl reaction (5.0 pmol/reaction). Estimate is based on an average sequence length of 25 bases.',
  },
  _PC_YIELD_RECOMMEND_NOTE_scorpuni: {
    id: '_PC_YIELD_RECOMMEND_NOTE_scorpuni',
    defaultMessage:
      '*Estimate is based on 2 nmoles or 32 µg for 1 OD and 200 nM in 25 µl reaction (5.0 pmol/reaction). Estimate is based on an average sequence length of 50 bases(uni-probe).',
  },
  _PC_YIELD_RECOMMEND_NOTE_BEACON: {
    id: '_PC_YIELD_RECOMMEND_NOTE_BEACON',
    defaultMessage:
      '*Estimate is based on 3 nmoles or 32 µg for 1 OD and 200 nM in 25 µl reaction (5.0 pmol/reaction). Estimate is based on an average sequence length of 30 bases.',
  },
  CONF_MODIFIED_RNA_OLIGOS: {
    id: 'CONF_MODIFIED_RNA_OLIGOS',
    defaultMessage: 'Modified RNA Oligos (O.D./µg)*',
  },
  CONF_MODIFIED_OLIGOS: {
    id: 'CONF_MODIFIED_OLIGOS',
    defaultMessage: 'Modified Oligos (O.D./μg)*',
  },
  CONF_MODIFIED_SCALE: {
    id: 'CONF_MODIFIED_SCALE',
    defaultMessage: 'Scale (μmole) ',
  },
  _PC_SPEC_MODIFIES_RNA_SCALE: {
    id: '_PC_SPEC_MODIFIES_RNA_SCALE',
    defaultMessage:
      '* Guarantee is for oligos 20 bases or longer, shorter oligos may have fewer ODs. Microgram amounts are calculated based on a 30 µg/OD value. If the µg/OD value is less than 30, the reported µg value will be proportionally less. Post-synthesis modifications may yield 50% less than the above stated values.',
  },
  _PC_SPEC_MODIFIES_SCALE: {
    id: '_PC_SPEC_MODIFIES_SCALE',
    defaultMessage:
      '* Guarantee is for 20mer or longer. Shorter oligos may have fewer ODs. Microgram amounts are calculated based on a 30 µg/OD value.  If the µg/OD value is less than 30, the reported µg value will be proportionally less. Note: Post-synthesis modifications may yield 50% less than the above stated values. Phosphorothioated yields are 70% of the above stated guarantees.',
  },
  CONF_RECOMMENDATION_standard: {
    id: 'CONF_RECOMMENDATION_standard',
    defaultMessage: 'Recommendation',
  },
  CONF_RECOMMENDATION_POPUP_standard: {
    id: 'CONF_RECOMMENDATION_POPUP_standard',
    defaultMessage: 'Recommended Purifications',
  },
  CONF_POPUP_APPLICATION: {
    id: 'CONF_POPUP_APPLICATION',
    defaultMessage: 'Application',
  },
  CONF_POPUP_HPLC: { id: 'CONF_POPUP_HPLC', defaultMessage: 'HPLC' },
  CUSTOM_CRISPR_RECOMMENDATIONS: {
    id: 'CUSTOM_CRISPR_RECOMMENDATIONS',
    defaultMessage: 'Recommendations based on application',
  },
  CUSTOM_CRISPR_CRRNA_POPUP_customcrispr: {
    id: 'CUSTOM_CRISPR_CRRNA_POPUP_customcrispr',
    defaultMessage: 'crRNA',
  },
  CUSTOM_CRISPR_SGRNA_POPUP_customcrispr: {
    id: 'CUSTOM_CRISPR_SGRNA_POPUP_customcrispr',
    defaultMessage: 'sgRNA',
  },
  CUSTOM_CRISPR_MOD_SGRNA_POPUP_customcrispr: {
    id: 'CUSTOM_CRISPR_MOD_SGRNA_POPUP_customcrispr',
    defaultMessage: 'Modified sgRNA',
  },
  CUSTOM_CRISPR_MOD_CRRNA_POPUP_customcrispr: {
    id: 'CUSTOM_CRISPR_MOD_CRRNA_POPUP_customcrispr',
    defaultMessage: 'Modified crRNA',
  },
  COMPANION_PRODUCT_HEADER_crisprgrna_redesign: {
    id: 'COMPANION_PRODUCT_HEADER_crisprgrna_redesign',
    defaultMessage:
      'CRISPR RNA requires the use of tracrRNA and a Cas9 Protein. Please find the following recommended options.',
  },
  CONF_MANUAL_SEARCH_crisprgrna: {
    id: 'CONF_MANUAL_SEARCH_crisprgrna',
    defaultMessage: 'Manual Search',
  },
  CONF_UPLOAD_QUERIES_crisprgrna: {
    id: 'CONF_UPLOAD_QUERIES_crisprgrna',
    defaultMessage: 'Upload Queries',
  },
  PC_SEND_FEASIBLITY_AND_QUOTATION_REQUEST: {
    id: 'PC_SEND_FEASIBLITY_AND_QUOTATION_REQUEST',
    defaultMessage: 'dnaoligos@milliporesigma.com',
  },
  PC_SEND_FEASIBLITY_AND_QUOTATION_MSG: {
    id: 'PC_SEND_FEASIBLITY_AND_QUOTATION_MSG',
    defaultMessage:
      'Send your feasibility and quotation request for modifications not listed to',
  },
  PC_CONTACT_JP_CPEPTIDE: {
    id: 'PC_CONTACT_JP_CPEPTIDE',
    defaultMessage: ' jpts@merckgroup.com.',
  },
  CONF_ADD_BUTTON: { id: 'CONF_ADD_BUTTON', defaultMessage: 'Add ' },
  CONF_AMINO_ACID_RADIO_LABEL: {
    id: 'CONF_AMINO_ACID_RADIO_LABEL',
    defaultMessage:
      'Will the peptide sequence include an isotopically labeled amino acid?',
  },
  CONF_AMINO_ACID_MODIFICATION_NO: {
    id: 'CONF_AMINO_ACID_MODIFICATION_NO',
    defaultMessage:
      'No, the peptide will NOT include an isotopically labeled amino acid.',
  },
  CONF_AMINO_ACID_MODIFICATION_YES: {
    id: 'CONF_AMINO_ACID_MODIFICATION_YES',
    defaultMessage:
      'Yes, insert cursor in the sequence position and select the desired labeled amino acid below.',
  },
  CONF_AQUA_INTERNAL_MODIFICATION_INSTRUCTION: {
    id: 'CONF_AQUA_INTERNAL_MODIFICATION_INSTRUCTION',
    defaultMessage:
      'To add internal modifications, click the Add button below or type directly into the sequence above at the desired location.',
  },
  CONF_AQUA_INTERNAL_MODIFICATION_NOTE: {
    id: 'CONF_AQUA_INTERNAL_MODIFICATION_NOTE',
    defaultMessage:
      'Modification placed at the last sequence position requires an amidated C-terminus[NH2].',
  },
  CONF_PRODUCT_STANDARD: {
    id: 'CONF_PRODUCT_STANDARD',
    defaultMessage: 'standard',
  },
  CONF_INLINE_MOD_STEPS_standard: {
    id: 'CONF_INLINE_MOD_STEPS_standard',
    defaultMessage: 'Follow these steps to insert an internal modification',
  },
  CONF_INLINE_MOD_STEP_1_standard: {
    id: 'CONF_INLINE_MOD_STEP_1_standard',
    defaultMessage: 'Select your internal modification below. ',
  },
  CONF_INLINE_MOD_STEP_2_standard: {
    id: 'CONF_INLINE_MOD_STEP_2_standard',
    defaultMessage:
      'Insert your cursor at the desired position within the sequence. ',
  },
  CONF_INLINE_MOD_STEP_3_standard: {
    id: 'CONF_INLINE_MOD_STEP_3_standard',
    defaultMessage: 'Press the ',
  },
  CONF_ADD_MODIFICATION: {
    id: 'CONF_ADD_MODIFICATION',
    defaultMessage: 'Add Modification',
  },
  CONF_INLINE_MOD_STEP_3B_standard: {
    id: 'CONF_INLINE_MOD_STEP_3B_standard',
    defaultMessage: 'button below.',
  },
  CONF_INTERNAL_MOD_TYPE_standard: {
    id: 'CONF_INTERNAL_MOD_TYPE_standard',
    defaultMessage: 'Internal Modification Type',
  },
  CONF_INTERNAL_MOD_standard: {
    id: 'CONF_INTERNAL_MOD_standard',
    defaultMessage: 'Internal Modification ',
  },
  CONF_OPTIONAL_BASES_HEADER_longOligo: {
    id: 'CONF_OPTIONAL_BASES_HEADER_longOligo',
    defaultMessage:
      'Select the Add link to insert the modified base at the desired sequence position with the placement of the cursor in the sequence field',
  },
  CONF_OPTIONAL_BASES_HEADER_standard: {
    id: 'CONF_OPTIONAL_BASES_HEADER_standard',
    defaultMessage:
      'Insert your cursor at the desired position and click the Add link.',
  },
  PC_CONTACT_CPEPTIDE_TEXT: {
    id: 'PC_CONTACT_CPEPTIDE_TEXT',
    defaultMessage:
      'If you do not have the qualification you requested, please contact us at',
  },
  PC_CONTACT_CPEPTIDE_IL_TEXT: {
    id: 'PC_CONTACT_CPEPTIDE_IL_TEXT',
    defaultMessage: 'If you do not qualify for your request, please contact',
  },
  PC_CONTACT_CPEPTIDE: {
    id: 'PC_CONTACT_CPEPTIDE',
    defaultMessage: ' isrcustserv@merckgroup.com ',
  },
  CONF_OPTIONAL_MOD_rna: {
    id: 'CONF_OPTIONAL_MOD_rna',
    defaultMessage: "5' Modifications",
  },
  CONF_TRADEMARK_LICENSE_INFORMATION: {
    id: 'CONF_TRADEMARK_LICENSE_INFORMATION',
    defaultMessage: 'Trademark and Label License Information',
  },
  CONF_MODIFICATION_TECHNICAL_RESOURCE: {
    id: 'CONF_MODIFICATION_TECHNICAL_RESOURCE',
    defaultMessage: 'Modifications Technical Resource',
  },
  CONF_MODIFICATION: {
    id: 'CONF_MODIFICATION',
    defaultMessage: 'Modifications',
  },
  CONF_MODIFICATION_INFO: {
    id: 'CONF_MODIFICATION_INFO',
    defaultMessage:
      'Please find {TrademarkURL} and {ModificationsTechnicalResourceURL} for your reference.',
  },
  CONF_SHOW_LESS: { id: 'CONF_SHOW_LESS', defaultMessage: 'Show less' },
  CONF_SHOW_MORE: { id: 'CONF_SHOW_MORE', defaultMessage: 'Show more' },
  CONF_DNA_DEGENERATE_BASES: {
    id: 'CONF_DNA_DEGENERATE_BASES',
    defaultMessage: 'DNA Degenerate Bases',
  },
  CONF_OME_RNA_BASES: {
    id: 'CONF_OME_RNA_BASES',
    defaultMessage: "2'-OMe RNA Bases",
  },
  CONF_URACLI_INOSINE: {
    id: 'CONF_URACLI_INOSINE',
    defaultMessage: 'Uracil and Inosine',
  },
  CONF_LNA_BASES: { id: 'CONF_LNA_BASES', defaultMessage: 'LNA Bases' },
  CONF_MODIFIED_BASES: {
    id: 'CONF_MODIFIED_BASES',
    defaultMessage: 'Modified Bases',
  },
  CONF_DNA_BASES: { id: 'CONF_DNA_BASES', defaultMessage: 'DNA Bases' },
  CONF_RNA_DEGENERATE_BASES: {
    id: 'CONF_RNA_DEGENERATE_BASES',
    defaultMessage: 'RNA Degenerate Bases',
  },
  CONF_FLUORO_BASES: {
    id: 'CONF_FLUORO_BASES',
    defaultMessage: "2'-Fluoro Bases",
  },
  REQUEST_QUOTE: { id: 'REQUEST_QUOTE', defaultMessage: 'Request Quote' },
  CONF_YOUR_SHOPPING_CART_UPDATE: {
    id: 'CONF_YOUR_SHOPPING_CART_UPDATE',
    defaultMessage: 'Your Shopping cart has been updated',
  },
  CONF_ITEM_ADDED_TO_SHOPPIN_CART: {
    id: 'CONF_ITEM_ADDED_TO_SHOPPIN_CART',
    defaultMessage: 'item has been added to your shopping cart',
  },
  SEMI_CONF_ORDER_MORE_CLONES: {
    id: 'SEMI_CONF_ORDER_MORE_CLONES',
    defaultMessage: 'Order More Clones',
  },
  SEMI_CONF_NEW_PRODUCTS_AND_CONTROLS: {
    id: 'SEMI_CONF_NEW_PRODUCTS_AND_CONTROLS',
    defaultMessage: 'New Products and Controls',
  },
  CONF_PROCEED_TO_CHECKOUT: {
    id: 'CONF_PROCEED_TO_CHECKOUT',
    defaultMessage: 'Proceed To Checkout',
  },
  CONF_CONTINUE_SHOPPING: {
    id: 'CONF_CONTINUE_SHOPPING',
    defaultMessage: 'Continue Shopping',
  },
  COMPANION_PRODUCT_HEADER_crisprgrna: {
    id: 'COMPANION_PRODUCT_HEADER_crisprgrna',
    defaultMessage:
      'CRISPR RNA requires the use of tracrRNA and a Cas9 protein. Please choose from the recommended options.',
  },
  CONF_CUSTOMERS_PURCHASED: {
    id: 'CONF_CUSTOMERS_PURCHASED',
    defaultMessage: 'Customers who purchased this also purchased',
  },
  CONF_NEW_PEPTIDE: { id: 'CONF_NEW_PEPTIDE', defaultMessage: 'New Peptide' },
  CONF_MY_PLATES_SIDE_BAR: {
    id: 'CONF_MY_PLATES_SIDE_BAR',
    defaultMessage: 'My Plates ',
  },
  CONF_DUPLEX_TERMS_AND_CONDITIONS: {
    id: 'CONF_DUPLEX_TERMS_AND_CONDITIONS',
    defaultMessage: 'Terms and Conditions',
  },
  CONF_DUPLEX_SUMMARY_AKNOWLEDGEMENT_ERROR_MSG: {
    id: 'CONF_DUPLEX_SUMMARY_AKNOWLEDGEMENT_ERROR_MSG',
    defaultMessage:
      'Please agree to the terms before adding the custom products to the cart.',
  },
  CLEAR_CART_OKAY: { id: 'CLEAR_CART_OKAY', defaultMessage: 'OK' },
  CONF_CAUTION_POPUP_TEXT_PEPSCREEN: {
    id: 'CONF_CAUTION_POPUP_TEXT_PEPSCREEN',
    defaultMessage:
      'Adding a new set of peptides will override any existing peptide sets in this session.',
  },
  SEMICONF_CAUTION_POPUP_TEXT1: {
    id: 'SEMICONF_CAUTION_POPUP_TEXT1',
    defaultMessage: 'Are you sure you want to change the {type}?',
  },
  SEMICONF_CAUTION_POPUP_TEXT2: {
    id: 'SEMICONF_CAUTION_POPUP_TEXT2',
    defaultMessage: 'Any custom changes you have made will be lost.',
  },
  CONF_CAUTION_POPUP_TEXT: {
    id: 'CONF_CAUTION_POPUP_TEXT',
    defaultMessage:
      'Adding a new set of plates will override any existing items in this session.',
  },
  CONF_COPY_PASTE_TOOLTIPMSG1: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG1',
    defaultMessage:
      'Download the Multiple Entry Template to view formatting requirements or type sequence information using the example format below. One record per line, comma or tab delimited. Do not include column headers.',
  },
  CONF_DROP_XLS_OR_XLSX_FILE_OR: {
    id: 'CONF_DROP_XLS_OR_XLSX_FILE_OR',
    defaultMessage: 'Drop XLS or XLSX files ',
  },
  OR: { id: 'OR', defaultMessage: 'or' },
  BROWSE: { id: 'BROWSE', defaultMessage: 'Browse' },
  CONF_NGSO_COMFIRM_REMOVAL_POPUP_HEADING: {
    id: 'CONF_NGSO_COMFIRM_REMOVAL_POPUP_HEADING',
    defaultMessage: 'Confirm Removal',
  },
  CONF_NGSO_COMFIRM_REMOVAL_POPUP_TEXT_FOR_TUBES: {
    id: 'CONF_NGSO_COMFIRM_REMOVAL_POPUP_TEXT_FOR_TUBES',
    defaultMessage:
      'Are you sure want to delete this tube rather than edit it? NGSO Silver Orders require a minimum of 12 tubes. Your order will be reset.',
  },
  CONF_NGSO_COMFIRM_REMOVAL_POPUP_TEXT_FOR_PLATES: {
    id: 'CONF_NGSO_COMFIRM_REMOVAL_POPUP_TEXT_FOR_PLATES',
    defaultMessage:
      'Are you sure want to remove this item rather than edit it? NGSO Plate Orders require a  minimum of 70 and your order will be reset. ',
  },
  CONF_DNAPLATE_VIEWALL_CHANNEL_TEXT: {
    id: 'CONF_DNAPLATE_VIEWALL_CHANNEL_TEXT',
    defaultMessage: '-channel',
  },
  CONF_DNAPLATE_VIEWALL_CHANNEL_MIXED_TEXT: {
    id: 'CONF_DNAPLATE_VIEWALL_CHANNEL_MIXED_TEXT',
    defaultMessage: '-channel, Mixed',
  },
  CONF_DNAPLATE_VIEWALL_PLATENAME_TEXT: {
    id: 'CONF_DNAPLATE_VIEWALL_PLATENAME_TEXT',
    defaultMessage: 'Plate Name',
  },
  CONF_DNAPLATE_VIEWALL_OLIGOS_TEXT: {
    id: 'CONF_DNAPLATE_VIEWALL_OLIGOS_TEXT',
    defaultMessage: '# Oligos',
  },
  CONF_DNAPLATE_VIEWALL_RESEARCH_NAME_TEXT: {
    id: 'CONF_DNAPLATE_VIEWALL_RESEARCH_NAME_TEXT',
    defaultMessage: 'Researcher Name',
  },
  CONF_OLIGO_NAME_TUBE: {
    id: 'CONF_OLIGO_NAME_TUBE',
    defaultMessage: 'Oligo Name',
  },
  CONF_AMINO_ACIDS_VIEW_ALL: {
    id: 'CONF_AMINO_ACIDS_VIEW_ALL',
    defaultMessage: '# Amino Acids',
  },
  CONF_BASES_VIEW_ALL: {
    id: 'CONF_BASES_VIEW_ALL',
    defaultMessage: '# Bases',
  },
  CONF_VIEWALL_SCALE: { id: 'CONF_VIEWALL_SCALE', defaultMessage: 'Scale' },
  CONF_EMAIL_CART_SUCCESS: {
    id: 'CONF_EMAIL_SUCCESS',
    defaultMessage: 'Successfully mailed the configuration',
  },
  SINGLE_PRODUCT_ENTRY: {
    id: 'SINGLE_PRODUCT_ENTRY',
    defaultMessage: 'Single Product Entry',
  },
  MULIPLE_PRODUCT_ENTRY: {
    id: 'MULIPLE_PRODUCT_ENTRY',
    defaultMessage: 'Multiple Product Entry',
  },
  CONF_HOME_easyoligo: { id: 'CONF_HOME_easyoligo', defaultMessage: 'Home' },
  CONF_HOME_iscaledna: { id: 'CONF_HOME_iscaledna', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_easyoligo: {
    id: 'CONF_CUSTOM_PRODUCTS_easyoligo',
    defaultMessage: customProductsStr,
  },
  CONF_CUSTOM_PRODUCTS_iscaledna: {
    id: 'CONF_CUSTOM_PRODUCTS_iscaledna',
    defaultMessage: customProductsStr,
  },
  CONF_STANDARD_TUBES_easyoligo: {
    id: 'CONF_STANDARD_TUBES_easyoligo',
    defaultMessage: 'Easy Oligos',
  },
  CONF_STANDARD_TUBES_iscaledna: {
    id: 'CONF_STANDARD_TUBES_iscaledna',
    defaultMessage: 'iScale Oligos™ (mg & g quantity)',
  },
  CONF_SPECIFICATIONS_AND_SHIPPING_easyoligo: {
    id: 'CONF_SPECIFICATIONS_AND_SHIPPING_easyoligo',
    defaultMessage: 'Specifications &Shipping',
  },
  CONF_HOME_standard: { id: 'CONF_HOME_standard', defaultMessage: 'Home' },
  CONF_OLIGO_NAME_iscaledna: {
    id: 'CONF_OLIGO_NAME_iscaledna',
    defaultMessage: oligoNameStr,
  },
  CONF_ENTER_NAME_standard: {
    id: 'CONF_ENTER_NAME_standard',
    defaultMessage: 'Enter Name ',
  },
  CONF_ENTER_NAME_iscaledna: {
    id: 'CONF_ENTER_NAME_iscaledna',
    defaultMessage: 'Enter Name ',
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_standard: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_standard',
    defaultMessage: maxStr,
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_iscaledna: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_iscaledna',
    defaultMessage: maxStr,
  },
  CONF_ENTER_SEQUENCE_standard: {
    id: 'CONF_ENTER_SEQUENCE_standard',
    defaultMessage: 'Enter Sequence ',
  },
  CONF_ENTER_SEQUENCE_iscaledna: {
    id: 'CONF_ENTER_SEQUENCE_iscaledna',
    defaultMessage: 'Enter Sequence ',
  },
  CONF_SEQUENCE_ENTRY_standard: {
    id: 'CONF_SEQUENCE_ENTRY_standard',
    defaultMessage: sequenceEntryStr,
  },
  CONF_SEQUENCE_ENTRY_iscaledna: {
    id: 'CONF_SEQUENCE_ENTRY_iscaledna',
    defaultMessage: sequenceEntryStr,
  },
  CONF_CONFIRM_ORDER_standard: {
    id: 'CONF_CONFIRM_ORDER_standard',
    defaultMessage: reviewStr,
  },
  CONF_CONFIRM_ORDER_iscaledna: {
    id: 'CONF_CONFIRM_ORDER_iscaledna',
    defaultMessage: reviewStr,
  },
  CONF_SEQUENCE_ENTRY_easyoligo: {
    id: 'CONF_SEQUENCE_ENTRY_easyoligo',
    defaultMessage: sequenceEntryStr,
  },
  CONF_CONFIRM_ORDER_easyoligo: {
    id: 'CONF_CONFIRM_ORDER_easyoligo',
    defaultMessage: reviewStr,
  },
  CONF_SEQUENCE_MESSAGE_standard: {
    id: 'CONF_SEQUENCE_MESSAGE_standard',
    defaultMessage:
      "Insert an asterisk '*' between bases that are to be phosphorothioated.",
  },
  CONF_SEQUENCE_MESSAGE_iscaledna: {
    id: 'CONF_SEQUENCE_MESSAGE_iscaledna',
    defaultMessage:
      "Insert an asterisk '*' between bases that are to be phosphorothioated.",
  },
  CONF_SEQUENCE_MESSAGE_easyoligo: {
    id: 'CONF_SEQUENCE_MESSAGE_easyoligo',
    defaultMessage: 'Standard DNA bases only: A, C, G, T',
  },
  CONF_SELECT_TYPE_standard: {
    id: 'CONF_SELECT_TYPE_standard',
    defaultMessage: 'Select Type ',
  },
  CONF_SELECT_MOD_standard: {
    id: 'CONF_SELECT_MOD_standard',
    defaultMessage: 'Select Modification',
  },
  CONF_INLINE_MOD_STEP_2A_standard: {
    id: 'CONF_INLINE_MOD_STEP_2A_standard',
    defaultMessage: 'Sequence Section ',
  },
  CONF_INLINE_MOD_STEP_2B_standard: {
    id: 'CONF_INLINE_MOD_STEP_2B_standard',
    defaultMessage: 'above. ',
  },
  CONF_SYNTHESIS_SCALE: {
    id: 'CONF_SYNTHESIS_SCALE',
    defaultMessage: 'Synthesis Scale (μmole) ',
  },
  CONF_CONCENTRATION: {
    id: 'CONF_CONCENTRATION',
    defaultMessage: 'Concentration (μm) ',
  },
  CONF_PCR_NON_MODIFIED_OLIGOS: {
    id: 'CONF_PCR_NON_MODIFIED_OLIGOS',
    defaultMessage: 'PCR Non-Modified Oligos',
  },
  CONF_ORDERING_TUTORIAL_HELP_NAV: {
    id: 'CONF_ORDERING_TUTORIAL_HELP_NAV',
    defaultMessage: 'Ordering Tutorial ',
  },
  CONF_CUSTOMER_SVC_HELP_NAV: {
    id: 'CONF_CUSTOMER_SVC_HELP_NAV',
    defaultMessage: 'customersvc@milliporesigma.com ',
  },
  CONF_CONTACT_NUMBER_HELP_NAV: {
    id: 'CONF_CONTACT_NUMBER_HELP_NAV',
    defaultMessage: '1-800-234-5362 ',
  },
  CONF_ADDING_SHIPPING_INFO_PROCESS: {
    id: 'CONF_ADDING_SHIPPING_INFO_PROCESS',
    defaultMessage:
      'Adding shipping information will slow the ordering process',
  },
  CONF_DUAL_LABELED_PROBES: {
    id: 'CONF_DUAL_LABELED_PROBES',
    defaultMessage: 'Dual -Labeled Probes',
  },
  CONF_EASY_OLIGOS: { id: 'CONF_EASY_OLIGOS', defaultMessage: 'Easy Oligos' },
  CONF_EASY_OLIGOS_SUB_HEADING: {
    id: 'CONF_EASY_OLIGOS_SUB_HEADING',
    defaultMessage: 'Normalized to 100m at a fixed price.',
  },
  CONF_PURE_SIMPLE_PRIMERS: {
    id: 'CONF_PURE_SIMPLE_PRIMERS',
    defaultMessage: 'Pure  simple Primers',
  },
  CONF_CARTRIDGE_PURIFIED_PRICE: {
    id: 'CONF_CARTRIDGE_PURIFIED_PRICE',
    defaultMessage: 'Cartridge purified primers at a fixed price.',
  },
  CONF_STANDARD_TEXT: { id: 'CONF_STANDARD_TEXT', defaultMessage: 'standard' },
  CONF_WELLRED_TEXT: { id: 'CONF_WELLRED_TEXT', defaultMessage: 'wellred' },
  CONF_EASYOLIGO_TEXT: {
    id: 'CONF_EASYOLIGO_TEXT',
    defaultMessage: 'easyoligo',
  },
  CONF_CUSTOM_PRODUCTS_standard: {
    id: 'CONF_CUSTOM_PRODUCTS_standard',
    defaultMessage: customProductsStr,
  },
  CONF_OLIGOS_PROBES_standard: {
    id: 'CONF_OLIGOS_PROBES_standard',
    defaultMessage: oligosStr,
  },
  CONF_OLIGOS_PROBES_iscaledna: {
    id: 'CONF_OLIGOS_PROBES_iscaledna',
    defaultMessage: oligosStr,
  },
  CONF_MILLIPLEX_LUMINEX: {
    id: 'CONF_MILLIPLEX_LUMINEX',
    defaultMessage: 'Multiplex Assays for Luminex',
  },
  CONF_STANDARD_TUBES_standard: {
    id: 'CONF_STANDARD_TUBES_standard',
    defaultMessage: 'DNA Oligos in Tubes',
  },
  CONF_MILLIPLEX: { id: 'CONF_MILLIPLEX', defaultMessage: 'Milliplex' },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_standard: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_standard',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters.',
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_iscaledna: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_iscaledna',
    defaultMessage:
      'Character limit is 30 including spaces. Do not use ASCII characters.',
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_easyoligo: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_easyoligo',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters.',
  },
  CONF_DNA_TUBES_TEMPLATE_standard: {
    id: 'CONF_DNA_TUBES_TEMPLATE_standard',
    defaultMessage: 'DNA_tubes_Template',
  },
  CONF_PCR_TEMPLATE_standard: {
    id: 'CONF_PCR_TEMPLATE_standard',
    defaultMessage: 'DNA_tubes_PCR_Template',
  },
  CONF_PCR_JP_TEMPLATE_standard: {
    id: 'CONF_PCR_JP_TEMPLATE_standard',
    defaultMessage: 'DNA_tubes_PCR_JP_Template',
  },
  CONF_DNA_TUBES_JP_TEMPLATE_standard: {
    id: 'CONF_DNA_TUBES_JP_TEMPLATE_standard',
    defaultMessage: 'DNA_tubes_JP_Template',
  },
  CONF_DNA_TUBES_MX_TEMPLATE_standard: {
    id: 'CONF_DNA_TUBES_MX_TEMPLATE_standard',
    defaultMessage: 'DNA_tubes_MX_Template',
  },
  CONF_DNA_TUBES_US_TEMPLATE_standard: {
    id: 'CONF_DNA_TUBES_US_TEMPLATE_standard',
    defaultMessage: 'DNA_tubes_US_Template',
  },
  CONF_CSR_TEMPLATE_standard: {
    id: 'CONF_CSR_TEMPLATE_standard',
    defaultMessage: '-csr.xlsx',
  },
  CONF_NON_CSR_TEMPLATE_standard: {
    id: 'CONF_NON_CSR_TEMPLATE_standard',
    defaultMessage: '.xlsx',
  },
  CONF_TEMPLATE_standard: {
    id: 'CONF_TEMPLATE_standard',
    defaultMessage: '_Template',
  },
  CONF_EXPECTED_YIELDS_POPUP_TITLE: {
    id: 'CONF_SYNTHESIS_SCALE_POPUP_TITLE',
    defaultMessage: 'Non-Modified Oligos (O.D./&mu;g)',
  },
  CONF_EXPECTED_YIELDS_POPUP_DESALT: {
    id: 'CONF_EXPECTED_YIELDS_POPUP_DESALT',
    defaultMessage: 'Desalt',
  },
  CONF_EXPECTED_YIELDS_POPUP_CARTRIDGE: {
    id: 'CONF_EXPECTED_YIELDS_POPUP_CARTRIDGE',
    defaultMessage: 'Cartridge',
  },
  CONF_EXPECTED_YIELDS_POPUP_HPLC: {
    id: 'CONF_EXPECTED_YIELDS_POPUP_HPLC',
    defaultMessage: 'HPLC',
  },
  CONF_SANGER_AMOUNT_TOOLTIP: {
    id: 'CONF_SANGER_AMOUNT_TOOLTIP',
    defaultMessage:
      '1 ug is provided at 20 ng/ul; all other amounts will have final concentration reported',
  },
  CONF_SANGER_TITER_TOOLTIP: {
    id: 'CONF_SANGER_TITER_TOOLTIP',
    defaultMessage:
      'This is the concentration of virus particles, measured by p24 ELISA.',
  },
  CONF_SANGER_VOLUME_TOOLTIP: {
    id: 'CONF_SANGER_VOLUME_TOOLTIP',
    defaultMessage: 'This is the total volume of virus particles chosen.',
  },
  CONF_SANGER_ALIQUOT_TOOLTIP: {
    id: 'CONF_SANGER_ALIQUOT_TOOLTIP',
    defaultMessage:
      'The number of vials and volume of each aliquot your total volume will be divided into.',
  },
  CONF_COPY_PASTE_TOOLTIPMSG_standard: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_standard',
    defaultMessage:
      "Comma delimited example: Oligo Name, 5'Mod, Sequence, 3'Mod, Scale(µmole), Purification, Format,Concentration(µM), Number of Tubes (Default = 1 tube)",
  },
  CONF_COPY_PASTE_TOOLTIPMSG_iscaledna: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_iscaledna',
    defaultMessage:
      "Comma delimited example: Oligo Name, 5'Mod, Sequence, 3' Mod, Amount, Purification, Number of tubes (Default = 1 tube), Salt Exchange, Filtration, Endotoxin Testing.",
  },
  CONF_COPY_PASTE_TOOLTIPMSG_rna: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_rna',
    defaultMessage:
      "Comma-separated example: Oligo Name, 5'Mod, Sequence, 3'Mod, Scale (µmol), Purification, Number of Tubes",
  },
  CONF_COPY_PASTE_TOOLTIPMSG_puresimple: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_puresimple',
    defaultMessage: 'Comma delimited example: Oligo Name, Sequence',
  },
  CONF_COPY_PASTE_TOOLTIPMSG_easyoligo: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_easyoligo',
    defaultMessage: 'Comma delimited example: Oligo Name, Sequence',
  },
  CONF_COPY_PASTE_TOOLTIPMSG_wellred: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_wellred',
    defaultMessage:
      "Comma delimited example: Oligo Name, 5'Mod, Sequence, Amount(OD), Purification, Number of Tubes per Oligo(Default = 1 tube)",
  },
  CONF_COPY_PASTE_TOOLTIPMSG_longoligo: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_longoligo',
    defaultMessage:
      "Comma delimited example: Oligo Name, 5'Mod, Sequence, 3'Mod, Purification, Yield",
  },
  CONF_COPY_PASTE_TOOLTIPMSG_BEACON: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_BEACON',
    defaultMessage:
      "Comma delimited example: Oligo Name, 5' Reporter / 3' Quencher Combination, Sequence (5' to 3'), Amount, Number of Tubes",
  },
  CONF_COPY_PASTE_TOOLTIPMSG_PROBE: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_PROBE',
    defaultMessage:
      "Comma delimited example: Oligo Name, 5' Reporter / 3' Quencher Combination, Sequence, Amount, Number of Tubes",
  },
  CONF_COPY_PASTE_TOOLTIPMSG_aqua: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_aqua',
    defaultMessage:
      'Comma delimited example: Peptide Name,N-Terminal Modification,Sequence,C-Terminal Modification',
  },
  CONF_COPY_PASTE_TOOLTIPMSG_JP_cpeptide: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_JP_cpeptide',
    defaultMessage:
      'Comma-separated example: Peptide Name, N-Terminal Modifications, Sequence, C-Terminal Modifications, Amount, Purity Level, Conjugation',
  },
  CONF_COPY_PASTE_TOOLTIPMSG_IL_cpeptide: {
    id: 'CONF_COPY_PASTE_TOOLTIPMSG_IL_cpeptide',
    defaultMessage:
      'Comma delimited example: Peptide Name,N-Terminal Modifications,Sequence,C-Terminal Modifications,Amount,Purity Level,Conjugation,Conjugation Amount,Conjugation Chemistry,Addittional Carrier Protien,Number of Tubes',
  },
  CONF_TOTAL_BASES_DNA_PLATES: {
    id: 'CONF_TOTAL_BASES_DNA_PLATES',
    defaultMessage: 'Total Bases ',
  },
  CONF_CHARGES_DNA_PLATES: {
    id: 'CONF_CHARGES_DNA_PLATES',
    defaultMessage: 'Additional fees may apply',
  },
  CONF_SELECT_NUMBER_DNA_PLATES: {
    id: 'CONF_SELECT_NUMBER_DNA_PLATES',
    defaultMessage: 'Select Number',
  },
  CONF_PLATE_SPECIFICATION_DNA_PLATES: {
    id: 'CONF_PLATE_SPECIFICATION_DNA_PLATES',
    defaultMessage: 'Plate Specification',
  },
  CONF_PACKAGING_OPTION_DNA_PLATES: {
    id: 'CONF_PACKAGING_OPTION_DNA_PLATES',
    defaultMessage: 'Packaging Option',
  },
  CONF_ADDITIONAL_SHIPPING_DNA_PLATES: {
    id: 'CONF_ADDITIONAL_SHIPPING_DNA_PLATES',
    defaultMessage: 'Additional Comments And Specifications (optional)',
  },
  CONF_NOTE_TEXT_DNA_PLATES: {
    id: 'CONF_NOTE_TEXT_DNA_PLATES',
    defaultMessage: 'Price displayed a subtotal amount',
  },
  CONF_POINT_TWO_DNA_PLATES: {
    id: 'CONF_POINT_TWO_DNA_PLATES',
    defaultMessage: 'Promotional codes can be added at checkout',
  },
  CONF_OLIGOS_dnaplate: {
    id: 'CONF_OLIGOS_dnaplate',
    defaultMessage: 'Oligos',
  },
  CONF_OLIGOS_duplexplate: {
    id: 'CONF_OLIGOS_duplexplate',
    defaultMessage: 'Duplexes',
  },
  CONF_OLIGO_NAME: { id: 'CONF_OLIGO_NAME', defaultMessage: 'name:' },
  CONF_NGSO_COPY_PASTE_EXAMPLE_ngsotubes: {
    id: 'CONF_NGSO_COPY_PASTE_EXAMPLE_ngsotubes',
    defaultMessage:
      "Example: Oligo Name, 5' Mod, Sequence, 3'Mod, Scale (µmole), Format.",
  },
  CONF_NGSO_COPY_PASTE_EXAMPLE_ngsoplates: {
    id: 'CONF_NGSO_COPY_PASTE_EXAMPLE_ngsoplates',
    defaultMessage:
      "Example: Row, Column, Oligo Name, 5' Mod, Sequence, 3'Mod, Format.",
  },
  CONF_BI_TUBE_TITLE: { id: 'CONF_BI_TUBE_TITLE', defaultMessage: 'BiTube' },
  CONF_TITLE_duplexplate: {
    id: 'CONF_TITLE_duplexplate',
    defaultMessage: 'SiRNA in Plates',
  },
  CONF_TITLE_dnaplate: {
    id: 'CONF_TITLE_dnaplate',
    defaultMessage: 'DNA Oligos in Plates',
  },
  CONF_SUBSTANCE_DETAILS_TITLE: {
    id: 'CONF_SUBSTANCE_DETAILS_TITLE',
    defaultMessage: 'Substance Details',
  },
  CONF_PLATES_duplexplate: {
    id: 'CONF_PLATES_duplexplate',
    defaultMessage: 'siRNA duplexes in Plates',
  },
  CONF_PLATES_dnaplate: {
    id: 'CONF_PLATES_dnaplate',
    defaultMessage: 'DNA Oligos in Plates',
  },
  CONF_DNAPLATES_CUSTOM_DNA_PLATES_dnaplate: {
    id: 'CONF_DNAPLATES_CUSTOM_DNA_PLATES_dnaplate',
    defaultMessage: 'Custom DNA In Plates',
  },
  CONF_DNAPLATES_CUSTOM_DNA_PLATES_duplexplate: {
    id: 'CONF_DNAPLATES_CUSTOM_DNA_PLATES_duplexplate',
    defaultMessage: 'Custom siRNA duplexes in Plates',
  },
  CONF_DNAPLATES_WELLS: {
    id: 'CONF_DNAPLATES_WELLS',
    defaultMessage: 'Wells: ',
  },
  CONF_DNAPLATES_CHANNEL: {
    id: 'CONF_DNAPLATES_CHANNEL',
    defaultMessage: 'Channels: ',
  },
  CONF_ISCALE_DNA_AMOUNT_MEASURE: {
    id: 'CONF_ISCALE_DNA_AMOUNT_MEASURE',
    defaultMessage: ' mg',
  },
  CONF_DNAPLATES_ORDER_SUMMARY_SHALLOW_WELL: {
    id: 'CONF_DNAPLATES_ORDER_SUMMARY_SHALLOW_WELL',
    defaultMessage: 'Shallow well (40 µLJ)',
  },
  CONF_DNAPLATES_SUMMARY_ACKNOWLEDGE: {
    id: 'CONF_DNAPLATES_SUMMARY_ACKNOWLEDGE',
    defaultMessage: 'Acknowledge: ',
  },
  CONF_ITEM_SELECTION: {
    id: 'CONF_ITEM_SELECTION',
    defaultMessage: 'Select Clones',
  },
  CONF_REVIEW_ORDER_crisprgrna: {
    id: 'CONF_REVIEW_ORDER_crisprgrna',
    defaultMessage: 'Review & Confirm',
  },
  CONF_CRISPR_gRNA_NAME_crisprgrna: {
    id: 'CONF_CRISPR_gRNA_NAME_crisprgrna',
    defaultMessage: 'crisprgrna',
  },
  CONF_SPECIFICATION_CRISPR_SPECIES_SpCas9_crisprgrna: {
    id: 'CONF_SPECIFICATION_CRISPR_SPECIES_SpCas9_crisprgrna',
    defaultMessage: 'SpCas9',
  },
  CONF_SPECIFICATION_CRISPR_SPECIES_FnCas9_crisprgrna: {
    id: 'CONF_SPECIFICATION_CRISPR_SPECIES_FnCas9_crisprgrna',
    defaultMessage: 'FnCas9 (For non-cellular,synthetic applications)',
  },
  CONF_SPECIFICATION_STRUCTURE_crRNA_crisprgrna: {
    id: 'CONF_SPECIFICATION_STRUCTURE_crRNA_crisprgrna',
    defaultMessage: 'crRNA(tracrRNA sold seperately)',
  },
  CONF_SPECIFICATION_SYNTHESIS_SCALE_2nmol_crisprgrna: {
    id: 'CONF_SPECIFICATION_SYNTHESIS_SCALE_2nmol_crisprgrna',
    defaultMessage: '2 nmol',
  },
  CONF_SPECIFICATION_SYNTHESIS_SCALE_5nmol_crisprgrna: {
    id: 'CONF_SPECIFICATION_SYNTHESIS_SCALE_5nmol_crisprgrna',
    defaultMessage: '5 nmol',
  },
  CONF_SPECIFICATION_MODIFIED_YES_crisprgrna: {
    id: 'CONF_SPECIFICATION_MODIFIED_YES_crisprgrna',
    defaultMessage: 'Yes',
  },
  CONF_SPECIFICATION_MODIFIED_NO_crisprgrna: {
    id: 'CONF_SPECIFICATION_MODIFIED_NO_crisprgrna',
    defaultMessage: 'No',
  },
  CONF_SPECIFICATION_PURIFICATION_DESALT_crisprgrna: {
    id: 'CONF_SPECIFICATION_PURIFICATION_DESALT_crisprgrna',
    defaultMessage: 'DESALT',
  },
  CONF_SPECIFICATION_PURIFICATION_HPLC_crisprgrna: {
    id: 'CONF_SPECIFICATION_PURIFICATION_HPLC_crisprgrna',
    defaultMessage: 'HPLC',
  },
  CONF_SANGER_ERROR_POPUP_sangercrispr: {
    id: 'CONF_SANGER_ERROR_POPUP_sangercrispr',
    defaultMessage: 'Please select a gRNA before proceeding to next step',
  },
  CONF_PRODUCT_SEARCH: {
    id: 'CONF_PRODUCT_SEARCH',
    defaultMessage: 'Product Search',
  },
  CONF_SPECIFICATIONS_sangerCrispr: {
    id: 'CONF_SPECIFICATIONS_sangerCrispr',
    defaultMessage: 'Specifications',
  },
  CONF_REVIEW_ORDER_sangerCrispr: {
    id: 'CONF_REVIEW_ORDER_sangerCrispr',
    defaultMessage: 'Review & Confirm',
  },
  CONF_SANGER_CRISPR_CLONES_NAME_sangerCrispr: {
    id: 'CONF_SANGER_CRISPR_CLONES_NAME_sangerCrispr',
    defaultMessage: 'sangercrispr',
  },
  CONF_SPEC_SANGER_GLYCEROL_sangercrisprclones: {
    id: 'CONF_SPEC_SANGER_GLYCEROL_sangercrisprclones',
    defaultMessage: 'Sanger Bacterial Glycerol Stock',
  },
  CONF_SPEC_VIRAL_TITER_10P6_sangercrisprclones: {
    id: 'CONF_SPEC_VIRAL_TITER_10P6_sangercrisprclones',
    defaultMessage: '10^6 Particles/ml',
  },
  CONF_SPEC_VIRAL_TITER_10P7_sangercrisprclones: {
    id: 'CONF_SPEC_VIRAL_TITER_10P7_sangercrisprclones',
    defaultMessage: '10^7 Particles/ml',
  },
  CONF_SPEC_VIRAL_TITER_10P8_sangercrisprclones: {
    id: 'CONF_SPEC_VIRAL_TITER_10P8_sangercrisprclones',
    defaultMessage: '10^8 Particles/ml',
  },
  CONF_SPEC_VIRAL_TITER_10P9_sangercrisprclones: {
    id: 'CONF_SPEC_VIRAL_TITER_10P9_sangercrisprclones',
    defaultMessage: '10^9 Particles/ml',
  },
  CONF_SPEC_VOLUME_sangercrisprclones: {
    id: 'CONF_SPEC_VOLUME_sangercrisprclones',
    defaultMessage: 'Volume',
  },
  CONF_SPEC_VOLUME_200μl_sangercrisprclones: {
    id: 'CONF_SPEC_VOLUME_200μl_sangercrisprclones',
    defaultMessage: '200 μl',
  },
  CONF_SPEC_VOLUME_1ml_sangercrisprclones: {
    id: 'CONF_SPEC_VOLUME_1ml_sangercrisprclones',
    defaultMessage: '1 ml',
  },
  CONF_SPEC_VOLUME_2ml_sangercrisprclones: {
    id: 'CONF_SPEC_VOLUME_2ml_sangercrisprclones',
    defaultMessage: '2 ml',
  },
  CONF_SPEC_VOLUME_5ml_sangercrisprclones: {
    id: 'CONF_SPEC_VOLUME_5ml_sangercrisprclones',
    defaultMessage: '5 ml',
  },
  CONF_SPEC_ALIQUOTING_sangercrisprclones: {
    id: 'CONF_SPEC_ALIQUOTING_sangercrisprclones',
    defaultMessage: 'Aliquoting',
  },
  CONF_SPEC_ALIQUOTING_1X200μl_sangercrisprclones: {
    id: 'CONF_SPEC_ALIQUOTING_1X200μl_sangercrisprclones',
    defaultMessage: '1x200 μl',
  },
  CONF_SPEC_ALIQUOTING_2X100μl_sangercrisprclones: {
    id: 'CONF_SPEC_ALIQUOTING_2X100μl_sangercrisprclones',
    defaultMessage: '2x100 μl',
  },
  CONF_SPEC_ALIQUOTING_4X50μl_sangercrisprclones: {
    id: 'CONF_SPEC_ALIQUOTING_4X50μl_sangercrisprclones',
    defaultMessage: '4x50 μl',
  },
  CONF_SPEC_ALIQUOTING_8X25μl_sangercrisprclones: {
    id: 'CONF_SPEC_ALIQUOTING_8X25μl_sangercrisprclones',
    defaultMessage: '8x25 μl',
  },
  CONF_SELECT_REQUIRED_FIELD_sangercrisprclones: {
    id: 'CONF_SELECT_REQUIRED_FIELD_sangercrisprclones',
    defaultMessage: 'Please select the Required Fields',
  },
  CONF_GRNA_ERROR_POPUP_sangercrisprclones: {
    id: 'CONF_GRNA_ERROR_POPUP_sangercrisprclones',
    defaultMessage:
      'Please select Sanger CRISPR Clones before proceeding to next step',
  },
  CONF_SELECT_CLONES_FILTER_RESULTS_HELP_TEXT_sangerCrispr: {
    id: 'CONF_SELECT_CLONES_FILTER_RESULTS_HELP_TEXT_sangerCrispr',
    defaultMessage: 'Check the box next to the species you’d like to target',
  },
  CONF_SELECT_CLONES_SANGER_VECTOR_HELP_TEXT_sangerCrispr: {
    id: 'CONF_SELECT_CLONES_SANGER_VECTOR_HELP_TEXT_sangerCrispr',
    defaultMessage: 'View vector map and features at',
  },
  CONF_SELECT_CLONES_SANGER_VECTOR_HELP_TEXT_LINK_sangerCrispr: {
    id: 'CONF_SELECT_CLONES_SANGER_VECTOR_HELP_TEXT_LINK_sangerCrispr',
    defaultMessage: 'CRISPR Clone, Control, and Cas9 Essentials.',
  },
  CONF_SEARCH_GENES: {
    id: 'CONF_SEARCH_GENES',
    defaultMessage: 'Search Genes',
  },
  CONF_HUMAN: { id: 'CONF_HUMAN', defaultMessage: 'Human' },
  CONF_MOUSE: { id: 'CONF_MOUSE', defaultMessage: 'Mouse' },
  CONF_SEARCH_TERM: { id: 'CONF_SEARCH_TERM', defaultMessage: 'Search Term' },
  CONF_SEARCH_MESSAGE: {
    id: 'CONF_SEARCH_MESSAGE',
    defaultMessage:
      'Search by Gene Symbol, RefSeq or Gene ID (enter up to 100 items separated by spaces)',
  },
  CONF_SEARCH_MESSAGE_CRISPR: {
    id: 'CONF_SEARCH_MESSAGE_CRISPR',
    defaultMessage:
      'Search by Gene Symbol, Clone ID or Gene ID (enter up to 100 items separated by spaces)',
  },
  CONF_CHECKED_HUMAN: {
    id: 'CONF_CHECKED_HUMAN',
    defaultMessage: 'checkedHuman',
  },
  CONF_CHECKED_MOUSE: {
    id: 'CONF_CHECKED_MOUSE',
    defaultMessage: 'checkdMouse',
  },
  CONF_Pre_Designed_Control_crisprgrna: {
    id: 'CONF_Pre_Designed_Control_crisprgrna',
    defaultMessage: 'Predesigned Controls',
  },
  CONF_Crispr_Search_Criteria_crisprgrna: {
    id: 'CONF_Crispr_Search_Criteria_crisprgrna',
    defaultMessage: 'Search Criteria',
  },
  CONF_Crispr_Search_Criteria_sangercrisprclones: {
    id: 'CONF_Crispr_Search_Criteria_sangercrisprclones',
    defaultMessage: 'Search Criteria',
  },
  CONF_Pre_Designed_gRNA_crisprgrna: {
    id: 'CONF_Pre_Designed_gRNA_crisprgrna',
    defaultMessage: 'Predesigned gRNAs',
  },
  CONF_FILTER_RESULT_crisprgrna: {
    id: 'CONF_FILTER_RESULT_crisprgrna',
    defaultMessage: 'Filter Results',
  },
  CONF_SANGERVECTOR_RESULT_sangercrisprclones: {
    id: 'CONF_SANGERVECTOR_RESULT_sangercrisprclones',
    defaultMessage: 'Sanger Vector',
  },
  CONF_SEARCH_TERMS: {
    id: 'CONF_SEARCH_TERMS',
    defaultMessage: 'Search Terms',
  },
  CONF_HUMAN_crisprgrna: {
    id: 'CONF_HUMAN_crisprgrna',
    defaultMessage: 'Human',
  },
  CONF_MOUSE_crisprgrna: {
    id: 'CONF_MOUSE_crisprgrna',
    defaultMessage: 'Mouse',
  },
  CONF_CATEGORY_crisprgrna: {
    id: 'CONF_CATEGORY_crisprgrna',
    defaultMessage: 'gRNA Category',
  },
  CONF_GENESYM_crisprgrna: {
    id: 'CONF_GENESYM_crisprgrna',
    defaultMessage: 'GeneSym',
  },
  CONF_GENE_ID_crisprgrna: {
    id: 'CONF_GENE_ID_crisprgrna',
    defaultMessage: 'Gene ID',
  },
  CONF_EFFICIENCY_crisprgrna: {
    id: 'CONF_EFFICIENCY_crisprgrna',
    defaultMessage: 'Efficiency',
  },
  CONF_SPECIFICITY_crisprgrna: {
    id: 'CONF_SPECIFICITY_crisprgrna',
    defaultMessage: 'Specificity',
  },
  CONF_SPECIES_crisprgrna: {
    id: 'CONF_SPECIES_crisprgrna',
    defaultMessage: 'Species',
  },
  CONF_OVER_HANG_TEXT: {
    id: 'CONF_OVER_HANG_TEXT',
    defaultMessage: 'customerOverHang',
  },
  CONF_SPECIFICATION_MODIFIED_HELP_TEXT_crisprgrna: {
    id: 'CONF_SPECIFICATION_MODIFIED_HELP_TEXT_crisprgrna',
    defaultMessage:
      "Chemically modified synthetic gRNA contain stabilizing 2'-O-methyl and phosphorothioate linkages",
  },
  CONF_OPTIONAL_3_MOD: {
    id: 'CONF_OPTIONAL_3_MOD',
    defaultMessage: "3' Modifications",
  },
  CONF_PRODUCT_rna: { id: 'CONF_PRODUCT_rna', defaultMessage: 'rna' },
  CONF_OPTIONAL_THREE_MOD: {
    id: 'CONF_OPTIONAL_THREE_MOD',
    defaultMessage: 'threeMod',
  },
  CONF_OPTIONAL_FIVE_MOD: {
    id: 'CONF_OPTIONAL_FIVE_MOD',
    defaultMessage: 'fiveMod',
  },
  CONF_PRODUCT_PROBE: { id: 'CONF_PRODUCT_PROBE', defaultMessage: 'PROBE' },
  CONF_OPTIONAL_QUENCHER_MOD: {
    id: 'CONF_OPTIONAL_QUENCHER_MOD',
    defaultMessage: 'reporterQuencher',
  },
  CONF_PRODUCT_AQUA: { id: 'CONF_PRODUCT_AQUA', defaultMessage: 'aqua' },
  CONF_AQUA_N_TERMINAL_MOD: {
    id: 'CONF_AQUA_N_TERMINAL_MOD',
    defaultMessage: 'nterminalMod',
  },
  CONF_AQUA_C_TERMINAL_MOD: {
    id: 'CONF_AQUA_C_TERMINAL_MOD',
    defaultMessage: 'cterminalMod',
  },
  CONF_AQUA_SPEC_POPUP_TITLE: {
    id: 'CONF_AQUA_SPEC_POPUP_TITLE',
    defaultMessage:
      'Greyed out Options are unavailable based upon your sequence',
  },
  CONF_HOME_rna: { id: 'CONF_HOME_rna', defaultMessage: 'Home' },
  CONF_HOME_aqua: { id: 'CONF_HOME_aqua', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_rna: {
    id: 'CONF_CUSTOM_PRODUCTS_rna',
    defaultMessage: customProductsStr,
  },
  CONF_CUSTOM_PRODUCTS_aqua: {
    id: 'CONF_CUSTOM_PRODUCTS_aqua',
    defaultMessage: customProductsStr,
  },
  CONF_OLIGOS_PROBES_rna: {
    id: 'CONF_OLIGOS_PROBES_rna',
    defaultMessage: 'RNA Oligos, Gene Knockout, Knockdown & Expression',
  },
  CONF_OLIGOS_PROBES_longoligo: {
    id: 'CONF_OLIGOS_PROBES_longoligo',
    defaultMessage: oligosStr,
  },
  CONF_OLIGOS_PROBES_puresimple: {
    id: 'CONF_OLIGOS_PROBES_puresimple',
    defaultMessage: oligosStr,
  },
  CONF_OLIGOS_PROBES_easyoligo: {
    id: 'CONF_OLIGOS_PROBES_easyoligo',
    defaultMessage: oligosStr,
  },
  CONF_OLIGOS_PROBES_cpeptide: {
    id: 'CONF_OLIGOS_PROBES_cpeptide',
    defaultMessage: 'Peptides',
  },
  CONF_OLIGOS_PROBES_aqua: {
    id: 'CONF_OLIGOS_PROBES_aqua',
    defaultMessage: 'Peptides',
  },
  CONF_STANDARD_TUBES_rna: {
    id: 'CONF_STANDARD_TUBES_rna',
    defaultMessage: 'RNA Oligos',
  },
  CONF_STANDARD_TUBES_aqua: {
    id: 'CONF_STANDARD_TUBES_aqua',
    defaultMessage: 'AQUA™ Peptides',
  },
  CONF_SEQUENCE_ENTRY_rna: {
    id: 'CONF_SEQUENCE_ENTRY_rna',
    defaultMessage: sequenceEntryStr,
  },
  CONF_SEQUENCE_ENTRY_aqua: {
    id: 'CONF_SEQUENCE_ENTRY_aqua',
    defaultMessage: sequenceEntryStr,
  },
  CONF_CONFIRM_ORDER_rna: {
    id: 'CONF_CONFIRM_ORDER_rna',
    defaultMessage: reviewStr,
  },
  CONF_CONFIRM_ORDER_aqua: {
    id: 'CONF_CONFIRM_ORDER_aqua',
    defaultMessage: reviewStr,
  },
  CONF_TITLE_iscaledna: {
    id: 'CONF_TITLE_iscaledna',
    defaultMessage: 'iScale Oligos™ (mg & g quantity)',
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_rna: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_rna',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters.',
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_aqua: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_aqua',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters.',
  },
  CONF_SEQUENCE_MESSAGE_rna: {
    id: 'CONF_SEQUENCE_MESSAGE_rna',
    defaultMessage:
      "Insert an asterisk '*' between bases that are to be phosphorothioated.",
  },
  CONF_SEQUENCE_MESSAGE_aqua: {
    id: 'CONF_SEQUENCE_MESSAGE_aqua',
    defaultMessage:
      'Sequence can contain only one stable isotopically labeled amino acid.',
  },
  CONF_GRNA_ERROR_POPUP_crispgrna: {
    id: 'CONF_GRNA_ERROR_POPUP_crispgrna',
    defaultMessage:
      'Please select either Predesigned Controls or Predesigned gRNAs before proceeding to next step',
  },
  CONF_MANUAL_SEARCH_1_ERROR_POPUP_crispgrna: {
    id: 'CONF_MANUAL_SEARCH_1_ERROR_POPUP_crispgrna',
    defaultMessage: 'We are sorry, but your search query "',
  },
  CONF_MANUAL_SEARCH_2_ERROR_POPUP_crispgrna: {
    id: 'CONF_MANUAL_SEARCH_2_ERROR_POPUP_crispgrna',
    defaultMessage:
      '" returned no results. Please review your query and try again.',
  },
  CONF_SYNTHETIC_RNA_crispgrna: {
    id: 'CONF_SYNTHETIC_RNA_crispgrna',
    defaultMessage: 'RNA',
  },
  CONF_LENTIVIRUS_crispgrna: {
    id: 'CONF_LENTIVIRUS_crispgrna',
    defaultMessage: 'VIRUS',
  },
  CONF_PLASMID_DNA_crispgrna: {
    id: 'CONF_PLASMID_DNA_crispgrna',
    defaultMessage: 'DNA',
  },
  CONF_VIRUS_TITER_SPECIFICATION_crispgrna: {
    id: 'CONF_VIRUS_TITER_SPECIFICATION_crispgrna',
    defaultMessage: 'Titer',
  },
  CONF_FILE_UPLOAD_crispgrna: {
    id: 'CONF_FILE_UPLOAD_crispgrna',
    defaultMessage: 'Upload your saved sequence file here (.xls format only) ',
  },
  CONF_GRNA_CATEGORY_crispgrna: {
    id: 'CONF_GRNA_CATEGORY_crispgrna',
    defaultMessage: 'gRNA Category',
  },
  CONF_MISSION_GRNA_ID_LABEL_crispgrna: {
    id: 'CONF_MISSION_GRNA_ID_LABEL_crispgrna',
    defaultMessage: 'MISSION ™ gRNA ID',
  },
  CONF_GENE_SYM_LABEL_crispgrna: {
    id: 'CONF_GENE_SYM_LABEL_crispgrna',
    defaultMessage: 'Gene Symbol',
  },
  CONF_GENE_ID_LABEL_crispgrna: {
    id: 'CONF_GENE_ID_LABEL_crispgrna',
    defaultMessage: 'Gene ID',
  },
  CONF_EFFICIENCY_LABEL_crispgrna: {
    id: 'CONF_EFFICIENCY_LABEL_crispgrna',
    defaultMessage: 'Efficiency Score',
  },
  CONF_SPECIFICATION_LABEL_crispgrna: {
    id: 'CONF_SPECIFICATION_LABEL_crispgrna',
    defaultMessage: 'Specificity Score',
  },
  CONF_SPECIES_LABEL_crispgrna: {
    id: 'CONF_SPECIES_LABEL_crispgrna',
    defaultMessage: 'Species',
  },
  CONF_HOME_PROBE: { id: 'CONF_HOME_PROBE', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_PROBE: {
    id: 'CONF_CUSTOM_PRODUCTS_PROBE',
    defaultMessage: customProductsStr,
  },
  CONF_STANDARD_TUBES_PROBE: {
    id: 'CONF_STANDARD_TUBES_PROBE',
    defaultMessage: 'Dual-Labeled Probes',
  },
  CONF_STANDARD_TUBES_PROBE_NEW: {
    id: 'CONF_STANDARD_TUBES_PROBE_NEW',
    defaultMessage: 'Dual-Labeled, Internal-Quenched & Dual-Quenched Probes',
  },
  CONF_SEQUENCE_MESSAGE_PROBE: {
    id: 'CONF_SEQUENCE_MESSAGE_PROBE',
    defaultMessage: 'DNA bases only',
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_PROBE: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_PROBE',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters',
  },
  CONF_SEQUENCE_ENTRY_PROBE: {
    id: 'CONF_SEQUENCE_ENTRY_PROBE',
    defaultMessage: sequenceEntryStr,
  },
  CONF_CONFIRM_ORDER_PROBE: {
    id: 'CONF_CONFIRM_ORDER_PROBE',
    defaultMessage: reviewStr,
  },
  CONF_OVERHANG_UU_VAL: { id: 'CONF_OVERHANG_UU_VAL', defaultMessage: 'UU' },
  CONF_BITUBE_TEMPLATE_FASTDUPLEX: {
    id: 'CONF_BITUBE_TEMPLATE_FASTDUPLEX',
    defaultMessage: 'FASTDUPLEX_Template',
  },
  CONF_HOME_wellred: { id: 'CONF_HOME_wellred', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_wellred: {
    id: 'CONF_CUSTOM_PRODUCTS_wellred',
    defaultMessage: customProductsStr,
  },
  CONF_OLIGOS_PROBES_wellred: {
    id: 'CONF_OLIGOS_PROBES_wellred',
    defaultMessage: oligosStr,
  },
  CONF_STANDARD_TUBES_wellred: {
    id: 'CONF_STANDARD_TUBES_wellred',
    defaultMessage: 'WellRED Oligos',
  },
  CONF_SEQUENCE_ENTRY_wellred: {
    id: 'CONF_SEQUENCE_ENTRY_wellred',
    defaultMessage: sequenceEntryStr,
  },
  CONF_CONFIRM_ORDER_wellred: {
    id: 'CONF_CONFIRM_ORDER_wellred',
    defaultMessage: reviewStr,
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_wellred: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_wellred',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters',
  },
  CONF_SEQUENCE_MESSAGE_wellred: {
    id: 'CONF_SEQUENCE_MESSAGE_wellred',
    defaultMessage: 'DNA bases only',
  },
  CONF_PRODUCT_wellred: {
    id: 'CONF_PRODUCT_wellred',
    defaultMessage: 'wellred',
  },
  CONF_AMBIENT_EASY_OLIGO: {
    id: 'CONF_AMBIENT_EASY_OLIGO',
    defaultMessage: 'Ambient ',
  },
  CONF_SEQUENCE_TYPE_aqua: {
    id: 'CONF_SEQUENCE_TYPE_aqua',
    defaultMessage: '(N-Term to C-Term)',
  },
  CONF_SEQUENCE_TYPE_iscaledna: {
    id: 'CONF_SEQUENCE_TYPE_iscaledna',
    defaultMessage: '(5’ to 3’)',
  },
  CONF_SEQUENCE_INFORMATION_aqua: {
    id: 'CONF_SEQUENCE_INFORMATION_aqua',
    defaultMessage: sequenceEntryStr,
  },
  CONF_SEQUENCE_INFORMATION_iscaledna: {
    id: 'CONF_SEQUENCE_INFORMATION_iscaledna',
    defaultMessage: sequenceInfoStr,
  },
  CONF_OLIGO_NAME_wellred: {
    id: 'CONF_OLIGO_NAME_wellred',
    defaultMessage: 'Oligo Name:',
  },
  CONF_SEQUENCE_TYPE_wellred: {
    id: 'CONF_SEQUENCE_TYPE_wellred',
    defaultMessage: fiveFootStr,
  },
  CONF_SEQUENCE_INFORMATION_wellred: {
    id: 'CONF_SEQUENCE_INFORMATION_wellred',
    defaultMessage: sequenceInfoStr,
  },
  CONF_OLIGO_NAME_PROBE: {
    id: 'CONF_OLIGO_NAME_PROBE',
    defaultMessage: 'Oligo Name:',
  },
  CONF_SEQUENCE_TYPE_PROBE: {
    id: 'CONF_SEQUENCE_TYPE_PROBE',
    defaultMessage: fiveFootStr,
  },
  CONF_SEQUENCE_INFORMATION_PROBE: {
    id: 'CONF_SEQUENCE_INFORMATION_PROBE',
    defaultMessage: sequenceInfoStr,
  },
  CONF_OLIGO_NAME_easyoligo: {
    id: 'CONF_OLIGO_NAME_easyoligo',
    defaultMessage: oligoNameStr,
  },
  CONF_SEQUENCE_TYPE_easyoligo: {
    id: 'CONF_SEQUENCE_TYPE_easyoligo',
    defaultMessage: fiveFootStr,
  },
  CONF_SEQUENCE_INFORMATION_easyoligo: {
    id: 'CONF_SEQUENCE_INFORMATION_easyoligo',
    defaultMessage: sequenceInfoStr,
  },
  CONF_OLIGO_NAME_rna: {
    id: 'CONF_OLIGO_NAME_rna',
    defaultMessage: 'Oligo Name:',
  },
  CONF_SEQUENCE_TYPE_rna: {
    id: 'CONF_SEQUENCE_TYPE_rna',
    defaultMessage: fiveFootStr,
  },
  CONF_SEQUENCE_INFORMATION_rna: {
    id: 'CONF_SEQUENCE_INFORMATION_rna',
    defaultMessage: sequenceInfoStr,
  },
  CONF_SEQUENCE_TYPE_standard: {
    id: 'CONF_SEQUENCE_TYPE_standard',
    defaultMessage: fiveFootStr,
  },
  CONF_SEQUENCE_INFORMATION_standard: {
    id: 'CONF_SEQUENCE_INFORMATION_standard',
    defaultMessage: sequenceInfoStr,
  },
  CONF_OLIGOS_PROBES_PROBE: {
    id: 'CONF_OLIGOS_PROBES_PROBE',
    defaultMessage: oligosStr,
  },
  CONF_HOME_cpeptide: { id: 'CONF_HOME_cpeptide', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_cpeptide: {
    id: 'CONF_CUSTOM_PRODUCTS_cpeptide',
    defaultMessage: customProductsStr,
  },
  CONF_STANDARD_TUBES_cpeptide: {
    id: 'CONF_STANDARD_TUBES_cpeptide',
    defaultMessage: 'Custom Peptide',
  },
  CONF_SEQUENCE_MESSAGE_cpeptide: {
    id: 'CONF_SEQUENCE_MESSAGE_cpeptide',
    defaultMessage: 'DNA bases only',
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_cpeptide: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_cpeptide',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters',
  },
  CONF_SEQUENCE_ENTRY_cpeptide: {
    id: 'CONF_SEQUENCE_ENTRY_cpeptide',
    defaultMessage: sequenceEntryStr,
  },
  CONF_CONFIRM_ORDER_cpeptide: {
    id: 'CONF_CONFIRM_ORDER_cpeptide',
    defaultMessage: reviewStr,
  },
  CONF_DNA_OLIGOS_IN_TUBES_cpeptide: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_cpeptide',
    defaultMessage: 'Custom Peptide',
  },
  CONF_INTERNAL_MOD: { id: 'CONF_INTERNAL_MOD', defaultMessage: 'internalMod' },
  CONF_SEQUENCE_TYPE_cpeptide: {
    id: 'CONF_SEQUENCE_TYPE_cpeptide',
    defaultMessage: '(N-Term to C-Term)',
  },
  CONF_OLIGO_NAME_cpeptide: {
    id: 'CONF_OLIGO_NAME_cpeptide',
    defaultMessage: 'Peptide Name:',
  },
  CONF_SEQUENCE_INFORMATION_cpeptide: {
    id: 'CONF_SEQUENCE_INFORMATION_cpeptide',
    defaultMessage: sequenceInfoStr,
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_rna: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_rna',
    defaultMessage: maxStr,
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_PROBE: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_PROBE',
    defaultMessage: maxStr,
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_easyoligo: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_easyoligo',
    defaultMessage: maxStr,
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_wellred: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_wellred',
    defaultMessage: maxStr,
  },
  CONF_MY_OLIGOS_SIDE_BAR_standard: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_standard',
    defaultMessage: 'My Oligos ',
  },
  CONF_MY_OLIGOS_SIDE_BAR_iscaledna: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_iscaledna',
    defaultMessage: 'My Oligos ',
  },
  CONF_MY_OLIGOS_SIDE_BAR_rna: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_rna',
    defaultMessage: 'My Oligos ',
  },
  CONF_MY_OLIGOS_SIDE_BAR_PROBE: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_PROBE',
    defaultMessage: 'My Oligos ',
  },
  CONF_MY_OLIGOS_SIDE_BAR_easyoligo: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_easyoligo',
    defaultMessage: 'My Oligos ',
  },
  CONF_MY_OLIGOS_SIDE_BAR_wellred: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_wellred',
    defaultMessage: 'My Oligos ',
  },
  CONF_ADD_OLIGO_SIDE_BAR_standard: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_standard',
    defaultMessage: 'Add Oligo ',
  },
  CONF_ADD_OLIGO_SIDE_BAR_iscaledna: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_iscaledna',
    defaultMessage: 'Add Oligo ',
  },
  CONF_ADD_OLIGO_SIDE_BAR_aqua: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_aqua',
    defaultMessage: 'Add Peptide ',
  },
  CONF_ADD_OLIGO_SIDE_BAR_rna: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_rna',
    defaultMessage: 'Add Oligo ',
  },
  CONF_ADD_OLIGO_SIDE_BAR_PROBE: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_PROBE',
    defaultMessage: 'Add Oligo ',
  },
  CONF_ADD_OLIGO_SIDE_BAR_easyoligo: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_easyoligo',
    defaultMessage: 'Add Oligo ',
  },
  CONF_ADD_OLIGO_SIDE_BAR_wellred: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_wellred',
    defaultMessage: 'Add Oligo ',
  },
  CONF_BASE_COUNT_iscaledna: {
    id: 'CONF_BASE_COUNT_iscaledna',
    defaultMessage: baseCountStr,
  },
  CONF_BASE_COUNT_aqua: {
    id: 'CONF_BASE_COUNT_aqua',
    defaultMessage: 'Amino Acid Count: ',
  },
  CONF_BASE_COUNT_rna: {
    id: 'CONF_BASE_COUNT_rna',
    defaultMessage: baseCountStr,
  },
  CONF_BASE_COUNT_PROBE: {
    id: 'CONF_BASE_COUNT_PROBE',
    defaultMessage: baseCountStr,
  },
  CONF_BASE_COUNT_easyoligo: {
    id: 'CONF_BASE_COUNT_easyoligo',
    defaultMessage: baseCountStr,
  },
  CONF_BASE_COUNT_wellred: {
    id: 'CONF_BASE_COUNT_wellred',
    defaultMessage: baseCountStr,
  },
  CONF_PEPTIDE_NAME_standard: {
    id: 'CONF_PEPTIDE_NAME_standard',
    defaultMessage: 'Peptide Name:',
  },
  CONF_PEPSCREEN_RESEARCHER: {
    id: 'CONF_PEPSCREEN_RESEARCHER',
    defaultMessage: 'Researcher Name:',
  },
  CONF_PEPSCREEN_PEPTIDE_SPECIFICATION: {
    id: 'CONF_PEPSCREEN_PEPTIDE_SPECIFICATION',
    defaultMessage: 'Peptide Specification',
  },
  CONF_PEPSCREEN_MESSAGE: {
    id: 'CONF_PEPSCREEN_MESSAGE',
    defaultMessage:
      'Error: Invalid format. Please check the template and try again.',
  },
  CONF_PEPSCREEN_YES_TEXT: {
    id: 'CONF_PEPSCREEN_YES_TEXT',
    defaultMessage: 'Yes',
  },
  CONF_PEPSCREEN_NO_TEXT: {
    id: 'CONF_PEPSCREEN_NO_TEXT',
    defaultMessage: 'No',
  },
  CONF_PEPSCREEN_HEADER_TEXT: {
    id: 'CONF_PEPSCREEN_HEADER_TEXT',
    defaultMessage: 'PEPScreen Custom Peptide Library',
  },
  CONF_PEPSCREEN_DOWNLOAD: {
    id: 'CONF_PEPSCREEN_DOWNLOAD',
    defaultMessage: 'Download the Plate Ordering Template:',
  },
  CONF_DNA_OLIGOS_IN_TUBES_BEACON: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_BEACON',
    defaultMessage: 'Molecular Beacons',
  },
  CONF_HOME_BEACON: { id: 'CONF_HOME_BEACON', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_BEACON: {
    id: 'CONF_CUSTOM_PRODUCTS_BEACON',
    defaultMessage: customProductsStr,
  },
  CONF_BASE_COUNT_BEACON: {
    id: 'CONF_BASE_COUNT_BEACON',
    defaultMessage: baseCountStr,
  },
  CONF_ADD_OLIGO_SIDE_BAR_BEACON: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_BEACON',
    defaultMessage: 'Add Oligo ',
  },
  CONF_MY_OLIGOS_SIDE_BAR_BEACON: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_BEACON',
    defaultMessage: 'My Oligos ',
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_BEACON: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_BEACON',
    defaultMessage: maxStr,
  },
  CONF_OLIGOS_PROBES_BEACON: {
    id: 'CONF_OLIGOS_PROBES_BEACON',
    defaultMessage: oligosStr,
  },
  CONF_OLIGO_NAME_BEACON: {
    id: 'CONF_OLIGO_NAME_BEACON',
    defaultMessage: 'Oligo Name:',
  },
  CONF_SEQUENCE_TYPE_BEACON: {
    id: 'CONF_SEQUENCE_TYPE_BEACON',
    defaultMessage: fiveFootStr,
  },
  CONF_SEQUENCE_INFORMATION_BEACON: {
    id: 'CONF_SEQUENCE_INFORMATION_BEACON',
    defaultMessage: sequenceInfoStr,
  },
  CONF_SEQUENCE_MESSAGE_BEACON: {
    id: 'CONF_SEQUENCE_MESSAGE_BEACON',
    defaultMessage: 'DNA bases only. Please be sure to include stem sequences.',
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_BEACON: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_BEACON',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters',
  },
  CONF_SEQUENCE_ENTRY_BEACON: {
    id: 'CONF_SEQUENCE_ENTRY_BEACON',
    defaultMessage: sequenceEntryStr,
  },
  CONF_CONFIRM_ORDER_BEACON: {
    id: 'CONF_CONFIRM_ORDER_BEACON',
    defaultMessage: reviewStr,
  },
  CONF_BASE_COUNT_cpeptide: {
    id: 'CONF_BASE_COUNT_cpeptide',
    defaultMessage: 'Amino Acid Count: ',
  },
  CONF_ADD_OLIGO_SIDE_BAR_cpeptide: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_cpeptide',
    defaultMessage: 'Add Peptide ',
  },
  CONF_MY_OLIGOS_SIDE_BAR_cpeptide: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_cpeptide',
    defaultMessage: 'My Peptides ',
  },
  CONF_AMINO_ACID: { id: 'CONF_AMINO_ACID', defaultMessage: 'No Amino Acids' },
  CONF_OLIGO_NAME_lightcycle: {
    id: 'CONF_OLIGO_NAME_lightcycle',
    defaultMessage: 'Oligo Name:',
  },
  CONF_SELECT_ASSAY_ERROR_MSG: {
    id: 'CONF_SELECT_ASSAY_ERROR_MSG',
    defaultMessage: 'Please select an assay before proceeding to next step',
  },
  CONF_SEQUENCE_MESSAGE_puresimple: {
    id: 'CONF_SEQUENCE_MESSAGE_puresimple',
    defaultMessage: 'Standard DNA bases only: A, C, G, T',
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_puresimple: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_puresimple',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters',
  },
  CONF_OLIGO_NAME_puresimple: {
    id: 'CONF_OLIGO_NAME_puresimple',
    defaultMessage: oligoNameStr,
  },
  CONF_SEQUENCE_TYPE_puresimple: {
    id: 'CONF_SEQUENCE_TYPE_puresimple',
    defaultMessage: fiveFootStr,
  },
  CONF_SEQUENCE_INFORMATION_puresimple: {
    id: 'CONF_SEQUENCE_INFORMATION_puresimple',
    defaultMessage: sequenceInfoStr,
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_puresimple: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_puresimple',
    defaultMessage: maxStr,
  },
  CONF_ADD_OLIGO_SIDE_BAR_puresimple: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_puresimple',
    defaultMessage: 'Add Oligo ',
  },
  CONF_BASE_COUNT_puresimple: {
    id: 'CONF_BASE_COUNT_puresimple',
    defaultMessage: baseCountStr,
  },
  CONF_INVALID_FORMAT_puresimple: {
    id: 'CONF_INVALID_FORMAT_puresimple',
    defaultMessage:
      'The file you have uploaded is invalid. Try again using the template provided.',
  },
  CONF_HOME_puresimple: { id: 'CONF_HOME_puresimple', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_puresimple: {
    id: 'CONF_CUSTOM_PRODUCTS_puresimple',
    defaultMessage: customProductsStr,
  },
  CONF_STANDARD_TUBES_puresimple: {
    id: 'CONF_STANDARD_TUBES_puresimple',
    defaultMessage: 'Pure & Simple Primers',
  },
  CONF_SEQUENCE_ENTRY_puresimple: {
    id: 'CONF_SEQUENCE_ENTRY_puresimple',
    defaultMessage: sequenceEntryStr,
  },
  CONF_MY_OLIGOS_SIDE_BAR_puresimple: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_puresimple',
    defaultMessage: 'My Oligos ',
  },
  CONF_CONFIRM_ORDER_puresimple: {
    id: 'CONF_CONFIRM_ORDER_puresimple',
    defaultMessage: reviewStr,
  },
  CONF_EFFICIENCY_SCORE_LABEL_crispgrna: {
    id: 'CONF_EFFICIENCY_SCORE_LABEL_crispgrna',
    defaultMessage: 'Efficiency Score',
  },
  CONF_SPECIFICATION_SCORE_LABEL_crispgrna: {
    id: 'CONF_SPECIFICATION_SCORE_LABEL_crispgrna',
    defaultMessage: 'Specificity Score',
  },
  CONF_LABEL_HEADER_KicqStart: {
    id: 'CONF_LABEL_HEADER_KicqStart',
    defaultMessage: 'KiCqStart',
  },
  CONF_LABEL_HEADER_PROBE_ASSAYS_KicqStart: {
    id: 'CONF_LABEL_HEADER_PROBE_ASSAYS_KicqStart',
    defaultMessage: ' Probe Assays',
  },
  CONF_TITLE_standard: {
    id: 'CONF_TITLE_standard',
    defaultMessage: 'DNA Oligos in Tubes',
  },
  CONF_TITLE_aqua: { id: 'CONF_TITLE_aqua', defaultMessage: 'AQUA Peptides' },
  CONF_TITLE_wellred: {
    id: 'CONF_TITLE_wellred',
    defaultMessage: 'WellRED Oligos',
  },
  CONF_TITLE_easyoligo: {
    id: 'CONF_TITLE_easyoligo',
    defaultMessage: 'Easy Oligos',
  },
  CONF_TITLE_lightcycle: {
    id: 'CONF_TITLE_lightcycle',
    defaultMessage: 'LightCycler® Probes',
  },
  CONF_TITLE_lightcycle_old: {
    id: 'CONF_TITLE_lightcycle_old',
    defaultMessage: 'LightCycler® Probes',
  },
  CONF_TITLE_fastduplex: {
    id: 'CONF_TITLE_fastduplex',
    defaultMessage: 'Fast SiRNA',
  },
  CONF_TITLE_fastduplex_old: {
    id: 'CONF_TITLE_fastduplex_old',
    defaultMessage: 'Fast SiRNA',
  },
  CONF_TITLE_mirna_old: {
    id: 'CONF_TITLE_mirna_old',
    defaultMessage: 'Custom miRNA in Tubes',
  },
  CONF_MILLIPLEX_TEXT: {
    id: 'CONF_MILLIPLEX_TEXT',
    defaultMessage: 'MILLIPLEX',
  },
  CONF_ANALYTE_KIT_FINDER: {
    id: 'CONF_ANALYTE_KIT_FINDER',
    defaultMessage: 'Analyte Kit Finder',
  },
  CONF_TITLE_cpeptide: {
    id: 'CONF_TITLE_cpeptide',
    defaultMessage: 'Custom Peptides',
  },
  CONF_TITLE_longoligo: {
    id: 'CONF_TITLE_longoligo',
    defaultMessage: 'Long Oligos',
  },
  CONF_TITLE_duplex: {
    id: 'CONF_TITLE_duplex',
    defaultMessage: 'Custom siRNA in Tubes',
  },
  CONF_DNA_OLIGOS_IN_TUBES_longoligo: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_longoligo',
    defaultMessage: 'Long Oligos',
  },
  CONF_HOME_longoligo: { id: 'CONF_HOME_longoligo', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_longoligo: {
    id: 'CONF_CUSTOM_PRODUCTS_longoligo',
    defaultMessage: customProductsStr,
  },
  CONF_SEQUENCE_ENTRY_longoligo: {
    id: 'CONF_SEQUENCE_ENTRY_longoligo',
    defaultMessage: sequenceEntryStr,
  },
  CONF_CONFIRM_ORDER_longoligo: {
    id: 'CONF_CONFIRM_ORDER_longoligo',
    defaultMessage: reviewStr,
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_longoligo: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_longoligo',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters.',
  },
  CONF_SEQUENCE_MESSAGE_longoligo: {
    id: 'CONF_SEQUENCE_MESSAGE_longoligo',
    defaultMessage:
      "Insert an asterisk '*' between bases that are to be phosphorothioated.",
  },
  CONF_SEQUENCE_INFORMATION_longoligo: {
    id: 'CONF_SEQUENCE_INFORMATION_longoligo',
    defaultMessage: sequenceEntryStr,
  },
  CONF_SEQUENCE_TYPE_longoligo: {
    id: 'CONF_SEQUENCE_TYPE_longoligo',
    defaultMessage: fiveFootStr,
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_longoligo: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_longoligo',
    defaultMessage: maxStr,
  },
  CONF_MY_OLIGOS_SIDE_BAR_longoligo: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_longoligo',
    defaultMessage: 'My Oligos ',
  },
  CONF_ADD_OLIGO_SIDE_BAR_longoligo: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_longoligo',
    defaultMessage: 'Add Oligo ',
  },
  CONF_BASE_COUNT_longoligo: {
    id: 'CONF_BASE_COUNT_longoligo',
    defaultMessage: baseCountStr,
  },
  CONF_OLIGO_NAME_longoligo: {
    id: 'CONF_OLIGO_NAME_longoligo',
    defaultMessage: 'Oligo Name:',
  },
  CONF_OPTIONAL_MOD_scorpuni: {
    id: 'CONF_OPTIONAL_MOD_scorpuni',
    defaultMessage: "5' Modifications",
  },
  CONF_OLIGOS_PROBES_scorpuni: {
    id: 'CONF_OLIGOS_PROBES_scorpuni',
    defaultMessage: oligosStr,
  },
  CONF_DNA_OLIGOS_IN_TUBES_scorpuni: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_scorpuni',
    defaultMessage: 'Scorpions{registered} Uni-Probes',
  },
  CONF_SEQUENCE_MESSAGE_scorpuni: {
    id: 'CONF_SEQUENCE_MESSAGE_scorpuni',
    defaultMessage:
      "Insert an asterisk '*' between bases that are to be phosphorothioated.",
  },
  CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_scorpuni: {
    id: 'CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_scorpuni',
    defaultMessage:
      'For optimal tube label printing, limit character length to 18. Do not use ASCII characters',
  },
  CONF_OLIGO_NAME_scorpuni: {
    id: 'CONF_OLIGO_NAME_scorpuni',
    defaultMessage: oligoNameStr,
  },
  CONF_SEQUENCE_TYPE_scorpuni: {
    id: 'CONF_SEQUENCE_TYPE_scorpuni',
    defaultMessage: fiveFootStr,
  },
  CONF_SEQUENCE_INFORMATION_scorpuni: {
    id: 'CONF_SEQUENCE_INFORMATION_scorpuni',
    defaultMessage: sequenceInfoStr,
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_scorpuni: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_scorpuni',
    defaultMessage: maxStr,
  },
  CONF_ADD_OLIGO_SIDE_BAR_scorpuni: {
    id: 'CONF_ADD_OLIGO_SIDE_BAR_scorpuni',
    defaultMessage: 'Add Oligo ',
  },
  CONF_BASE_COUNT_scorpuni: {
    id: 'CONF_BASE_COUNT_scorpuni',
    defaultMessage: baseCountStr,
  },
  CONF_INVALID_FORMAT_scorpuni: {
    id: 'CONF_INVALID_FORMAT_scorpuni',
    defaultMessage:
      'The file you have uploaded is invalid. Try again using the template provided.',
  },
  CONF_HOME_scorpuni: { id: 'CONF_HOME_scorpuni', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCTS_scorpuni: {
    id: 'CONF_CUSTOM_PRODUCTS_scorpuni',
    defaultMessage: customProductsStr,
  },
  CONF_SEQUENCE_ENTRY_scorpuni: {
    id: 'CONF_SEQUENCE_ENTRY_scorpuni',
    defaultMessage: sequenceEntryStr,
  },
  CONF_MY_OLIGOS_SIDE_BAR_scorpuni: {
    id: 'CONF_MY_OLIGOS_SIDE_BAR_scorpuni',
    defaultMessage: 'My Oligos ',
  },
  CONF_CONFIRM_ORDER_scorpuni: {
    id: 'CONF_CONFIRM_ORDER_scorpuni',
    defaultMessage: reviewStr,
  },
  CONF_LABEL_HEADER_sirna: {
    id: 'CONF_LABEL_HEADER_sirna',
    defaultMessage: 'Predesigned siRNA',
  },
  CONF_LABEL_HEADER_PROBE_ASSAYS_sirna: {
    id: 'CONF_LABEL_HEADER_PROBE_ASSAYS_sirna',
    defaultMessage: ' Probe Assays',
  },
  CONF_DNA_OLIGOS_IN_TUBES_rna: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_rna',
    defaultMessage: 'RNA Oligos',
  },
  CONF_DNA_OLIGOS_IN_TUBES_puresimple: {
    id: 'CONF_DNA_OLIGOS_IN_TUBES_puresimple',
    defaultMessage: 'Pure & Simple Primers',
  },
  CONF_VIEW_SEQUENCE: {
    id: 'CONF_VIEW_SEQUENCE',
    defaultMessage: 'View Sequence',
  },
  CONF_PRICE_WARNING: { id: 'CONF_PRICE_WARNING', defaultMessage: 'Warning:' },
  CONF_TITLE_customcrispr: {
    id: 'CONF_TITLE_customcrispr',
    defaultMessage: 'Custom CRISPR',
  },
  CONF_MAX_OLIGO_NAME_LENGTH_30_cpeptide: {
    id: 'CONF_MAX_OLIGO_NAME_LENGTH_30_cpeptide',
    defaultMessage: maxStr,
  },
  CONF_MILLIPLEX_VIEW_LABEL_milliplex: {
    id: 'CONF_MILLIPLEX_VIEW_LABEL_milliplex',
    defaultMessage: 'View',
  },
  CONF_DUPLEX_PLATE_WARNING: {
    id: 'CONF_DUPLEX_PLATE_WARNING',
    defaultMessage: 'Wells containing duplexes with more than 20% mismatch:  ',
  },
  CONF_SPECIFICATION_STRUCTURE_crRNA_customcrispr: {
    id: 'CONF_SPECIFICATION_STRUCTURE_crRNA_customcrispr',
    defaultMessage: 'crRNA(tracrRNA sold seperately)',
  },
  CONF_SPECIFICATION_STRUCTURE_sgRNA_customcrispr: {
    id: 'CONF_SPECIFICATION_STRUCTURE_sgRNA_customcrispr',
    defaultMessage: 'sgRNA (crRNA + tracrRNA as one)',
  },
  CONF_SPECIFICATION_SYNTHESIS_SCALE_2nmol_customcrispr: {
    id: 'CONF_SPECIFICATION_SYNTHESIS_SCALE_2nmol_crisprgrna',
    defaultMessage: '2 nmol',
  },
  CONF_SPECIFICATION_SYNTHESIS_SCALE_3nmol_customcrispr: {
    id: 'CONF_SPECIFICATION_SYNTHESIS_SCALE_3nmol_customcrispr',
    defaultMessage: '3 nmol',
  },
  CONF_SPECIFICATION_SYNTHESIS_SCALE_5nmol_customcrispr: {
    id: 'CONF_SPECIFICATION_SYNTHESIS_SCALE_5nmol_crisprgrna',
    defaultMessage: '5 nmol',
  },
  CONF_SPECIFICATION_MODIFIED_HELP_TEXT_customcrispr: {
    id: 'CONF_SPECIFICATION_MODIFIED_HELP_TEXT_customcrispr',
    defaultMessage:
      "Chemically modified CRISPR RNA contain stabilizing 2'-O-methyl and phosphorothioate linkages which may lead to improved editing efficiency in primary cells and other hard-to-transfect cell lines.",
  },
  CONF_DUPLEX_MISMATCH_WARNING: {
    id: 'CONF_DUPLEX_MISMATCH_WARNING',
    defaultMessage:
      'The mismatch between Sense and Antisense Sequences is greater than 20%',
  },
  CONF_AMMONIUM_SULFATE_FRACTIONATION_ANTISERA: {
    id: 'CONF_AMMONIUM_SULFATE_FRACTIONATION_ANTISERA',
    defaultMessage: 'Ammonium Sulfate Fractionation',
  },
  CONF_SUPPLIED_ANTIGENS_ANTISERA: {
    id: 'CONF_SUPPLIED_ANTIGENS_ANTISERA',
    defaultMessage: 'Customer Supplied Antigens',
  },
  CONF_ORDERING_YOUR_REGION: {
    id: 'CONF_ORDERING_YOUR_REGION',
    defaultMessage: 'ordering area for your region.',
  },
  CONF_HOME_duplex: { id: 'CONF_HOME_duplex', defaultMessage: 'Home' },
  CONF_HOME_mirna: { id: 'CONF_HOME_mirna', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCT_duplex: {
    id: 'CONF_CUSTOM_PRODUCT_duplex',
    defaultMessage: customProductsStr,
  },
  CONF_CUSTOM_PRODUCT_mirna: {
    id: 'CONF_CUSTOM_PRODUCT_mirna',
    defaultMessage: customProductsStr,
  },
  CONF_CUSTOM_PRODUCT_NAME_duplex: {
    id: 'CONF_CUSTOM_PRODUCT_NAME_duplex',
    defaultMessage: 'Gene Knockout, Knockdown & Expression',
  },
  CONF_CUSTOM_PRODUCT_NAME_mirna: {
    id: 'CONF_CUSTOM_PRODUCT_NAME_mirna',
    defaultMessage: 'Gene Knockout, Knockdown & Expression',
  },
  CONF_BITUBE_PRODUCT_NAME_duplex: {
    id: 'CONF_BITUBE_PRODUCT_NAME_duplex',
    defaultMessage: 'siRNA',
  },
  CONF_BITUBE_PRODUCT_NAME_mirna: {
    id: 'CONF_BITUBE_PRODUCT_NAME_mirna',
    defaultMessage: 'Custom miRNA in Tubes',
  },
  CONF_HOME_fastduplex: { id: 'CONF_HOME_fastduplex', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCT_fastduplex: {
    id: 'CONF_CUSTOM_PRODUCT_fastduplex',
    defaultMessage: customProductsStr,
  },
  CONF_CUSTOM_PRODUCT_NAME_fastduplex: {
    id: 'CONF_CUSTOM_PRODUCT_NAME_fastduplex',
    defaultMessage: 'Gene Knockout, Knockdown & Expression',
  },
  CONF_BITUBE_PRODUCT_NAME_fastduplex: {
    id: 'CONF_BITUBE_PRODUCT_NAME_fastduplex',
    defaultMessage: 'FAST siRNA',
  },
  CONF_HOME_lightcycle: { id: 'CONF_HOME_lightcycle', defaultMessage: 'Home' },
  CONF_CUSTOM_PRODUCT_lightcycle: {
    id: 'CONF_CUSTOM_PRODUCT_lightcycle',
    defaultMessage: customProductsStr,
  },
  CONF_CUSTOM_PRODUCT_NAME_lightcycle: {
    id: 'CONF_CUSTOM_PRODUCT_NAME_lightcycle',
    defaultMessage: oligosStr,
  },
  CONF_BITUBE_PRODUCT_NAME_lightcycle: {
    id: 'CONF_BITUBE_PRODUCT_NAME_lightcycle',
    defaultMessage: 'LightCycler{registered} Probes',
  },
  CONF_PLATE_PRODUCT_NUMBER_OF_BASES_TEXT_dnaplate: {
    id: 'CONF_PLATE_PRODUCT_NUMBER_OF_BASES_TEXT_dnaplate',
    defaultMessage: 'Number of Bases({totalbasecountvalue}):',
  },
  CONF_SEARCH_MESSAGE_crisprgrna: {
    id: 'CONF_SEARCH_MESSAGE_crisprgrna',
    defaultMessage:
      'Search by Gene Symbol, Gene ID or MISSION™ gRNA ID (Enter up to 100 items separated by spaces)',
  },
  CONF_COPY_TEXT: { id: 'CONF_COPY_TEXT', defaultMessage: 'Copy' },
  CONF_CUSTOM_PRODUCTS_dnaplate: {
    id: 'CONF_CUSTOM_PRODUCTS_dnaplate',
    defaultMessage: customProductsStr,
  },
  CONF_OLIGOS_PROBES_dnaplate: {
    id: 'CONF_OLIGOS_PROBES_dnaplate',
    defaultMessage: oligosStr,
  },
  CONF_CUSTOM_PRODUCTS_duplexplate: {
    id: 'CONF_CUSTOM_PRODUCTS_duplexplate',
    defaultMessage: customProductsStr,
  },
  CONF_OLIGOS_PROBES_duplexplate: {
    id: 'CONF_OLIGOS_PROBES_duplexplate',
    defaultMessage: 'Gene Knockout, Knockdown & Expression',
  },
  CONF_PLATE_PRODUCT_NUMBER_OF_BASES_TEXT_duplexplate: {
    id: 'CONF_PLATE_PRODUCT_NUMBER_OF_BASES_TEXT_duplexplate',
    defaultMessage: 'Duplex Fee:',
  },
  CONF_DISCOUNT_MESSAGE: {
    id: 'CONF_DISCOUNT_MESSAGE',
    defaultMessage:
      'Don’t miss out on the substantial discount you receive when you order 5 or more clones of any gene in the same format; additional discounts are given for > 25 quantities',
  },
  CONF_PRICE_SUB_TOTAL_MIRNA: {
    id: 'CONF_PRICE_SUB_TOTAL_MIRNA',
    defaultMessage:
      'Pricing can not be calculated. Add to cart to submit your quotation request.',
  },
  CONF_NGSO_PROMOTIONAL_CODES: {
    id: 'CONF_NGSO_PROMOTIONAL_CODES',
    defaultMessage: 'Promotional codes can be applied during checkout',
  },
  _PC_SH_MAIN_HEADER_milliplex: {
    id: '_PC_SH_MAIN_HEADER_milliplex',
    defaultMessage: 'Multiplex Assays Using Luminex',
  },
  _PC_SPEC_5MOD_standard: {
    id: '_PC_SPEC_5MOD_standard',
    defaultMessage: "Optional 5' & 3' Modifications ",
  },
  _PC_SPEC_5MOD_iscaledna: {
    id: '_PC_SPEC_5MOD_iscaledna',
    defaultMessage: "Optional 5' & 3' Modifications ",
  },
  _PC_SPEC_internalModS: {
    id: '_PC_SPEC_internalModS',
    defaultMessage: 'Optional Internal Modifications ',
  },
  _PC_SPEC_MODIFIED_BASES: {
    id: '_PC_SPEC_MODIFIED_BASES',
    defaultMessage: 'Optional Bases',
  },
  _PC_SPEC_10_0UM: { id: '_PC_SPEC_10_0UM', defaultMessage: '10 µmole' },
  _PC_SPEC_15_0UM: { id: '_PC_SPEC_15_0UM', defaultMessage: '15 µmole' },
  _PC_SPEC_0_1UM: { id: '_PC_SPEC_0_1UM', defaultMessage: '0.1 µmole' },
  _PC_SPEC_0_15UM: { id: '_PC_SPEC_0_15UM', defaultMessage: '0.15 µmole' },
  _PC_SPEC_Unpurified: {
    id: '_PC_SPEC_Unpurified',
    defaultMessage: 'Unpurified',
  },
  _PC_SPEC_Desalt: { id: '_PC_SPEC_Desalt', defaultMessage: 'Desalt' },
  _PC_SPEC_PAGE: { id: '_PC_SPEC_PAGE', defaultMessage: 'PAGE' },
  _PC_SPEC_CARTRIDGE: { id: '_PC_SPEC_CARTRIDGE', defaultMessage: 'Cartridge' },
  _PC_SPEC_0UM: { id: '_PC_SPEC_0UM', defaultMessage: '0 µM' },
  _PC_SPEC_20UM: { id: '_PC_SPEC_20UM', defaultMessage: '20 µM' },
  _PC_SPEC_50UM: { id: '_PC_SPEC_50UM', defaultMessage: '50 µM' },
  _PC_SPEC_100UM: { id: '_PC_SPEC_100UM', defaultMessage: '100 µM' },
  _PC_SPEC_200UM: { id: '_PC_SPEC_200UM', defaultMessage: '200 µM' },
  _PC_SPEC_500UM: { id: '_PC_SPEC_500UM', defaultMessage: '500 µM' },
  _PC_SPEC_PURICIFATION: {
    id: '_PC_SPEC_PURICIFATION',
    defaultMessage: 'Purification',
  },
  _PC_SPEC_NOFT: {
    id: '_PC_SPEC_NOFT',
    defaultMessage: 'Number of Tubes per Oligo',
  },
  _PC_SPEC_DESALT: { id: '_PC_SPEC_DESALT', defaultMessage: 'Desalt' },
  _PC_GHT_OLIGO_SPEC: {
    id: '_PC_GHT_OLIGO_SPEC',
    defaultMessage: 'Specifications',
  },
  _PC_SPEC_OLIGO_FORMAT: {
    id: '_PC_SPEC_OLIGO_FORMAT',
    defaultMessage: 'Format',
  },
  _PC_SPEC_HPLC: { id: '_PC_SPEC_HPLC', defaultMessage: 'HPLC' },
  _PC_SPEC_PUREDIT: { id: '_PC_SPEC_PUREDIT', defaultMessage: 'PURedit™' },
  _PC_SPEC_STANDARD: { id: '_PC_SPEC_STANDARD', defaultMessage: 'Standard' },
  _PC_SPEC_VIVO: { id: '_PC_SPEC_VIVO', defaultMessage: 'In Vivo Treatment' },
  _PC_SPEC_VIVO_V2: { id: '_PC_SPEC_VIVO_V2', defaultMessage: 'In Vivo' },
  _PC_SPEC_AMBIENT: { id: '_PC_SPEC_AMBIENT', defaultMessage: 'Ambient ' },
  _PC_SPEC_IS_WATER: {
    id: '_PC_SPEC_IS_WATER',
    defaultMessage: 'In Solution (Water)',
  },
  _PC_SPEC_IS_TE: { id: '_PC_SPEC_IS_TE', defaultMessage: 'In Solution (TE)' },
  _PC_SPEC_IS_TRIS: {
    id: '_PC_SPEC_IS_TRIS',
    defaultMessage: 'In Solution (TRIS)',
  },
  _PC_SPEC_RP1: { id: '_PC_SPEC_RP1', defaultMessage: 'Cartridge' },
  _PC_SECONDARY_PATTERN_NONE: {
    id: '_PC_SECONDARY_PATTERN_NONE',
    defaultMessage: 'None',
  },
  _PC_SPEC_NONE: { id: '_PC_SPEC_NONE', defaultMessage: 'None' },
  _PC_SPEC_None: { id: '_PC_SPEC_None', defaultMessage: 'None' },
  _PC_SPEC_Amino_Modifier_C3_TFA: {
    id: '_PC_SPEC_Amino_Modifier_C3_TFA',
    defaultMessage: 'Amino-Modifier C3',
  },
  _PC_SPEC_3_Amino_Modifier_C7: {
    id: '_PC_SPEC_3_Amino_Modifier_C7',
    defaultMessage: 'Amino-Modifier C7',
  },
  _PC_SPEC_3_Biotin_TEG: {
    id: '_PC_SPEC_3_Biotin_TEG',
    defaultMessage: 'Biotin TEG',
  },
  _PC_SPEC_Phosphate: { id: '_PC_SPEC_Phosphate', defaultMessage: 'Phosphate' },
  _PC_SPEC_Amino_Modifier_C12: {
    id: '_PC_SPEC_Amino_Modifier_C12',
    defaultMessage: 'Amino-Modifier C12',
  },
  _PC_SPEC_Amino_Modifier_C6: {
    id: '_PC_SPEC_Amino_Modifier_C6',
    defaultMessage: 'Amino-Modifier C6',
  },
  _PC_SPEC_BIOTIN: { id: '_PC_SPEC_BIOTIN', defaultMessage: 'Biotin' },
  _PC_SPEC_BIOTIN_TEG: {
    id: '_PC_SPEC_BIOTIN_TEG',
    defaultMessage: 'Biotin TEG',
  },
  _PC_SPEC_HEX: { id: '_PC_SPEC_HEX', defaultMessage: 'HEX' },
  _PC_SPEC_TET: { id: '_PC_SPEC_TET', defaultMessage: 'TET' },
  _PC_SPEC_6_FAM: {
    id: '_PC_SPEC_6_FAM',
    defaultMessage: '6-FAM (Fluorescein)',
  },
  _PC_SECONDARY_PATTERN_MODERATE: {
    id: '_PC_SECONDARY_PATTERN_MODERATE',
    defaultMessage: 'Moderate',
  },
  _PC_SECONDARY_PATTERN_VERY_WEAK: {
    id: '_PC_SECONDARY_PATTERN_VERY_WEAK',
    defaultMessage: 'Very Weak',
  },
  _PC_SECONDARY_PATTERN_VERY_STRONG: {
    id: '_PC_SECONDARY_PATTERN_VERY_STRONG',
    defaultMessage: 'Very Strong',
  },
  _PC_SECONDARY_PATTERN_WEAK: {
    id: '_PC_SECONDARY_PATTERN_WEAK',
    defaultMessage: 'Weak',
  },
  _PC_SECONDARY_PATTERN_STRONG: {
    id: '_PC_SECONDARY_PATTERN_STRONG',
    defaultMessage: 'Strong',
  },
  _PC_PROPERTY_DISPLAY_INSOL_OTHER_screen: {
    id: '_PC_PROPERTY_DISPLAY_INSOL_OTHER_screen',
    defaultMessage: 'In Solution (Other)',
  },
  _PC_SPEC_3MOD: { id: '_PC_SPEC_3MOD', defaultMessage: "3' Modifications" },
  _PC_SPEC_5MOD: { id: '_PC_SPEC_5MOD', defaultMessage: "5' Modifications" },
  _PC_SPEC_YEILD: { id: '_PC_SPEC_YEILD', defaultMessage: 'Amount' },
  _PC_SPEC_1_D: { id: '_PC_SPEC_1_D', defaultMessage: '1 OD' },
  _PC_SPEC_3_D: { id: '_PC_SPEC_3_D', defaultMessage: '3 OD' },
  _PC_SPEC_5_D: { id: '_PC_SPEC_5_D', defaultMessage: '5 OD' },
  _PC_SPEC_10_D: { id: '_PC_SPEC_10_D', defaultMessage: '10 OD' },
  _PC_SPEC_50_D: { id: '_PC_SPEC_50_D', defaultMessage: '50 OD' },
  _PC_SPEC_100_D: { id: '_PC_SPEC_100_D', defaultMessage: '100 OD' },
  _PC_SPEC_REP_QUEN: {
    id: '_PC_SPEC_REP_QUEN',
    defaultMessage: "5' Reporter / 3' Quencher Combination",
  },
  _PC_SPEC_BASES: { id: '_PC_SPEC_BASES', defaultMessage: 'Optional Bases' },
  _PC_SPEC_6FAM_BHQ1: {
    id: '_PC_SPEC_6FAM_BHQ1',
    defaultMessage: '6-FAM / BHQ-1',
  },
  _PC_SPEC_6FAM_TAMRA: {
    id: '_PC_SPEC_6FAM_TAMRA',
    defaultMessage: '6-FAM / TAMRA',
  },
  _PC_SPEC_HEX_BHQ1: { id: '_PC_SPEC_HEX_BHQ1', defaultMessage: 'HEX / BHQ-1' },
  _PC_SPEC_HEX_TAMRA: {
    id: '_PC_SPEC_HEX_TAMRA',
    defaultMessage: 'HEX / TAMRA',
  },
  _PC_SPEC_JOE_BHQ1: { id: '_PC_SPEC_JOE_BHQ1', defaultMessage: 'JOE / BHQ-1' },
  _PC_SPEC_JOE_TAMRA: {
    id: '_PC_SPEC_JOE_TAMRA',
    defaultMessage: 'JOE / TAMRA',
  },
  _PC_SPEC_TEXAS_BHQ2: {
    id: '_PC_SPEC_TEXAS_BHQ2',
    defaultMessage: 'TxRd / BHQ-2',
  },
  _PC_SPEC_ROX_BHQ2: { id: '_PC_SPEC_ROX_BHQ2', defaultMessage: 'ROX / BHQ-2' },
  _PC_SPEC_CY5_BHQ3: {
    id: '_PC_SPEC_CY5_BHQ3',
    defaultMessage: 'Cyanine 5 / BHQ-3',
  },
  _PC_SPEC_CY5_BHQ2: {
    id: '_PC_SPEC_CY5_BHQ2',
    defaultMessage: 'Cyanine 5 / BHQ-2',
  },
  _PC_SPEC_CY5_OQD: {
    id: '_PC_SPEC_CY5_OQD',
    defaultMessage: 'Cyanine 5 / Onyx Quencher D',
  },
  _PC_SPEC_CY3_BHQ2: {
    id: '_PC_SPEC_CY3_BHQ2',
    defaultMessage: 'Cyanine 3 / BHQ-2',
  },
  _PC_SPEC_CY3_OQB: {
    id: '_PC_SPEC_CY3_OQB',
    defaultMessage: 'Cyanine 3 / Onyx Quencher B',
  },
  _PC_SPEC_TET_BHQ1: { id: '_PC_SPEC_TET_BHQ1', defaultMessage: 'TET / BHQ-1' },
  _PC_SPEC_TET_TAMRA: {
    id: '_PC_SPEC_TET_TAMRA',
    defaultMessage: 'TET / TAMRA',
  },
  _PC_SPEC_TET_OQA: {
    id: '_PC_SPEC_TET_OQA',
    defaultMessage: 'TET / Onyx Quencher A',
  },
  _PC_SPEC_TAM_BHQ2: {
    id: '_PC_SPEC_TAM_BHQ2',
    defaultMessage: 'TAMRA / BHQ-2',
  },
  _PC_SPEC_CY55_BHQ2: {
    id: '_PC_SPEC_CY55_BHQ2',
    defaultMessage: 'Cyanine 5.5 / BHQ-2',
  },
  _PC_SPEC_CY55_BHQ3: {
    id: '_PC_SPEC_CY55_BHQ3',
    defaultMessage: 'Cyanine 5.5 / BHQ-3',
  },
  _PC_SPEC_CY55_OQD: {
    id: '_PC_SPEC_CY55_OQD',
    defaultMessage: 'Cyanine 5.5 / Onyx Quencher D',
  },
  _PC_SPEC_CFO560_BHQ1: {
    id: '_PC_SPEC_CFO560_BHQ1',
    defaultMessage: 'Cal Fluor Orange 560 / BHQ-1',
  },
  _PC_SPEC_CFG540_BHQ1: {
    id: '_PC_SPEC_CFG540_BHQ1',
    defaultMessage: 'Cal Fluor Gold 540 / BHQ-1',
  },
  _PC_SPEC_CFR590_BHQ2: {
    id: '_PC_SPEC_CFR590_BHQ2',
    defaultMessage: 'Cal Fluor Red 590 / BHQ-2',
  },
  _PC_SPEC_Q570_BHQ2: {
    id: '_PC_SPEC_Q570_BHQ2',
    defaultMessage: 'Quasar 570 / BHQ-2',
  },
  _PC_SPEC_Q670_BHQ3: {
    id: '_PC_SPEC_Q670_BHQ3',
    defaultMessage: 'Quasar 670 / BHQ-3',
  },
  _PC_SPEC_6FAM_OQA: {
    id: '_PC_SPEC_6FAM_OQA',
    defaultMessage: '6-FAM / Onyx Quencher A',
  },
  _PC_SPEC_6FAM_BHQ1_BHQ1: {
    id: '_PC_SPEC_6FAM_BHQ1_BHQ1',
    defaultMessage: '6-FAM / BHQ-1 / BHQ-1',
  },
  _PC_SPEC_HEX_BHQ1_BHQ1: {
    id: '_PC_SPEC_HEX_BHQ1_BHQ1',
    defaultMessage: 'HEX / BHQ-1 / BHQ-1',
  },
  _PC_SPEC_HEX_BHQ1_BHQ2: {
    id: '_PC_SPEC_HEX_BHQ1_BHQ2',
    defaultMessage: 'HEX / BHQ-1 / BHQ-2',
  },
  _PC_SPEC_TAMRA_BHQ2_BHQ2: {
    id: '_PC_SPEC_TAMRA_BHQ2_BHQ2',
    defaultMessage: 'TAMRA / BHQ-2 / BHQ-2',
  },
  _PC_SPEC_TEXAS_BHQ2_BHQ2: {
    id: '_PC_SPEC_TEXAS_BHQ2_BHQ2',
    defaultMessage: 'TxRd / BHQ-2  / BHQ-2',
  },
  _PC_SPEC_TEXAS_BHQ2_BHQ3: {
    id: '_PC_SPEC_TEXAS_BHQ2_BHQ3',
    defaultMessage: 'TxRd / BHQ-2 / BHQ-3',
  },

  _PC_SPEC_HEX_BHQ1_PHOS: {
    id: '_PC_SPEC_HEX_BHQ1_PHOS',
    defaultMessage: 'HEX / BHQ-1 / Phos',
  },
  _PC_SPEC_6FAM_BHQ1_PHOS: {
    id: '_PC_SPEC_6FAM_BHQ1_PHOS',
    defaultMessage: '6-FAM / BHQ-1 / Phos',
  },
  _PC_SPEC_TAMRA_BHQ2_PHOS: {
    id: '_PC_SPEC_TAMRA_BHQ2_PHOS',
    defaultMessage: 'TAMRA / BHQ-2 / Phos',
  },
  _PC_SPEC_TEXAS_BHQ2_PHOS: {
    id: '_PC_SPEC_TEXAS_BHQ2_PHOS',
    defaultMessage: 'TxRd / BHQ-2 / Phos',
  },
  _PC_SPEC_CY5_BHQ2_PHOS: {
    id: '_PC_SPEC_CY5_BHQ2_PHOS',
    defaultMessage: 'Cyanine 5 / BHQ-2 / Phos',
  },
  _PC_SPEC_CY55_BHQ2_PHOS: {
    id: '_PC_SPEC_CY55_BHQ2_PHOS',
    defaultMessage: 'Cyanine 5.5 / BHQ-2 / Phos',
  },

  _PC_SPEC_Cyanine55_BHQ2_BHQ3: {
    id: '_PC_SPEC_Cyanine55_BHQ2_BHQ3',
    defaultMessage: 'Cyanine 5.5 / BHQ-2 / BHQ-3',
  },
  _PC_SPEC_Cyanine5_BHQ2_BHQ3: {
    id: '_PC_SPEC_Cyanine5_BHQ2_BHQ3',
    defaultMessage: 'Cyanine 5 / BHQ-2 / BHQ-3',
  },
  _PC_SPEC_HEX_OQA: {
    id: '_PC_SPEC_HEX_OQA',
    defaultMessage: 'HEX / Onyx Quencher A',
  },
  _PC_SPEC_JOE_OQA: {
    id: '_PC_SPEC_JOE_OQA',
    defaultMessage: 'JOE / Onyx Quencher A',
  },
  _PC_SPEC_TAM_OQB: {
    id: '_PC_SPEC_TAM_OQB',
    defaultMessage: 'TAMRA / Onyx Quencher B',
  },
  _PC_SPEC_ROX_OQC: {
    id: '_PC_SPEC_ROX_OQC',
    defaultMessage: 'ROX / Onyx Quencher C',
  },
  _PC_SPEC_TEXAS_OQC: {
    id: '_PC_SPEC_TEXAS_OQC',
    defaultMessage: 'TxRd / Onyx Quencher C',
  },
  _PC_SPEC_AMOUNT: { id: '_PC_SPEC_AMOUNT', defaultMessage: 'Amount' },
  _PC_SPEC_QUANTITATION: {
    id: '_PC_SPEC_QUANTITATION',
    defaultMessage: 'Quantitation',
  },
  _PC_SPEC_LABELED_AMINO_ACIDS: {
    id: '_PC_SPEC_LABELED_AMINO_ACIDS',
    defaultMessage: 'Labeled Amino Acids',
  },
  _PC_SPEC_N_TERMINAL_MOD: {
    id: '_PC_SPEC_N_TERMINAL_MOD',
    defaultMessage: 'N-Terminal Modifications',
  },
  _PC_SPEC_INTERNALMODS: {
    id: '_PC_SPEC_INTERNALMODS',
    defaultMessage: 'Internal Modifications',
  },
  _PC_SPEC_C_TERMINAL_MOD: {
    id: '_PC_SPEC_C_TERMINAL_MOD',
    defaultMessage: 'C-Terminal Modifications',
  },
  _PC_SPEC_F_C13N15: {
    id: '_PC_SPEC_F_C13N15',
    defaultMessage: '[F_C13N15] = Phenylalanine_C13N15',
  },
  _PC_SPEC_I_C13N15: {
    id: '_PC_SPEC_I_C13N15',
    defaultMessage: '[I_C13N15] = Isoleucine_C13N15',
  },
  _PC_SPEC_K_C13N15: {
    id: '_PC_SPEC_K_C13N15',
    defaultMessage: '[K_C13N15] = Lysine_C13N15',
  },
  _PC_SPEC_L_C13N15: {
    id: '_PC_SPEC_L_C13N15',
    defaultMessage: '[L_C13N15] = Leucine_C13N15',
  },
  _PC_SPEC_P_C13N15: {
    id: '_PC_SPEC_P_C13N15',
    defaultMessage: '[P_C13N15] = Proline_C13N15',
  },
  _PC_SPEC_R_C13N15: {
    id: '_PC_SPEC_R_C13N15',
    defaultMessage: '[R_C13N15] = Arginine_C13N15',
  },
  _PC_SPEC_V_C13N15: {
    id: '_PC_SPEC_V_C13N15',
    defaultMessage: '[V_C13N15] = Valine_C13N15',
  },
  _PC_SPEC_PSER: {
    id: '_PC_SPEC_PSER',
    defaultMessage: '[pSer] = Phosphoserine',
  },
  _PC_SPEC_PTHR: {
    id: '_PC_SPEC_PTHR',
    defaultMessage: '[pThr] = Phosphothreonine',
  },
  _PC_SPEC_PTYR: {
    id: '_PC_SPEC_PTYR',
    defaultMessage: '[pTyr] = Phosphotyrosine',
  },
  _PC_SPEC_CM_CYS: {
    id: '_PC_SPEC_CM_CYS',
    defaultMessage: '[CM_Cys] = Carboxymethylated Cys',
  },
  _PC_SPEC_CAM: {
    id: '_PC_SPEC_CAM',
    defaultMessage: '[CAM] = Carbamidomethylated Cys',
  },
  _PC_SPEC_K_UBQ: {
    id: '_PC_SPEC_K_UBQ',
    defaultMessage: '[K_Ubq] = Ubiquitinated Lysine',
  },
  _PC_SPEC_HYP: {
    id: '_PC_SPEC_HYP',
    defaultMessage: '[Hyp] = Hydroxyproline',
  },
  _PC_SPEC_ACE_K: {
    id: '_PC_SPEC_ACE_K',
    defaultMessage: '[ace-K] = Acetylated Lysine',
  },
  _PC_SPEC_KME2: {
    id: '_PC_SPEC_KME2',
    defaultMessage: '[K-Me2] = Dimethylated Lysine',
  },
  _PC_SPEC_NIT_Y: {
    id: '_PC_SPEC_NIT_Y',
    defaultMessage: '[Nit-Y] = Nitrotyrosine',
  },
  _PC_SPEC_C_ACM: {
    id: '_PC_SPEC_C_ACM',
    defaultMessage: '[C-acm] = Acetomidomethylated Cys',
  },
  _PC_SPEC_PGLU: {
    id: '_PC_SPEC_PGLU',
    defaultMessage: '[pGlu] = Pyroglutamic acid',
  },
  _PC_SPEC_METO: {
    id: '_PC_SPEC_METO',
    defaultMessage: '[MetO] = Methionine Sulfoxide',
  },
  _PC_SPEC_H_aqua: {
    id: '_PC_SPEC_H_aqua',
    defaultMessage: '[H] = Free Amine',
  },
  _PC_SPEC_ACE: { id: '_PC_SPEC_ACE', defaultMessage: '[Ace] = Acetylation' },
  _PC_SPEC_Btn: {
    id: '_PC_SPEC_Btn',
    defaultMessage: '[Btn] = Biotin (includes Ahx spacer)',
  },
  _PC_SPEC_OH: { id: '_PC_SPEC_OH', defaultMessage: '[OH] = Free Acid' },
  _PC_SPEC_NH2: { id: '_PC_SPEC_NH2', defaultMessage: '[NH2] = Amidation' },
  _PC_SPEC_Ahx: { id: '_PC_SPEC_Ahx', defaultMessage: 'Aminohexanoic acid' },
  _PC_SPEC_10_NMOL_2_D: {
    id: '_PC_SPEC_10_NMOL_2_D',
    defaultMessage: '10 nmol (2 OD)',
  },
  _PC_SPEC_25_NMOL_5_D: {
    id: '_PC_SPEC_25_NMOL_5_D',
    defaultMessage: '25 nmol (5 OD)',
  },
  _PC_SPEC_50_NMOL_10_D: {
    id: '_PC_SPEC_50_NMOL_10_D',
    defaultMessage: '50 nmol (10 OD)',
  },
  _PC_SPEC_250_NMOL_50_D: {
    id: '_PC_SPEC_250_NMOL_50_D',
    defaultMessage: '250 nmol (50 OD)',
  },
  _PC_SPEC_6FAM: { id: '_PC_SPEC_6FAM', defaultMessage: '6-FAM' },
  _PC_SPEC_5_Biotin: { id: '_PC_SPEC_5_Biotin', defaultMessage: 'Biotin' },
  _PC_SPEC_Cyanine3: { id: '_PC_SPEC_Cyanine3', defaultMessage: 'Cyanine 3' },
  _PC_SPEC_Cyanine5: { id: '_PC_SPEC_Cyanine5', defaultMessage: 'Cyanine 5' },
  _PC_SPEC_Cyanine55: {
    id: '_PC_SPEC_Cyanine55',
    defaultMessage: 'Cyanine 5.5',
  },
  _PC_SPEC_Invert_Abasic: {
    id: '_PC_SPEC_Invert_Abasic',
    defaultMessage: 'Inverted Abasic',
  },
  _PC_SPEC_Thiol_Modifier_C6_S_S: {
    id: '_PC_SPEC_Thiol_Modifier_C6_S_S',
    defaultMessage: 'Thiol-Modifier C6 S-S',
  },
  _PC_SPEC_THIC3: {
    id: '_PC_SPEC_THIC3',
    defaultMessage: 'Thiol-Modifier C3 S-S',
  },
  _PC_SPEC_G_5_Inverse_Oligo: {
    id: '_PC_SPEC_G_5_Inverse_Oligo',
    defaultMessage: 'Inverted dT',
  },
  _PC_PLATE_SPECIFICATIONS_RP1: {
    id: '_PC_PLATE_SPECIFICATIONS_RP1',
    defaultMessage: 'Cartridge',
  },
  _PC_PLATE_SPECIFICATIONS_HPLC: {
    id: '_PC_PLATE_SPECIFICATIONS_HPLC',
    defaultMessage: 'HPLC',
  },
  _PC_PLATE_SPECIFICATIONS_PAGE: {
    id: '_PC_PLATE_SPECIFICATIONS_PAGE',
    defaultMessage: 'PAGE',
  },
  _PC_PLATE_SPECIFICATIONS_DRY: {
    id: '_PC_PLATE_SPECIFICATIONS_DRY',
    defaultMessage: 'Dry',
  },
  _PC_PLATE_SPECIFICATIONS_LIQUID: {
    id: '_PC_PLATE_SPECIFICATIONS_LIQUID',
    defaultMessage: 'In Solution (Water)',
  },
  _PC_PLATE_SPECIFICATIONS_TE: {
    id: '_PC_PLATE_SPECIFICATIONS_TE',
    defaultMessage: 'In Solution (TE)',
  },
  _PC_PLATE_SPECIFICATIONS_TRIS: {
    id: '_PC_PLATE_SPECIFICATIONS_TRIS',
    defaultMessage: 'In Solution (TRIS)',
  },
  _PC_SPEC_D2_PA: {
    id: '_PC_SPEC_D2_PA',
    defaultMessage: '[D2-PA] = WellRED D2-PA',
  },
  _PC_SPEC_D3_PA: {
    id: '_PC_SPEC_D3_PA',
    defaultMessage: '[D3-PA] = WellRED D3-PA',
  },
  _PC_SPEC_D4_PA: {
    id: '_PC_SPEC_D4_PA',
    defaultMessage: '[D4-PA] = WellRED D4-PA',
  },
  _PC_SPEC_2_D: { id: '_PC_SPEC_2_D', defaultMessage: '2 OD' },
  _PC_SPEC_4_D: { id: '_PC_SPEC_4_D', defaultMessage: '4 OD' },
  _PC_SPEC_20_D: { id: '_PC_SPEC_20_D', defaultMessage: '20 OD' },
  _PC_SPEC_40_D: { id: '_PC_SPEC_40_D', defaultMessage: '40 OD' },
  _PC_SPEC_R1_CATRIDGE: {
    id: '_PC_SPEC_R1_CATRIDGE',
    defaultMessage: 'Cartridge',
  },
  _PC_SPEC_LOCKED_BASE_A: {
    id: '_PC_SPEC_LOCKED_BASE_A',
    defaultMessage: '[+A] - Locked Base A',
  },
  _PC_SPEC_LOCKED_BASE_C: {
    id: '_PC_SPEC_LOCKED_BASE_C',
    defaultMessage: '[+C] - Locked Base C',
  },
  _PC_SPEC_LOCKED_BASE_G: {
    id: '_PC_SPEC_LOCKED_BASE_G',
    defaultMessage: '[+G] - Locked Base G',
  },
  _PC_SPEC_LOCKED_BASE_T: {
    id: '_PC_SPEC_LOCKED_BASE_T',
    defaultMessage: '[+T] - Locked Base T',
  },
  _PC_SPEC_K_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_K_DNA_DEGENERATE_BASE',
    defaultMessage: 'K (G,T)',
  },
  _PC_SPEC_H_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_H_DNA_DEGENERATE_BASE',
    defaultMessage: 'H (A,T,C)',
  },
  _PC_SPEC_D_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_D_DNA_DEGENERATE_BASE',
    defaultMessage: 'D (A,G,T)',
  },
  _PC_SPEC_Y_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_Y_DNA_DEGENERATE_BASE',
    defaultMessage: 'Y (C,T)',
  },
  _PC_SPEC_S_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_S_DNA_DEGENERATE_BASE',
    defaultMessage: 'S (C,G)',
  },
  _PC_SPEC_B_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_B_DNA_DEGENERATE_BASE',
    defaultMessage: 'B (C,G,T)',
  },
  _PC_SPEC_N_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_N_DNA_DEGENERATE_BASE',
    defaultMessage: 'N (A,C,G,T)',
  },
  _PC_SPEC_M_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_M_DNA_DEGENERATE_BASE',
    defaultMessage: 'M (A,C)',
  },
  _PC_SPEC_W_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_W_DNA_DEGENERATE_BASE',
    defaultMessage: 'W (A,T)',
  },
  _PC_SPEC_V_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_V_DNA_DEGENERATE_BASE',
    defaultMessage: 'V (A,C,G)',
  },
  _PC_SPEC_R_DNA_DEGENERATE_BASE: {
    id: '_PC_SPEC_R_DNA_DEGENERATE_BASE',
    defaultMessage: 'R (A,G)',
  },
  _PC_SPEC_DEOXYURIDINE: {
    id: '_PC_SPEC_DEOXYURIDINE',
    defaultMessage: 'U (deoxyUridine)',
  },
  _PC_SPEC_INOSINE: {
    id: '_PC_SPEC_INOSINE',
    defaultMessage: 'I (deoxyInosine)',
  },
  _PC_SPEC_2_OMe_A: { id: '_PC_SPEC_2_OMe_A', defaultMessage: '2-OMe-RNA A' },
  _PC_SPEC_2_OMe_C: { id: '_PC_SPEC_2_OMe_C', defaultMessage: '2-OMe-RNA C' },
  _PC_SPEC_2_OMe_G: { id: '_PC_SPEC_2_OMe_G', defaultMessage: '2-OMe-RNA G' },
  _PC_SPEC_2_OMe_U: { id: '_PC_SPEC_2_OMe_U', defaultMessage: '2-OMe-RNA U' },
  _PC_SPEC_R: { id: '_PC_SPEC_R', defaultMessage: 'R (A,G)' },
  _PC_SPEC_K: { id: '_PC_SPEC_K', defaultMessage: 'K (G,U)' },
  _PC_SPEC_H: { id: '_PC_SPEC_H', defaultMessage: 'H (A,U,C)' },
  _PC_SPEC_D: { id: '_PC_SPEC_D', defaultMessage: 'D (A,G,U)' },
  _PC_SPEC_Y: { id: '_PC_SPEC_Y', defaultMessage: 'Y (C,U)' },
  _PC_SPEC_S: { id: '_PC_SPEC_S', defaultMessage: 'S (C,G)' },
  _PC_SPEC_B: { id: '_PC_SPEC_B', defaultMessage: 'B (C,G,U)' },
  _PC_SPEC_N: { id: '_PC_SPEC_N', defaultMessage: 'N (A,C,G,U)' },
  _PC_SPEC_M: { id: '_PC_SPEC_M', defaultMessage: 'M (A,C)' },
  _PC_SPEC_W: { id: '_PC_SPEC_W', defaultMessage: 'W (A,U)' },
  _PC_SPEC_V: { id: '_PC_SPEC_V', defaultMessage: 'V (A,C,G)' },
  _PC_SPEC_BASE_dA: {
    id: '_PC_SPEC_BASE_dA',
    defaultMessage: '[dA]-DNA Base A',
  },
  _PC_SPEC_BASE_dC: {
    id: '_PC_SPEC_BASE_dC',
    defaultMessage: '[dC]-DNA Base C',
  },
  _PC_SPEC_BASE_dG: {
    id: '_PC_SPEC_BASE_dG',
    defaultMessage: '[dG]-DNA Base G',
  },
  _PC_SPEC_BASE_dT: {
    id: '_PC_SPEC_BASE_dT',
    defaultMessage: '[dT]-DNA Base T',
  },
  _PC_SPEC_DEOXYURIDINE_RNA: {
    id: '_PC_SPEC_DEOXYURIDINE_RNA',
    defaultMessage: '[dU] (deoxyUridine)',
  },
  _PC_SPEC_INOSINE_RNA: {
    id: '_PC_SPEC_INOSINE_RNA',
    defaultMessage: '[dI] (deoxyInosine)',
  },
  _PC_SPEC_2Flouro_A: {
    id: '_PC_SPEC_2Flouro_A',
    defaultMessage: "2'-Fluoro A",
  },
  _PC_SPEC_2Flouro_C: {
    id: '_PC_SPEC_2Flouro_C',
    defaultMessage: "2'-Fluoro C",
  },
  _PC_SPEC_2Flouro_G: {
    id: '_PC_SPEC_2Flouro_G',
    defaultMessage: "2'-Fluoro G",
  },
  _PC_SPEC_2Flouro_U: {
    id: '_PC_SPEC_2Flouro_U',
    defaultMessage: "2'-Fluoro U",
  },
  _PC_SPEC_0_0250_UMO: {
    id: '_PC_SPEC_0_0250_UMO',
    defaultMessage: '0.025 µmole',
  },
  _PC_SPEC_0_0500_UMO: {
    id: '_PC_SPEC_0_0500_UMO',
    defaultMessage: '0.05 µmole',
  },
  _PC_SPEC_0_2000_UMO: {
    id: '_PC_SPEC_0_2000_UMO',
    defaultMessage: '0.2 µmole',
  },
  _PC_SPEC_1_0000_UMO: { id: '_PC_SPEC_1_0000_UMO', defaultMessage: '1 µmole' },
  _PC_SPEC_10_0000_UMO: {
    id: '_PC_SPEC_10_0000_UMO',
    defaultMessage: '10 µmole',
  },
  _PC_SPEC_15_0000_UMO: {
    id: '_PC_SPEC_15_0000_UMO',
    defaultMessage: '15 µmole',
  },
  _PC_SPEC_D1_D: { id: '_PC_SPEC_D1_D', defaultMessage: '0.1 OD' },
  _PC_SPEC_D25_D: { id: '_PC_SPEC_D25_D', defaultMessage: '0.25 OD' },
  _PC_SPEC_1D5_D: { id: '_PC_SPEC_1D5_D', defaultMessage: '1.5 OD' },
  _PC_SPEC_15_D: { id: '_PC_SPEC_15_D', defaultMessage: '15 OD' },
  _PC_SPEC_dT_dT: { id: '_PC_SPEC_dT_dT', defaultMessage: '[dT][dT]' },
  _PC_SPEC_UU: { id: '_PC_SPEC_UU', defaultMessage: 'UU' },
  _PC_SPEC_A: { id: '_PC_SPEC_A', defaultMessage: 'A' },
  _PC_SPEC_C: { id: '_PC_SPEC_C', defaultMessage: 'C' },
  _PC_SPEC_G: { id: '_PC_SPEC_G', defaultMessage: 'G' },
  _PC_SPEC_T: { id: '_PC_SPEC_T', defaultMessage: 'T' },
  _PC_SPEC_A_LNA_BASE: {
    id: '_PC_SPEC_A_LNA_BASE',
    defaultMessage: '[+A] - LNA Base A',
  },
  _PC_SPEC_C_LNA_BASE: {
    id: '_PC_SPEC_C_LNA_BASE',
    defaultMessage: '[+C] - LNA Base C',
  },
  _PC_SPEC_G_LNA_BASE: {
    id: '_PC_SPEC_G_LNA_BASE',
    defaultMessage: '[+G] - LNA Base G',
  },
  _PC_SPEC_T_LNA_BASE: {
    id: '_PC_SPEC_T_LNA_BASE',
    defaultMessage: '[+T] - LNA Base T',
  },
  _PC_SPEC_dT_dG: { id: '_PC_SPEC_dT_dG', defaultMessage: '[dT][dG]' },
  _PC_SPEC_dT_dC: { id: '_PC_SPEC_dT_dC', defaultMessage: '[dT][dC]' },
  _PC_SPEC_dT_dA: { id: '_PC_SPEC_dT_dA', defaultMessage: '[dT][dA]' },
  _PC_SPEC_dG_dT: { id: '_PC_SPEC_dG_dT', defaultMessage: '[dG][dT]' },
  _PC_SPEC_dG_dG: { id: '_PC_SPEC_dG_dG', defaultMessage: '[dG][dG]' },
  _PC_SPEC_dG_dC: { id: '_PC_SPEC_dG_dC', defaultMessage: '[dG][dC]' },
  _PC_SPEC_dG_dA: { id: '_PC_SPEC_dG_dA', defaultMessage: '[dG][dA]' },
  _PC_SPEC_dC_dT: { id: '_PC_SPEC_dC_dT', defaultMessage: '[dC][dT]' },
  _PC_SPEC_dC_dG: { id: '_PC_SPEC_dC_dG', defaultMessage: '[dC][dG]' },
  _PC_SPEC_dA_dA: { id: '_PC_SPEC_dA_dA', defaultMessage: '[dA][dA]' },
  _PC_SPEC_dC_dC: { id: '_PC_SPEC_dC_dC', defaultMessage: '[dC][dC]' },
  _PC_SPEC_dC_dA: { id: '_PC_SPEC_dC_dA', defaultMessage: '[dC][dA]' },
  _PC_SPEC_dA_dT: { id: '_PC_SPEC_dA_dT', defaultMessage: '[dA][dT]' },
  _PC_SPEC_dA_dG: { id: '_PC_SPEC_dA_dG', defaultMessage: '[dA][dG]' },
  _PC_SPEC_dA_dC: { id: '_PC_SPEC_dA_dC', defaultMessage: '[dA][dC]' },
  _PC_SPEC_dT__dT: { id: '_PC_SPEC_dT__dT', defaultMessage: '[dT]*[dT]' },
  _PC_SPEC_NONE_VALUE: { id: '_PC_SPEC_NONE_VALUE', defaultMessage: 'None' },
  _PC_SPEC_3_AmC7: {
    id: '_PC_SPEC_3_AmC7',
    defaultMessage: '3-Amino-Modifier-C6',
  },
  _PC_SPEC_3_Amino_Modifier_C6: {
    id: '_PC_SPEC_3_Amino_Modifier_C6',
    defaultMessage: 'Amino-Modifier C6',
  },
  _PC_SPEC_5_Btn: { id: '_PC_SPEC_5_Btn', defaultMessage: '5-Biotin' },
  _PC_DUPLEX_Cyanine3: {
    id: '_PC_DUPLEX_Cyanine3',
    defaultMessage: 'Cyanine 3',
  },
  _PC_DUPLEX_Cyanine5: {
    id: '_PC_DUPLEX_Cyanine5',
    defaultMessage: 'Cyanine 5',
  },
  _PC_SPEC_Cyanine5_5: {
    id: '_PC_SPEC_Cyanine5_5',
    defaultMessage: 'Cyanine55',
  },
  _PC_SPEC_dT5F: { id: '_PC_SPEC_dT5F', defaultMessage: 'Flipped base' },
  _PC_SPEC_FLUORESCEIN: {
    id: '_PC_SPEC_FLUORESCEIN',
    defaultMessage: 'Fluorescein',
  },
  _PC_SPEC_InvAb: { id: '_PC_SPEC_InvAb', defaultMessage: 'Inverted Abasic' },
  _PC_SPEC_Phos: { id: '_PC_SPEC_Phos', defaultMessage: 'Phosphate' },
  _PC_SPEC_MOD_6FAM: { id: '_PC_SPEC_MOD_6FAM', defaultMessage: '6-FAM' },
  _PC_SPEC_ATTACHMENT_THC6_SS: {
    id: '_PC_SPEC_ATTACHMENT_THC6_SS',
    defaultMessage: 'Thiol-Modifier-C6 S-S',
  },
  _PC_SPEC_ATTACHMENT_THC3: {
    id: '_PC_SPEC_ATTACHMENT_THC3',
    defaultMessage: 'Thiol-Modifier C3',
  },
  _PC_SPEC_TUBES: { id: '_PC_SPEC_TUBES', defaultMessage: 'Tubes' },
  _PC_SPEC_10_mg: { id: '_PC_SPEC_10_mg', defaultMessage: '10 mg' },
  _PC_SPEC_25_mg: { id: '_PC_SPEC_25_mg', defaultMessage: '25 mg' },
  _PC_SPEC_50_mg: { id: '_PC_SPEC_50_mg', defaultMessage: '50 mg' },
  _PC_SPEC_100_mg: { id: '_PC_SPEC_100_mg', defaultMessage: '100 mg' },
  _PC_SPEC_2_000_mg: { id: 'PC_SPEC_2_000_mg', defaultMessage: '2 mg' },
  _PC_SPEC_3_000_mg: { id: 'PC_SPEC_3_000_mg', defaultMessage: '3 mg' },
  _PC_SPEC_5_000_mg: { id: 'PC_SPEC_5_000_mg', defaultMessage: '5 mg' },
  _PC_SPEC_10_000_mg: { id: 'PC_SPEC_10_000_mg', defaultMessage: '10 mg' },
  _PC_SPEC_25_000_mg: { id: 'PC_SPEC_25_000_mg', defaultMessage: '25 mg' },
  _PC_SPEC_50_000_mg: { id: 'PC_SPEC_50_000_mg', defaultMessage: '50 mg' },
  _PC_SPEC_100_000_mg: { id: 'PC_SPEC_100_000_mg', defaultMessage: '100 mg' },
  _PC_PROPERTY_DISPLAY_Unpurified_screen: {
    id: '_PC_PROPERTY_DISPLAY_Unpurified_screen',
    defaultMessage: 'Unpurified',
  },
  _PC_SPEC_2_OD: { id: '_PC_SPEC_2_OD', defaultMessage: '10 nmol (2 OD)' },
  _PC_SPEC_5_OD: { id: '_PC_SPEC_5_OD', defaultMessage: '25 nmol (5 OD)' },
  _PC_SPEC_10_OD: { id: '_PC_SPEC_10_OD', defaultMessage: '50 nmol (10 OD)' },
  _PC_SPEC_50_OD: { id: '_PC_SPEC_50_OD', defaultMessage: '250 nmol (50 OD)' },
  _PC_SPEC_10: { id: '_PC_SPEC_10', defaultMessage: '10 mg' },
  _PC_SPEC_25: { id: '_PC_SPEC_25', defaultMessage: '25 mg' },
  _PC_SPEC_50: { id: '_PC_SPEC_50', defaultMessage: '50 mg' },
  _PC_SPEC_100: { id: '_PC_SPEC_100', defaultMessage: '100 mg' },
  _PC_SPEC_250: { id: '_PC_SPEC_250', defaultMessage: '250 mg' },
  _PC_SPEC_500: { id: '_PC_SPEC_500', defaultMessage: '500 mg' },
  _PC_SPEC_1000: { id: '_PC_SPEC_1000', defaultMessage: '1000 mg' },
  _PC_SPEC_amount_10: { id: '_PC_SPEC_amount_10', defaultMessage: '10 mg' },
  _PC_SPEC_amount_25: { id: '_PC_SPEC_amount_25', defaultMessage: '25 mg' },
  _PC_SPEC_amount_50: { id: '_PC_SPEC_amount_50', defaultMessage: '50 mg' },
  _PC_SPEC_amount_100: { id: '_PC_SPEC_amount_100', defaultMessage: '100 mg' },
  _PC_SPEC_amount_250: { id: '_PC_SPEC_amount_250', defaultMessage: '250 mg' },
  _PC_SPEC_amount_500: { id: '_PC_SPEC_amount_500', defaultMessage: '500 mg' },
  _PC_SPEC_amount_1000: {
    id: '_PC_SPEC_amount_1000',
    defaultMessage: '1000 mg',
  },
  _PC_SPEC_amount_2000: {
    id: '_PC_SPEC_amount_2000',
    defaultMessage: '2000 mg',
  },
  _PC_SPEC_amount_5000: {
    id: '_PC_SPEC_amount_5000',
    defaultMessage: '5000 mg',
  },
  _PC_SPEC_amount_10000: {
    id: '_PC_SPEC_amount_10000',
    defaultMessage: '10000 mg',
  },
  _PC_SPEC_amount_15000: {
    id: '_PC_SPEC_amount_15000',
    defaultMessage: '15000 mg',
  },
  _PC_SPEC_2000: { id: '_PC_SPEC_2000', defaultMessage: '2000 mg' },
  _PC_SPEC_5000: { id: '_PC_SPEC_5000', defaultMessage: '5000 mg' },
  _PC_SPEC_10000: { id: '_PC_SPEC_10000', defaultMessage: '10000 mg' },
  _PC_SPEC_15000: { id: '_PC_SPEC_15000', defaultMessage: '15000 mg' },
  _PC_SPEC_DEOXYURIDINE_DUPLEX: {
    id: '_PC_SPEC_DEOXYURIDINE_DUPLEX',
    defaultMessage: '[dU]-DeoxyUridine',
  },
  _PC_SPEC_2_FLA: {
    id: '_PC_SPEC_2_FLA',
    defaultMessage: "[2flA]-2'- Fluoro A",
  },
  _PC_SPEC_2_FLC: {
    id: '_PC_SPEC_2_FLC',
    defaultMessage: "[2flC]-2'- Fluoro C",
  },
  _PC_SPEC_2_FLG: {
    id: '_PC_SPEC_2_FLG',
    defaultMessage: "[2flG]-2'- Fluoro G",
  },
  _PC_SPEC_2_FLU: {
    id: '_PC_SPEC_2_FLU',
    defaultMessage: "[2flU]-2'- Fluoro U",
  },
  _PC_SPEC_BASE_mA: {
    id: '_PC_SPEC_BASE_mA',
    defaultMessage: "[mA]-2'-OMe RNA Base A",
  },
  _PC_SPEC_BASE_mC: {
    id: '_PC_SPEC_BASE_mC',
    defaultMessage: "[mC]-2'-OMe RNA Base C",
  },
  _PC_SPEC_BASE_mG: {
    id: '_PC_SPEC_BASE_mG',
    defaultMessage: "[mG]-2'-OMe RNA Base G",
  },
  _PC_SPEC_BASE_mU: {
    id: '_PC_SPEC_BASE_mU',
    defaultMessage: "[mU]-2'-OMe RNA Base U",
  },
  _PC_SPEC_BASE_dC_duplex: {
    id: '_PC_SPEC_BASE_dC_duplex',
    defaultMessage: '[dC]-DNA Base C',
  },
  _PC_SPEC_BASE_dT_duplex: {
    id: '_PC_SPEC_BASE_dT_duplex',
    defaultMessage: '[dT]-DNA Base T',
  },
  _PC_SPEC_6FAM_DABC: {
    id: '_PC_SPEC_6FAM_DABC',
    defaultMessage: '6-FAM / Dabcyl',
  },
  _PC_SPEC_6FAM_MGBQ: {
    id: '_PC_SPEC_6FAM_MGBQ',
    defaultMessage: '6-FAM / MGB-Q',
  },
  _PC_SPEC_HEX_MGBQ: {
    id: '_PC_SPEC_HEX_MGBQ',
    defaultMessage: 'HEX / MGB-Q',
  },
  _PC_SPEC_TET_MGBQ: {
    id: '_PC_SPEC_TET_MGBQ',
    defaultMessage: 'TET / MGB-Q',
  },
  _PC_SPEC_HEX_DABC: {
    id: '_PC_SPEC_HEX_DABC',
    defaultMessage: 'HEX / Dabcyl',
  },
  _PC_SPEC_TEXAS_DABC: {
    id: '_PC_SPEC_TEXAS_DABC',
    defaultMessage: 'TxRd / Dabcyl',
  },
  _PC_SPEC_JOE_DABC: {
    id: '_PC_SPEC_JOE_DABC',
    defaultMessage: 'JOE / Dabcyl',
  },
  _PC_SPEC_CY5_DABC: {
    id: '_PC_SPEC_CY5_DABC',
    defaultMessage: 'Cyanine 5 / Dabcyl',
  },
  _PC_SPEC_CY55_DABC: {
    id: '_PC_SPEC_CY55_DABC',
    defaultMessage: 'Cyanine 5.5 / Dabcyl',
  },
  _PC_SPEC_TET_DABC: {
    id: '_PC_SPEC_TET_DABC',
    defaultMessage: 'TET / Dabcyl',
  },
  _PC_SPEC_CY3_DABC: {
    id: '_PC_SPEC_CY3_DABC',
    defaultMessage: 'Cyanine 3 / Dabcyl',
  },
  _PC_SPEC_ROX_DABC: {
    id: '_PC_SPEC_ROX_DABC',
    defaultMessage: 'ROX / Dabcyl',
  },
  _PC_SPEC_DEOXYURIDINE_BITUBE: {
    id: '_PC_SPEC_DEOXYURIDINE_BITUBE',
    defaultMessage: 'U - deoxyUridine',
  },
  _PC_SPEC_BASE_B: {
    id: '_PC_SPEC_BASE_B',
    defaultMessage: 'B - Degenerate Base B',
  },
  _PC_SPEC_BASE_M: {
    id: '_PC_SPEC_BASE_M',
    defaultMessage: 'M - Degenerate Base M',
  },
  _PC_SPEC_BASE_V: {
    id: '_PC_SPEC_BASE_V',
    defaultMessage: 'V - Degenerate Base V',
  },
  _PC_SPEC_BASE_D: {
    id: '_PC_SPEC_BASE_D',
    defaultMessage: 'D - Degenerate Base D',
  },
  _PC_SPEC_BASE_N: {
    id: '_PC_SPEC_BASE_N',
    defaultMessage: 'N - Degenerate Base N',
  },
  _PC_SPEC_BASE_W: {
    id: '_PC_SPEC_BASE_W',
    defaultMessage: 'W - Degenerate Base W',
  },
  _PC_SPEC_BASE_H: {
    id: '_PC_SPEC_BASE_H',
    defaultMessage: 'H - Degenerate Base H',
  },
  _PC_SPEC_BASE_R: {
    id: '_PC_SPEC_BASE_R',
    defaultMessage: 'R - Degenerate Base R',
  },
  _PC_SPEC_BASE_Y: {
    id: '_PC_SPEC_BASE_Y',
    defaultMessage: 'Y - Degenerate Base Y',
  },
  _PC_SPEC_BASE_K: {
    id: '_PC_SPEC_BASE_K',
    defaultMessage: 'K - Degenerate Base K',
  },
  _PC_SPEC_BASE_S: {
    id: '_PC_SPEC_BASE_S',
    defaultMessage: 'S - Degenerate Base S',
  },
  _PC_SPEC_INOSINE_BITUBE: {
    id: '_PC_SPEC_INOSINE_BITUBE',
    defaultMessage: 'I - deoxyInosine',
  },
  _PC_SPEC__A: { id: '_PC_SPEC__A', defaultMessage: '[+A] - LNA Base A' },
  _PC_SPEC__C: { id: '_PC_SPEC__C', defaultMessage: '[+C] - LNA Base C' },
  _PC_SPEC__G: { id: '_PC_SPEC__G', defaultMessage: '[+G] - LNA Base G' },
  _PC_SPEC__T: { id: '_PC_SPEC__T', defaultMessage: '[+T] - LNA Base T' },
  _PC_SPEC_INT_MOD_RED_610: {
    id: '_PC_SPEC_INT_MOD_RED_610',
    defaultMessage: '[LC610] - Red 610',
  },
  _PC_SPEC_INT_MOD_RED_640: {
    id: '_PC_SPEC_INT_MOD_RED_640',
    defaultMessage: '[LC640] - Red 640',
  },
  _PC_SPEC_RED_610: { id: '_PC_SPEC_RED_610', defaultMessage: 'Red 610' },
  _PC_SPEC_RED_640: { id: '_PC_SPEC_RED_640', defaultMessage: 'Red 640' },
  _PC_SPEC_RED_670: { id: '_PC_SPEC_RED_670', defaultMessage: 'Red 670' },
  _PC_SPEC_RED_705: { id: '_PC_SPEC_RED_705', defaultMessage: 'Red 705' },
  _PC_SPEC_LCFLC: { id: '_PC_SPEC_LCFLC', defaultMessage: 'Fluorescein' },
  _PC_SPEC_0_010_mg: { id: '_PC_SPEC_0_010_mg', defaultMessage: '5x1 nmol' },
  _PC_SPEC_G95: { id: '_PC_SPEC_G95', defaultMessage: '>95%' },
  _PC_SPEC_3_OD: { id: '_PC_SPEC_3_OD', defaultMessage: '3 OD' },
  _PC_SPEC_amount_1_OD: { id: '_PC_SPEC_amount_1_OD', defaultMessage: '1 OD' },
  _PC_SPEC_amount_105_OD: {
    id: '_PC_SPEC_amount_105_OD',
    defaultMessage: '1.5 OD',
  },
  _PC_SPEC_amount_2_OD: { id: '_PC_SPEC_amount_2_OD', defaultMessage: '2 OD' },
  _PC_SPEC_amount_3_OD: { id: '_PC_SPEC_amount_3_OD', defaultMessage: '3 OD' },
  _PC_SPEC_amount_4_OD: { id: '_PC_SPEC_amount_4_OD', defaultMessage: '4 OD' },
  _PC_SPEC_amount_5_OD: { id: '_PC_SPEC_amount_5_OD', defaultMessage: '5 OD' },
  _PC_SPEC_amount_10_OD: {
    id: '_PC_SPEC_amount_10_OD',
    defaultMessage: '10 OD',
  },
  _PC_SPEC_amount_50_OD: {
    id: '_PC_SPEC_amount_50_OD',
    defaultMessage: '50 OD',
  },
  _PC_SPEC_amount_100_OD: {
    id: '_PC_SPEC_amount_100_OD',
    defaultMessage: '100 OD',
  },
  _PC_SPEC_0_1_OD: { id: '_PC_SPEC_0_1_OD', defaultMessage: '0.1 OD' },
  _PC_SPEC_0_25_OD: { id: '_PC_SPEC_D25_D', defaultMessage: '0.25 OD' },
  _PC_SPEC_1_5_OD: { id: '_PC_SPEC_1_5_OD', defaultMessage: '1.5 OD' },
  _PC_SPEC_15_OD: { id: '_PC_SPEC_15_OD', defaultMessage: '15 OD' },
  _PC_SPEC_SALT: { id: '_PC_SPEC_SALT', defaultMessage: 'Salt Exchange' },
  _PC_SPEC_ENDO: { id: '_PC_SPEC_ENDO', defaultMessage: 'Endotoxin Testing' },
  _PC_SPEC_FILTER: { id: '_PC_SPEC_FILTER', defaultMessage: 'Filtration' },
  _PC_SPEC_SERVICES: { id: '_PC_SPEC_SERVICES', defaultMessage: 'Services' },
  _PC_SPEC_PURIFICATION_iscaledna: {
    id: '_PC_SPEC_PURIFICATION_iscaledna',
    defaultMessage: 'Purification',
  },
  _PC_SPEC_250_mg: { id: '_PC_SPEC_250_mg', defaultMessage: '250 mg' },
  _PC_SPEC_500_mg: { id: '_PC_SPEC_500_mg', defaultMessage: '500 mg' },
  _PC_SPEC_1000_mg: { id: '_PC_SPEC_1000_mg', defaultMessage: '1000 mg' },
  _PC_SPEC_2000_mg: { id: '_PC_SPEC_2000_mg', defaultMessage: '2000 mg' },
  _PC_SPEC_5000_mg: { id: '_PC_SPEC_5000_mg', defaultMessage: '5000 mg' },
  _PC_SPEC_10000_mg: { id: '_PC_SPEC_10000_mg', defaultMessage: '10000 mg' },
  _PC_SPEC_15000_mg: { id: '_PC_SPEC_15000_mg', defaultMessage: '15000 mg' },
  _PC_SPEC_Biot: {
    id: '_PC_SPEC_Biot',
    defaultMessage: '[Biot] = Biotin (no spacer)',
  },
  _PC_SPEC_Dans: { id: '_PC_SPEC_Dans', defaultMessage: '[Dans] = Dansyl' },
  _PC_SPEC_2_4_DINITROPHENYL: {
    id: '_PC_SPEC_2_4_DINITROPHENYL',
    defaultMessage: '[Dnp] =2,4-Dinitrophenyl',
  },
  _PC_SPEC_Formic_Acid: {
    id: '_PC_SPEC_Formic_Acid',
    defaultMessage: '[Form] = Formic acid',
  },
  _PC_SPEC_7_methoxycoumarin_Acetic_Acid: {
    id: '_PC_SPEC_7_methoxycoumarin_Acetic_Acid',
    defaultMessage: '[Mca] =  7-methoxycoumarin acetic acid',
  },
  _PC_SPEC_Palmitic_Acid: {
    id: '_PC_SPEC_Palmitic_Acid',
    defaultMessage: '[Palm] = Palmitic acid',
  },
  _PC_SPEC_Fluorescein: {
    id: '_PC_SPEC_Fluorescein',
    defaultMessage: '[Flc] = Fluorescein',
  },
  _PC_PROPERTY_DISPLAY_Desalt_screen: {
    id: '_PC_PROPERTY_DISPLAY_Desalt_screen',
    defaultMessage: 'Desalted',
  },
  _PC_TOR_PEPTIDE_FORMAT_TOOLTIP_screen: {
    id: '_PC_TOR_PEPTIDE_FORMAT_TOOLTIP_screen',
    defaultMessage: ' Dry = Lyophilized; In Solution = 20 mg/mL in DMSO',
  },
  _PC_PROPERTY_DISPLAY_DRY_screen: {
    id: '_PC_PROPERTY_DISPLAY_DRY_screen',
    defaultMessage: 'Dry',
  },
  _PC_PROPERTY_DISPLAY_INSOL_screen: {
    id: '_PC_PROPERTY_DISPLAY_INSOL_screen',
    defaultMessage: 'In Solution (20mg/ml in DMSO)',
  },
  _PC_PROPERTY_DISPLAY_INSOL_40_screen: {
    id: '_PC_PROPERTY_DISPLAY_INSOL_40_screen',
    defaultMessage: 'In Solution (40mg/ml in DMSO)',
  },
  _PC_PROPERTY_DISPLAY_YES_screen: {
    id: '_PC_PROPERTY_DISPLAY_YES_screen',
    defaultMessage: 'Yes',
  },
  _PC_PROPERTY_DISPLAY_NO_screen: {
    id: '_PC_PROPERTY_DISPLAY_NO_screen',
    defaultMessage: 'No',
  },
  _PC_REVIEW_PURITY_PROFILE_YES_screen: {
    id: '_PC_REVIEW_PURITY_PROFILE_YES_screen',
    defaultMessage: 'Yes',
  },
  _PC_REVIEW_PURITY_PROFILE_NO_screen: {
    id: '_PC_REVIEW_PURITY_PROFILE_NO_screen',
    defaultMessage: 'No',
  },
  _PC_SH_PRODUCT_NAME_longoligo: {
    id: '_PC_SH_PRODUCT_NAME_longoligo',
    defaultMessage: 'Long Oligos',
  },
  _PC_SPEC_PURIFICATION: {
    id: '_PC_SPEC_PURIFICATION',
    defaultMessage: 'Purification',
  },
  _PC_SPEC_dUracil: { id: '_PC_SPEC_dUracil', defaultMessage: 'Uracil' },
  _PC_SPEC_JOE: { id: '_PC_SPEC_JOE', defaultMessage: 'JOE' },
  _PC_SPEC_ROX: { id: '_PC_SPEC_ROX', defaultMessage: 'ROX' },
  _PC_SPEC_TAMRA: { id: '_PC_SPEC_TAMRA', defaultMessage: 'TAMRA' },
  _PC_SPEC_Texas_Red: { id: '_PC_SPEC_Texas_Red', defaultMessage: 'TxRd' },
  _PC_SPEC_5_FAMTM: { id: '_PC_SPEC_5_FAMTM', defaultMessage: '5-FAM' },
  _PC_SPEC_Alexa_Fluor_488: {
    id: '_PC_SPEC_Alexa_Fluor_488',
    defaultMessage: 'Sulfonated Fluorescein 488',
  },
  _PC_SPEC_ATTO488: { id: '_PC_SPEC_ATTO488', defaultMessage: 'ATTO 488' },
  _PC_SPEC_ATTO532: { id: '_PC_SPEC_ATTO532', defaultMessage: 'ATTO 532' },
  _PC_SPEC_ATTO550: { id: '_PC_SPEC_ATTO550', defaultMessage: 'ATTO 550' },
  _PC_SPEC_ATTO565: { id: '_PC_SPEC_ATTO565', defaultMessage: 'ATTO 565' },
  _PC_SPEC_ATTO647N: { id: '_PC_SPEC_ATTO647N', defaultMessage: 'ATTO 647N' },
  _PC_SPEC_ATTO680: { id: '_PC_SPEC_ATTO680', defaultMessage: 'ATTO 680' },
  _PC_SPEC_DIGOXIGENIN: {
    id: '_PC_SPEC_DIGOXIGENIN',
    defaultMessage: 'Digoxigenin',
  },
  _PC_SPEC_Oregon_Green_488: {
    id: '_PC_SPEC_Oregon_Green_488',
    defaultMessage: 'Oregon Green 488',
  },
  _PC_SPEC_Oregon_Green_488_X: {
    id: '_PC_SPEC_Oregon_Green_488_X',
    defaultMessage: 'Oregon Green 488-X',
  },
  _PC_SPEC_Oregon_Green_514: {
    id: '_PC_SPEC_Oregon_Green_514',
    defaultMessage: 'Oregon Green 514',
  },
  _PC_SPEC_Pacific_Blue: {
    id: '_PC_SPEC_Pacific_Blue',
    defaultMessage: 'Pacific Blue',
  },
  _PC_SPEC_6_Carboxy_rhodamine: {
    id: '_PC_SPEC_6_Carboxy_rhodamine',
    defaultMessage: '6-Carboxy-rhodamine 6G',
  },
  _PC_SPEC_Rhodamine_RedTM_X: {
    id: '_PC_SPEC_Rhodamine_RedTM_X',
    defaultMessage: 'Rhodamine RedTM-X',
  },
  _PC_SPEC_Derivative_K_dK: {
    id: '_PC_SPEC_Derivative_K_dK',
    defaultMessage: 'Derivative K (dK)',
  },
  _PC_SPEC_Derivative_P_dP: {
    id: '_PC_SPEC_Derivative_P_dP',
    defaultMessage: 'Derivative P (dK)',
  },
  _PC_SPEC_Thymidine_Glycol: {
    id: '_PC_SPEC_Thymidine_Glycol',
    defaultMessage: 'Thymidine Glycol',
  },
  _PC_SPEC_Spacer_9: { id: '_PC_SPEC_Spacer_9', defaultMessage: 'Spacer 9' },
  _PC_SPEC_Spacer_18: { id: '_PC_SPEC_Spacer_18', defaultMessage: 'Spacer 18' },
  _PC_SPEC_Spacer_12: { id: '_PC_SPEC_Spacer_12', defaultMessage: 'Spacer 12' },
  _PC_SPEC_Spacer_C3: { id: '_PC_SPEC_Spacer_C3', defaultMessage: 'Spacer C3' },
  _PC_SPEC_8_Br_dA: { id: '_PC_SPEC_8_Br_dA', defaultMessage: '8-Br-dA' },
  _PC_SPEC_8_Br_dG: { id: '_PC_SPEC_8_Br_dG', defaultMessage: '8-Br-dG' },
  _PC_SPEC_5_Br_dC: { id: '_PC_SPEC_5_Br_dC', defaultMessage: '5-Br-dC' },
  _PC_SPEC_5_Br_dU: { id: '_PC_SPEC_5_Br_dU', defaultMessage: '5-Br-dU' },
  _PC_SPEC_5_Nitroindole: {
    id: '_PC_SPEC_5_Nitroindole',
    defaultMessage: '5-Nitroindole',
  },
  _PC_SPEC_5_Me_dC: { id: '_PC_SPEC_5_Me_dC', defaultMessage: '5-Me-dC' },
  _PC_SPEC_Cytosine_Arabinoside_araC: {
    id: '_PC_SPEC_Cytosine_Arabinoside_araC',
    defaultMessage: 'Cytosine Arabinoside (araC)',
  },
  _PC_SPEC_8_Oxo_dA: { id: '_PC_SPEC_8_Oxo_dA', defaultMessage: '8-oxo-dA' },
  _PC_SPEC_8_Oxo_dG: { id: '_PC_SPEC_8_Oxo_dG', defaultMessage: '8-oxo-dG' },
  _PC_SPEC_2_6_Diaminopurine: {
    id: '_PC_SPEC_2_6_Diaminopurine',
    defaultMessage: '2,6-Diaminopurine',
  },
  _PC_SPEC_2_Aminopurine: {
    id: '_PC_SPEC_2_Aminopurine',
    defaultMessage: '2-Aminopurine',
  },
  _PC_SPEC_dA_5_Inverse_Oligo: {
    id: '_PC_SPEC_dA_5_Inverse_Oligo',
    defaultMessage: "dA-5' (5' to 3' synthesis)",
  },
  _PC_SPEC_dG_5_Inverse_Oligo: {
    id: '_PC_SPEC_dG_5_Inverse_Oligo',
    defaultMessage: "dG-5' (5' to 3' synthesis)",
  },
  _PC_SPEC_dC_5_Inverse_Oligo: {
    id: '_PC_SPEC_dC_5_Inverse_Oligo',
    defaultMessage: "dC-5' (5' to 3' synthesis)",
  },
  _PC_SPEC_dSpacer: { id: '_PC_SPEC_dSpacer', defaultMessage: 'dSpacer' },
  _PC_SPEC_dT_5_Inverse_Oligo: {
    id: '_PC_SPEC_dT_5_Inverse_Oligo',
    defaultMessage: "dT-5' (5' to 3' synthesis)",
  },
  _PC_SPEC_URIDINE: { id: '_PC_SPEC_URIDINE', defaultMessage: 'Uracil' },
  _PC_SPEC_Cholesteryl_TEG: {
    id: '_PC_SPEC_Cholesteryl_TEG',
    defaultMessage: 'Cholesteryl TEG',
  },
  _PC_SPEC_2_OMe_RNA_A: {
    id: '_PC_SPEC_2_OMe_RNA_A',
    defaultMessage: "2'-OMe-RNA A",
  },
  _PC_SPEC_2_OMe_RNA_G: {
    id: '_PC_SPEC_2_OMe_RNA_G',
    defaultMessage: "2'-OMe-RNA G",
  },
  _PC_SPEC_2_OMe_RNA_C: {
    id: '_PC_SPEC_2_OMe_RNA_C',
    defaultMessage: "2'-OMe-RNA C",
  },
  _PC_SPEC_2_OMe_RNA_U: {
    id: '_PC_SPEC_2_OMe_RNA_U',
    defaultMessage: "2'-OMe-RNA U",
  },
  _PC_SPEC_Thiophosphate_S_Oligo: {
    id: '_PC_SPEC_Thiophosphate_S_Oligo',
    defaultMessage: 'Thiophosphate',
  },
  _PC_SPEC_Alexa_Fluor_546: {
    id: '_PC_SPEC_Alexa_Fluor_546',
    defaultMessage: 'Alexa Fluor 546',
  },
  _PC_SPEC_Alexa_Fluor_647: {
    id: '_PC_SPEC_Alexa_Fluor_647',
    defaultMessage: 'Alexa Fluor 647',
  },
  _PC_SPEC_Dabcyl: { id: '_PC_SPEC_Dabcyl', defaultMessage: 'Dabcyl' },
  _PC_SPEC_ONXY_A: { id: '_PC_SPEC_ONXY_A', defaultMessage: 'Onyx Quencher A' },
  _PC_SPEC_ONXY_B: { id: '_PC_SPEC_ONXY_B', defaultMessage: 'Onyx Quencher B' },
  _PC_SPEC_ONXY_C: { id: '_PC_SPEC_ONXY_C', defaultMessage: 'Onyx Quencher C' },
  _PC_SPEC_ONXY_D: { id: '_PC_SPEC_ONXY_D', defaultMessage: 'Onyx Quencher D' },
  _PC_SPEC_3_Amino_Modifier_C3: {
    id: '_PC_SPEC_3_Amino_Modifier_C3',
    defaultMessage: 'Amino-Modifier C3',
  },
  _PC_SPEC_Thiol_Modifier_C3_S_S: {
    id: '_PC_SPEC_Thiol_Modifier_C3_S_S',
    defaultMessage: 'Thiol-Modifier C3 S-S',
  },
  _PC_SPEC_3_dA: {
    id: '_PC_SPEC_3_dA',
    defaultMessage: "3'-dA (chain terminator)",
  },
  _PC_SPEC_3_dG: {
    id: '_PC_SPEC_3_dG',
    defaultMessage: "3'-dG (chain terminator)",
  },
  _PC_SPEC_3_dC: {
    id: '_PC_SPEC_3_dC',
    defaultMessage: "3'-dC (chain terminator)",
  },
  _PC_SPEC_3_dT: {
    id: '_PC_SPEC_3_dT',
    defaultMessage: "3'-dT (chain terminator)",
  },
  _PC_SPEC_FluoresceindT: {
    id: '_PC_SPEC_FluoresceindT',
    defaultMessage: 'Fluorescein dT',
  },
  _PC_SPEC_Amino_Modifier_C2_dT: {
    id: '_PC_SPEC_Amino_Modifier_C2_dT',
    defaultMessage: 'Amino-Modifier C2 dT',
  },
  _PC_SPEC_Amino_Modifier_C6_dT: {
    id: '_PC_SPEC_Amino_Modifier_C6_dT',
    defaultMessage: 'Amino-Modifier C6 dT',
  },
  _PC_SPEC_BIOTIN_DT: { id: '_PC_SPEC_BIOTIN_DT', defaultMessage: 'Biotin dT' },
  _PC_SPEC_2_3_dideoxycytidine_ddC: {
    id: '_PC_SPEC_2_3_dideoxycytidine_ddC',
    defaultMessage: "2',3'-ddC",
  },
  _PC_SPEC_Inosine: { id: '_PC_SPEC_Inosine', defaultMessage: 'Inosine' },
  _PC_SPEC_5BrdC: { id: '_PC_SPEC_5BrdC', defaultMessage: '5-Br-dC' },
  _PC_SPEC_5BrDU: { id: '_PC_SPEC_5BrDU', defaultMessage: '5-Br-dU' },
  _PC_SPEC_FIVEMOD_SPECIAL: {
    id: '_PC_SPEC_FIVEMOD_SPECIAL',
    defaultMessage: 'Special',
  },
  _PC_SPEC_INTERNALMOD_SPECIAL: {
    id: '_PC_SPEC_INTERNALMOD_SPECIAL',
    defaultMessage: 'Special',
  },
  _PC_SPEC_BHQ1: { id: '_PC_SPEC_BHQ1', defaultMessage: 'BHQ1' },
  _PC_SPEC_BHQ2: { id: '_PC_SPEC_BHQ2', defaultMessage: 'BHQ2' },
  _PC_SPEC_BHQ3: { id: '_PC_SPEC_BHQ3', defaultMessage: 'BHQ3' },
  _PC_SPEC_DABDT: { id: '_PC_SPEC_DABDT', defaultMessage: 'Dabcyl' },
  _PC_SPEC_FLUORESCENT: {
    id: '_PC_SPEC_FLUORESCENT',
    defaultMessage: 'Fluorescent',
  },
  _PC_SPEC_ATTACHMENT: {
    id: '_PC_SPEC_ATTACHMENT',
    defaultMessage: 'Attachment',
  },
  _PC_SPEC_BINDING: { id: '_PC_SPEC_BINDING', defaultMessage: 'Binding' },
  _PC_SPEC_SPACER: { id: '_PC_SPEC_SPACER', defaultMessage: 'Spacer' },
  _PC_SPEC_ANALOG: { id: '_PC_SPEC_ANALOG', defaultMessage: 'Analog' },
  _PC_SPEC_ANTISENSE: { id: '_PC_SPEC_ANTISENSE', defaultMessage: 'Antisense' },
  _PC_SPEC_wellred: { id: '_PC_SPEC_wellred', defaultMessage: 'WellRED' },
  _PC_SPEC_VIEWALL_PURITY_LEVEL: {
    id: '_PC_SPEC_VIEWALL_PURITY_LEVEL',
    defaultMessage: 'Purity Level :',
  },
  _PC_SPEC_15_000_mg: { id: 'PC_SPEC_15_000_mg', defaultMessage: '15 mg' },
  _PC_SPEC_2_0NM: { id: '_PC_SPEC_2_0NM', defaultMessage: '2 nmol' },
  _PC_SPEC_5_0NM: { id: '_PC_SPEC_5_0NM', defaultMessage: '5 nmol' },
  _PC_SPEC_YES: { id: '_PC_SPEC_YES', defaultMessage: 'Yes' },
  _PC_SPEC_NO: { id: '_PC_SPEC_NO', defaultMessage: 'No' },
  _PC_SPEC_CUSTOM_CRISPR_N: {
    id: '_PC_SPEC_CUSTOM_CRISPR_N',
    defaultMessage: 'No',
  },
  _PC_SPEC_CUSTOM_CRISPR_Y: {
    id: '_PC_SPEC_CUSTOM_CRISPR_Y',
    defaultMessage: 'Yes',
  },
  _PC_SPEC_3_0NM: { id: '_PC_SPEC_3_0NM', defaultMessage: '3 nmol' },
  _PC_SPEC_FORMAT_TE: {
    id: '_PC_SPEC_FORMAT_TE',
    defaultMessage: 'In Solution (Water)',
  },
  _PC_SIRNA_TITLE: {
    id: '_PC_SIRNA_TITLE',
    defaultMessage: 'Custom siRNA in Tubes',
  },
  _PC_SPEC_UG: { id: '_PC_SPEC_UG', defaultMessage: 'UG' },
  _PC_SPEC_UC: { id: '_PC_SPEC_UC', defaultMessage: 'UC' },
  _PC_SPEC_UA: { id: '_PC_SPEC_UA', defaultMessage: 'UA' },
  _PC_SPEC_GU: { id: '_PC_SPEC_GU', defaultMessage: 'GU' },
  _PC_SPEC_GG: { id: '_PC_SPEC_GG', defaultMessage: 'GG' },
  _PC_SPEC_GC: { id: '_PC_SPEC_GC', defaultMessage: 'GC' },
  _PC_SPEC_GA: { id: '_PC_SPEC_GA', defaultMessage: 'GA' },
  _PC_SPEC_CU: { id: '_PC_SPEC_CU', defaultMessage: 'CU' },
  _PC_SPEC_CG: { id: '_PC_SPEC_CG', defaultMessage: 'CG' },
  _PC_SPEC_CC: { id: '_PC_SPEC_CC', defaultMessage: 'CC' },
  _PC_SPEC_CA: { id: '_PC_SPEC_CA', defaultMessage: 'CA' },
  _PC_SPEC_AU: { id: '_PC_SPEC_AU', defaultMessage: 'AU' },
  _PC_SPEC_AG: { id: '_PC_SPEC_AG', defaultMessage: 'AG' },
  _PC_SPEC_AC: { id: '_PC_SPEC_AC', defaultMessage: 'AC' },
  _PC_SPEC_AA: { id: '_PC_SPEC_AA', defaultMessage: 'AA' },
  _PC_SPEC_0_050_UMO: {
    id: '_PC_SPEC_0_050_UMO',
    defaultMessage: '0.05 µmole',
  },
  _PC_SPEC_DUAL_LABELED: {
    id: '_PC_SPEC_DUAL_LABELED',
    defaultMessage: 'Dual-Labeled',
  },
  _PC_SPEC_INTERNAL_QUENCHED: {
    id: '_PC_SPEC_INTERNAL_QUENCHED',
    defaultMessage: 'Internal-Quenched',
  },
  _PC_SPEC_DUAL_QUENCHED: {
    id: '_PC_SPEC_DUAL_QUENCHED',
    defaultMessage: 'Dual-Quenched',
  },
  _PC_SPEC_0_025_UMO: {
    id: '_PC_SPEC_0_025_UMO',
    defaultMessage: '0.025 µmole',
  },
  _PC_SPEC_0_200_UMO: { id: '_PC_SPEC_0_200_UMO', defaultMessage: '0.2 µmole' },
  _PC_SPEC_1_000_UMO: { id: '_PC_SPEC_1_000_UMO', defaultMessage: '1 µmole' },
  _PC_SPEC_10_000_UMO: {
    id: '_PC_SPEC_10_000_UMO',
    defaultMessage: '10 µmole',
  },
  _PC_SPEC_15_000_UMO: {
    id: '_PC_SPEC_15_000_UMO',
    defaultMessage: '15 µmole',
  },
  _PC_SPEC_IS_WATER_RNA: {
    id: '_PC_SPEC_IS_WATER_RNA',
    defaultMessage: 'In Solution (TE)',
  },
  PC_SPEC_EC_AMINO_LINKER: {
    id: 'PC_SPEC_EC_AMINO_LINKER',
    defaultMessage: 'EC Amino Linker',
  },
  PC_SPEC_LOADING: { id: '_PC_SPEC_LOADING', defaultMessage: 'Loading....' },
  PC_SPEC_IN_SOLUTION: {
    id: 'PC_SPEC_IN_SOLUTION',
    defaultMessage: 'In Solution',
  },
  PC_SPEC_1_duplexplate: {
    id: 'PC_SPEC_1_duplexplate',
    defaultMessage: '1 nmol (0.2 OD)',
  },
  PC_SPEC_2_duplexplate: {
    id: 'PC_SPEC_2_duplexplate',
    defaultMessage: '2 nmol (0.4 OD)',
  },
  PC_SPEC_10_duplexplate: {
    id: 'PC_SPEC_10_duplexplate',
    defaultMessage: '10 nmol (2 OD)',
  },
  PC_SPEC_DESALT_duplexplate: {
    id: 'PC_SPEC_DESALT_duplexplate',
    defaultMessage: 'Desalt',
  },
  PC_SPEC_RP1_duplexplate: {
    id: 'PC_SPEC_RP1_duplexplate',
    defaultMessage: 'Cartridge',
  },
  PC_SPEC_HPLC_duplexplate: {
    id: 'PC_SPEC_HPLC_duplexplate',
    defaultMessage: 'HPLC',
  },
  PC_SPEC_AmC6_duplexplate: {
    id: 'PC_SPEC_AmC6_duplexplate',
    defaultMessage: 'Amino-Modifier C6',
  },
  PC_SPEC_Btn_duplexplate: {
    id: 'PC_SPEC_Btn_duplexplate',
    defaultMessage: 'Biotin',
  },
  PC_SPEC_Cyanine3_duplexplate: {
    id: 'PC_SPEC_Cyanine3_duplexplate',
    defaultMessage: 'Cyanine 3',
  },
  PC_SPEC_Cyanine5_duplexplate: {
    id: 'PC_SPEC_Cyanine5_duplexplate',
    defaultMessage: 'Cyanine 5',
  },
  PC_SPEC_Cyanine55_duplexplate: {
    id: 'PC_SPEC_Cyanine55_duplexplate',
    defaultMessage: 'Cyanine 5.5',
  },
  PC_SPEC_6FAM_duplexplate: {
    id: 'PC_SPEC_6FAM_duplexplate',
    defaultMessage: '6-FAM  (fluorescein)',
  },
  PC_SPEC_Phos_duplexplate: {
    id: 'PC_SPEC_Phos_duplexplate',
    defaultMessage: 'Phosphate',
  },
  PC_SPEC_Flc_duplexplate: {
    id: 'PC_SPEC_Flc_duplexplate',
    defaultMessage: 'Fluorescein',
  },
  PC_SPEC_None_duplexplate: {
    id: 'PC_SPEC_None_duplexplate',
    defaultMessage: 'None',
  },
  PC_SPEC_ThiC6_duplexplate: {
    id: 'PC_SPEC_ThiC6_duplexplate',
    defaultMessage: 'Thiol-Modifier-C6 S-S',
  },
  PC_SPEC_InvAb_duplexplate: {
    id: 'PC_SPEC_InvAb_duplexplate',
    defaultMessage: 'Inverted Abasic',
  },
  PC_SPEC_AmC7_duplexplate: {
    id: 'PC_SPEC_AmC7_duplexplate',
    defaultMessage: 'Amino-Modifier C7',
  },
  PC_SPEC_dT5F_duplexplate: {
    id: 'PC_SPEC_dT5F_duplexplate',
    defaultMessage: 'Flipped Base',
  },
  PC_SPEC_dTdT_duplexplate: {
    id: 'PC_SPEC_dTdT_duplexplate',
    defaultMessage: '[dT][dT]',
  },
  PC_SPEC_dTdG_duplexplate: {
    id: 'PC_SPEC_dTdG_duplexplate',
    defaultMessage: '[dT][dG]',
  },
  PC_SPEC_dTdC_duplexplate: {
    id: 'PC_SPEC_dTdC_duplexplate',
    defaultMessage: '[dT][dC]',
  },
  PC_SPEC_dTdA_duplexplate: {
    id: 'PC_SPEC_dTdA_duplexplate',
    defaultMessage: '[dT][dA]',
  },
  PC_SPEC_dGdT_duplexplate: {
    id: 'PC_SPEC_dGdT_duplexplate',
    defaultMessage: '[dG][dT]',
  },
  PC_SPEC_dGdG_duplexplate: {
    id: 'PC_SPEC_dGdG_duplexplate',
    defaultMessage: '[dG][dG]',
  },
  PC_SPEC_dGdC_duplexplate: {
    id: 'PC_SPEC_dGdC_duplexplate',
    defaultMessage: '[dG][dC]',
  },
  PC_SPEC_dGdA_duplexplate: {
    id: 'PC_SPEC_dGdA_duplexplate',
    defaultMessage: '[dG][dA]',
  },
  PC_SPEC_dCdT_duplexplate: {
    id: 'PC_SPEC_dCdT_duplexplate',
    defaultMessage: '[dC][dT]',
  },
  PC_SPEC_dCdG_duplexplate: {
    id: 'PC_SPEC_dCdG_duplexplate',
    defaultMessage: '[dC][dG]',
  },
  PC_SPEC_dAdA_duplexplate: {
    id: 'PC_SPEC_dAdA_duplexplate',
    defaultMessage: '[dA][dA]',
  },
  PC_SPEC_UU_duplexplate: {
    id: 'PC_SPEC_UU_duplexplate',
    defaultMessage: 'UU',
  },
  PC_SPEC_UG_duplexplate: {
    id: 'PC_SPEC_UG_duplexplate',
    defaultMessage: 'UG',
  },
  PC_SPEC_UC_duplexplate: {
    id: 'PC_SPEC_UC_duplexplate',
    defaultMessage: 'UC',
  },
  PC_SPEC_UA_duplexplate: {
    id: 'PC_SPEC_UA_duplexplate',
    defaultMessage: 'UA',
  },
  PC_SPEC_GU_duplexplate: {
    id: 'PC_SPEC_GU_duplexplate',
    defaultMessage: 'GU',
  },
  PC_SPEC_GG_duplexplate: {
    id: 'PC_SPEC_GG_duplexplate',
    defaultMessage: 'GG',
  },
  PC_SPEC_GC_duplexplate: {
    id: 'PC_SPEC_GC_duplexplate',
    defaultMessage: 'GC',
  },
  PC_SPEC_GA_duplexplate: {
    id: 'PC_SPEC_GA_duplexplate',
    defaultMessage: 'GA',
  },
  PC_SPEC_CU_duplexplate: {
    id: 'PC_SPEC_CU_duplexplate',
    defaultMessage: 'CU',
  },
  PC_SPEC_CG_duplexplate: {
    id: 'PC_SPEC_CG_duplexplate',
    defaultMessage: 'CG',
  },
  PC_SPEC_CC_duplexplate: {
    id: 'PC_SPEC_CC_duplexplate',
    defaultMessage: 'CC',
  },
  PC_SPEC_CA_duplexplate: {
    id: 'PC_SPEC_CA_duplexplate',
    defaultMessage: 'CA',
  },
  PC_SPEC_AU_duplexplate: {
    id: 'PC_SPEC_AU_duplexplate',
    defaultMessage: 'AU',
  },
  PC_SPEC_AG_duplexplate: {
    id: 'PC_SPEC_AG_duplexplate',
    defaultMessage: 'AG',
  },
  PC_SPEC_AC_duplexplate: {
    id: 'PC_SPEC_AC_duplexplate',
    defaultMessage: 'AC',
  },
  PC_SPEC_AA_duplexplate: {
    id: 'PC_SPEC_AA_duplexplate',
    defaultMessage: 'AA',
  },
  PC_SPEC_dCdC_duplexplate: {
    id: 'PC_SPEC_dCdC_duplexplate',
    defaultMessage: '[dC][dC]',
  },
  PC_SPEC_dCdA_duplexplate: {
    id: 'PC_SPEC_dCdA_duplexplate',
    defaultMessage: '[dC][dA]',
  },
  PC_SPEC_dAdT_duplexplate: {
    id: 'PC_SPEC_dAdT_duplexplate',
    defaultMessage: '[dA][dT]',
  },
  PC_SPEC_dAdG_duplexplate: {
    id: 'PC_SPEC_dAdG_duplexplate',
    defaultMessage: '[dA][dG]',
  },
  PC_SPEC_dAdC_duplexplate: {
    id: 'PC_SPEC_dAdC_duplexplate',
    defaultMessage: '[dA][dC]',
  },
  PC_SPEC_SPECIES_Chicken_milliplex: {
    id: 'PC_SPEC_SPECIES_Chicken_milliplex',
    defaultMessage: 'Chicken',
  },
  PC_SPEC_CONJUGATION_AMOUNT: {
    id: 'PC_SPEC_CONJUGATION_AMOUNT',
    defaultMessage: 'Conjugation Amount',
  },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN',
    defaultMessage: 'Additional Carrier Protein',
  },
  PC_SPEC_6_FAM_DESC: {
    id: 'PC_SPEC_6_FAM_DESC',
    defaultMessage: '[6FAM] = Fluorescein',
  },
  PC_SPEC_TAM_DESC: { id: 'PC_SPEC_TAM_DESC', defaultMessage: '[TAM] = TAMRA' },
  PC_SPEC_PEG: { id: 'PC_SPEC_PEG', defaultMessage: '[PEG] = Pegylation' },
  PC_SPEC_FITC: {
    id: 'PC_SPEC_FITC',
    defaultMessage: '[FITC] = Fluorescein-5isothiocyanate',
  },
  PC_SPEC_ACA: { id: 'PC_SPEC_ACA', defaultMessage: '[ACA]' },
  PC_SPEC_KBTN: { id: 'PC_SPEC_KBTN', defaultMessage: '[K_Btn]' },
  PC_SPEC_CYCL: {
    id: 'PC_SPEC_CYCL',
    defaultMessage: '[Cycl] = Disulfide Bond Formation',
  },
  PC_SPEC_PSER: { id: 'PC_SPEC_PSER', defaultMessage: '[pSer]=Phosphoserine' },
  PC_SPEC_PTHR: {
    id: 'PC_SPEC_PTHR',
    defaultMessage: '[pThr]=Phosphotheronine',
  },
  PC_SPEC_PTYR: {
    id: 'PC_SPEC_PTYR',
    defaultMessage: '[pTyr]=Phosphotyrosine',
  },
  PC_SPEC_2_mg: { id: 'PC_SPEC_2_mg', defaultMessage: '2 mg' },
  PC_SPEC_3_mg: { id: 'PC_SPEC_3_mg', defaultMessage: '3 mg' },
  PC_SPEC_5_mg: { id: 'PC_SPEC_5_mg', defaultMessage: '5 mg' },
  PC_SPEC_15_mg: { id: 'PC_SPEC_15_mg', defaultMessage: '15 mg' },
  PC_SPEC_IMMUNO: {
    id: 'PC_SPEC_IMMUNO',
    defaultMessage: 'Immunological Grade',
  },
  PC_SPEC_G50: { id: 'PC_SPEC_G50', defaultMessage: '>50%' },
  PC_SPEC_Unpurified: {
    id: 'PC_SPEC_Unpurified',
    defaultMessage: 'Unpurified',
  },
  PC_SPEC_G70: { id: 'PC_SPEC_G70', defaultMessage: '>70%' },
  PC_SPEC_G80: { id: 'PC_SPEC_G80', defaultMessage: '>80%' },
  PC_SPEC_G90: { id: 'PC_SPEC_G90', defaultMessage: '>90%' },
  PC_SPEC_G95: { id: 'PC_SPEC_G95', defaultMessage: '>95%' },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_KLH: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_KLH',
    defaultMessage: 'KLH',
  },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_BSA: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_BSA',
    defaultMessage: 'BSA',
  },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_OVA: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_OVA',
    defaultMessage: 'OVA',
  },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_RSA: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_RSA',
    defaultMessage: 'RSA',
  },
  PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_NONE: {
    id: 'PC_SPEC_ADDITIONAL_CARRIER_PROTEIN_NONE',
    defaultMessage: 'None',
  },
  PC_SPEC_1: { id: 'PC_SPEC_1', defaultMessage: '1' },
  PC_SPEC_2: { id: 'PC_SPEC_2', defaultMessage: '2' },
  PC_SPEC_3: { id: 'PC_SPEC_3', defaultMessage: '3' },
  PC_SPEC_4: { id: 'PC_SPEC_4', defaultMessage: '4' },
  PC_SPEC_5: { id: 'PC_SPEC_5', defaultMessage: '5' },
  PC_SPEC_6: { id: 'PC_SPEC_6', defaultMessage: '6' },
  PC_SPEC_7: { id: 'PC_SPEC_7', defaultMessage: '7' },
  PC_SPEC_8: { id: 'PC_SPEC_8', defaultMessage: '8' },
  PC_SPEC_9: { id: 'PC_SPEC_9', defaultMessage: '9' },
  PC_SPEC_10: { id: 'PC_SPEC_10', defaultMessage: '10' },
  PC_SPEC_SALT: {
    id: 'PC_SPEC_SALT',
    defaultMessage:
      'Salt Exchange - Sodium salt exchange performed at the end of the process',
  },
  PC_SPEC_ENDO: {
    id: 'PC_SPEC_ENDO',
    defaultMessage:
      'Endotoxin Testing - Performed on a sample of the product and can be requested for In Vivo treated oligos',
  },
  PC_SPEC_FILTER: {
    id: 'PC_SPEC_FILTER',
    defaultMessage:
      'Filtration - Final product filtered through a 0.2µm filter',
  },
  PC_SPEC_HPLC: { id: 'PC_SPEC_HPLC', defaultMessage: 'HPLC' },
  PC_SPEC_VIVO: { id: 'PC_SPEC_VIVO', defaultMessage: 'In Vivo Treatment' },
  PC_SPEC_CATRIDGE_longoligo: {
    id: 'PC_SPEC_CATRIDGE_longoligo',
    defaultMessage: 'Cartridge (Yield: 5 OD)',
  },
  PC_SPEC_PAGE_longoligo: {
    id: 'PC_SPEC_PAGE_longoligo',
    defaultMessage: 'PAGE (Yield: 0.5 OD)',
  },
  PC_SPEC_05_D: { id: 'PC_SPEC_05_D', defaultMessage: '0.5 OD' },
  PC_SPEC_5_OD: { id: 'PC_SPEC_5_OD', defaultMessage: '5 OD' },
  PC_SPEC_0_5_OD: { id: 'PC_SPEC_0_5_OD', defaultMessage: '0.5 OD' },
  PC_SPEC_MINIPEG: {
    id: 'PC_SPEC_MINIPEG',
    defaultMessage: '[mini-PEG] = mini-Pegylation',
  },
  PC_SPEC_SPECIES_Canine_milliplex: {
    id: 'PC_SPEC_SPECIES_Canine_milliplex',
    defaultMessage: 'Canine',
  },
  PC_SPEC_SPECIES_Bovine_milliplex: {
    id: 'PC_SPEC_SPECIES_Bovine_milliplex',
    defaultMessage: 'Bovine',
  },
  PC_SPEC_SPECIES_Equine_milliplex: {
    id: 'PC_SPEC_SPECIES_Equine_milliplex',
    defaultMessage: 'Equine',
  },
  PC_SPEC_SPECIES_Feline_milliplex: {
    id: 'PC_SPEC_SPECIES_Feline_milliplex',
    defaultMessage: 'Feline',
  },
  PC_SPEC_SPECIES_Human_milliplex: {
    id: 'PC_SPEC_SPECIES_Human_milliplex',
    defaultMessage: 'Human',
  },
  PC_SPEC_SPECIES_Mouse_milliplex: {
    id: 'PC_SPEC_SPECIES_Mouse_milliplex',
    defaultMessage: 'Mouse',
  },
  PC_SPEC_SPECIES_Porcine_milliplex: {
    id: 'PC_SPEC_SPECIES_Porcine_milliplex',
    defaultMessage: 'Porcine',
  },
  PC_SPEC_SPECIES_Non_Human_Primate_milliplex: {
    id: 'PC_SPEC_SPECIES_Non_Human_Primate_milliplex',
    defaultMessage: 'Non-Human Primate',
  },
  PC_SPEC_SPECIES_Rat_milliplex: {
    id: 'PC_SPEC_SPECIES_Rat_milliplex',
    defaultMessage: 'Rat',
  },
  PC_SPEC_RESEARCH_AREAS_Bone_Metabolism_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Bone_Metabolism_milliplex',
    defaultMessage: 'Bone Metabolism',
  },
  PC_SPEC_RESEARCH_AREAS_Cancer_Angiogenesis_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Cancer_Angiogenesis_milliplex',
    defaultMessage: 'Cancer/Angiogenesis',
  },
  PC_SPEC_RESEARCH_AREAS_Cancer_Immuno_oncology_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Cancer_Immuno_oncology_milliplex',
    defaultMessage: 'Cancer/Immuno-oncology',
  },
  PC_SPEC_RESEARCH_AREAS_Cardiovascular_Disease_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Cardiovascular_Disease_milliplex',
    defaultMessage: 'Cardiovascular Disease',
  },
  PC_SPEC_RESEARCH_AREAS_Immunology_Inflammation_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Immunology_Inflammation_milliplex',
    defaultMessage: 'Immunology/Inflammation',
  },
  PC_SPEC_RESEARCH_AREAS_Cell_Signaling_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Cell_Signaling_milliplex',
    defaultMessage: 'Cell Signaling',
  },
  PC_SPEC_RESEARCH_AREAS_Metabolism_Endocrinology_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Metabolism_Endocrinology_milliplex',
    defaultMessage: 'Metabolism/Endocrinology',
  },
  PC_SPEC_RESEARCH_AREAS_Neuroscience_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Neuroscience_milliplex',
    defaultMessage: 'Neuroscience',
  },
  PC_SPEC_RESEARCH_AREAS_Toxicity_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Toxicity_milliplex',
    defaultMessage: 'Toxicity',
  },
  PC_SPEC_VECTOR_LV01: {
    id: 'PC_SPEC_VECTOR_LV01',
    defaultMessage:
      '(LV01) U6-gRNA:ef1a-puro-2A-Cas9-2A-tGFP (Sigma all-in-one lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV02: {
    id: 'PC_SPEC_VECTOR_LV02',
    defaultMessage:
      '(LV02) U6-gRNA:ef1a-puro (GeCKOv2:puro lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV03: {
    id: 'PC_SPEC_VECTOR_LV03',
    defaultMessage:
      '(LV03) U6-gRNA:ef1a-tGFP (GeCKOv2:tGFP lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV04: {
    id: 'PC_SPEC_VECTOR_LV04',
    defaultMessage:
      '(LV04) U6-gRNA:hPGK-puro-2A-tBFP (Sanger lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV05: {
    id: 'PC_SPEC_VECTOR_LV05',
    defaultMessage:
      '(LV05) U6-gRNA:EF1a-Cas9+FLAG-2A-puro (GeCKOv2 all-in-one lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV06: {
    id: 'PC_SPEC_VECTOR_LV06',
    defaultMessage:
      '(LV06) U6-gRNA-MS2:ef1a-puro (SAM Activator:puro lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV07: {
    id: 'PC_SPEC_VECTOR_LV07',
    defaultMessage:
      '(LV07) U6-gRNA-MS2:ef1a-zeo (SAM Activator:zeo lentiviral plasmid)',
  },
  PC_SPEC_VECTOR_LV08: {
    id: 'PC_SPEC_VECTOR_LV08',
    defaultMessage: '(LV08) U6-gRNA:EF1a-Puro (Optimized for gRNA expression)',
  },
  PC_SPEC_VECTOR_LV13: {
    id: 'PC_SPEC_VECTOR_LV013',
    defaultMessage:
      '(LV13) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, stem-loop position)',
  },
  PC_SPEC_VECTOR_LV14: {
    id: 'PC_SPEC_VECTOR_LV014',
    defaultMessage: "(LV14) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, 3' position)",
  },
  PC_SPEC_VECTOR_LV15: {
    id: 'PC_SPEC_VECTOR_LV015',
    defaultMessage:
      '(LV15) U6-gRNA:EF1a-Puro-2a-BFP (10x CS2, stem-loop position)',
  },
  PC_SPEC_VECTOR_LV16: {
    id: 'PC_SPEC_VECTOR_LV016',
    defaultMessage: "(LV16) U6-gRNA:EF1a-Puro-2a-BFP (10x CS2, 3' position)",
  },
  PC_SPEC_VECTOR_LV17: {
    id: 'PC_SPEC_VECTOR_LV017',
    defaultMessage:
      '(LV17) U6-gRNA:EF1a-Puro-2a-BFP (Optimized gRNA scaffold with BFP)',
  },
  PC_SPEC_VECTOR_p01: {
    id: 'PC_SPEC_VECTOR_p01',
    defaultMessage: '(p01) U6-gRNA:CMV-Cas9-2a-tGFP (transfection plasmid)',
  },
  PC_SPEC_VECTOR_p02: {
    id: 'PC_SPEC_VECTOR_p02',
    defaultMessage: '(p02) U6-gRNA:CMV-Cas9-2A-tRFP (transfection plasmid)',
  },
  PC_SPEC_VECTOR_p03: {
    id: 'PC_SPEC_VECTOR_p03',
    defaultMessage: '(p03) U6-gRNA (transfection plasmid)',
  },
  PC_SPEC_VECTOR_p04: {
    id: 'PC_SPEC_VECTOR_p04',
    defaultMessage: '(p04) U6-gRNA:CMV-eCas9-2a-tGFP (transfection plasmid)',
  },
  PC_SPEC_VECTOR_p05: {
    id: 'PC_SPEC_VECTOR_p05',
    defaultMessage: '(p05) U6-gRNA:CMV-eCas9-2a-tRFP (transfection plasmid)',
  },
  PC_SPEC_VECTOR_p10: {
    id: 'PC_SPEC_VECTOR_p10',
    defaultMessage: 'p10 CRISPRBACD J23119-gRNA-amp (bacterial plasmid)',
  },
  PC_SPEC_VECTOR_p11: { id: 'PC_SPEC_VECTOR_p11', defaultMessage: '(p11) BBB' },
  PC_SPEC_VECTOR_p50: {
    id: 'PC_SPEC_VECTOR_p50',
    defaultMessage:
      'p50 (monocot) U6-gRNA:CMV-Cas9-hyg (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p51: {
    id: 'PC_SPEC_VECTOR_p51',
    defaultMessage:
      'p51 (monocot)U6-gRNA:CMV-Cas9-neo (Agrobacterium plasmid) ',
  },
  PC_SPEC_VECTOR_p52: {
    id: 'PC_SPEC_VECTOR_p52',
    defaultMessage: 'p52 (monocot)U6-gRNA:CMV-Cas9-bar (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p53: {
    id: 'PC_SPEC_VECTOR_p53',
    defaultMessage: 'p53 (dicot)U6-gRNA:CMV-Cas9-hyg (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p54: {
    id: 'PC_SPEC_VECTOR_p54',
    defaultMessage: 'p54 (dicot)U6-gRNA:CMV-Cas9-neo (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p55: {
    id: 'PC_SPEC_VECTOR_p55',
    defaultMessage: 'p55 (dicot)U6-gRNA:CMV-Cas9-bar (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p56: {
    id: 'PC_SPEC_VECTOR_p56',
    defaultMessage: 'p56 (monocot)U6-gRNA:CMV-Cas9-hyg (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p57: {
    id: 'PC_SPEC_VECTOR_p57',
    defaultMessage: 'p57 (monocot)U6-gRNA:CMV-Cas9-neo (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p58: {
    id: 'PC_SPEC_VECTOR_p58',
    defaultMessage: 'p58 (monocot)U6-gRNA:CMV-Cas9-bar (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p59: {
    id: 'PC_SPEC_VECTOR_p59',
    defaultMessage: 'p59	(dicot)U6-gRNA:CMV-Cas9-hyg (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p60: {
    id: 'PC_SPEC_VECTOR_p60',
    defaultMessage: 'p60 (dicot)U6-gRNA:CMV-Cas9-neo (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p61: {
    id: 'PC_SPEC_VECTOR_p61',
    defaultMessage: 'p61	(dicot)U6-gRNA:CMV-Cas9-bar (bioballistic plasmid)',
  },
  PC_SPEC_VECTOR_p62: {
    id: 'PC_SPEC_VECTOR_p62',
    defaultMessage:
      'p62	(monocot)U6-gRNA:CMV-Cas9-beta glucaronidase (Agrobacterium plasmid)',
  },
  PC_SPEC_VECTOR_p63: {
    id: 'PC_SPEC_VECTOR_p63',
    defaultMessage:
      'p63	(dicot)U6-gRNA:CMV-Cas9-beta glucuronidase (Agrobacterium plasmid)',
  },
  PC_SPEC_AMOUNT_1_UG: { id: 'PC_SPEC_AMOUNT_1_UG', defaultMessage: '1 µg' },
  PC_SPEC_AMOUNT_10_UG: { id: 'PC_SPEC_AMOUNT_10_UG', defaultMessage: '10 µg' },
  PC_SPEC_AMOUNT_25_UG: { id: 'PC_SPEC_AMOUNT_25_UG', defaultMessage: '25 µg' },
  PC_SPEC_AMOUNT_100_UG: {
    id: 'PC_SPEC_AMOUNT_100_UG',
    defaultMessage: '100 µg',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV01: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV01',
    defaultMessage:
      '(LV01) U6-gRNA:ef1a-puro-2A-Cas9-2A-tGFP (Sigma all-in-one lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV02: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV02',
    defaultMessage: '(LV02) U6-gRNA:ef1a-puro (GeCKOv2:puro lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV03: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV03',
    defaultMessage: '(LV03) U6-gRNA:ef1a-tGFP (GeCKOv2:tGFP lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV04: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV04',
    defaultMessage: '(LV04) U6-gRNA:hPGK-puro-2A-tBFP (Sanger lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV05: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV05',
    defaultMessage:
      '(LV05) U6-gRNA:EF1a-Cas9+FLAG-2A-puro (GeCKOv2 all-in-one lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV06: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV06',
    defaultMessage:
      '(LV06) U6-gRNA-MS2:ef1a-puro (SAM Activator:puro lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV07: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV07',
    defaultMessage:
      '(LV07) U6-gRNA-MS2:ef1a-zeo (SAM Activator:zeo lentivirus)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV08: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV08',
    defaultMessage: '(LV08) U6-gRNA:EF1a-Puro (Optimized for gRNA expression)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV13: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV13',
    defaultMessage:
      '(LV13) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, stem-loop position)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV14: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV14',
    defaultMessage: "(LV14) U6-gRNA:EF1a-Puro-2a-BFP (10x CS1, 3' position)",
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV15: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV15',
    defaultMessage:
      '(LV15) U6-gRNA:EF1a-Puro-2a-BFP (10x CS2, stem-loop position)',
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV16: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV16',
    defaultMessage: "(LV16) U6-gRNA:EF1a-Puro-2a-BFP (10x CS2, 3' position)",
  },
  PC_SPEC_LENTIVIRAL_BACKBONE_LV17: {
    id: 'PC_SPEC_LENTIVIRAL_BACKBONE_LV17',
    defaultMessage:
      '(LV17) U6-gRNA:EF1a-Puro-2a-BFP (Optimized gRNA scaffold with BFP)',
  },
  PC_SPEC_ALIQUOTING_1_INTO_200_UL: {
    id: 'PC_SPEC_ALIQUOTING_1_INTO_200_UL',
    defaultMessage: '1 x 200 µl',
  },
  PC_SPEC_ALIQUOTING_10_INTO_100_UL: {
    id: 'PC_SPEC_ALIQUOTING_10_INTO_100_UL',
    defaultMessage: '10 x 100 µl',
  },
  PC_SPEC_ALIQUOTING_10_INTO_20_UL: {
    id: 'PC_SPEC_ALIQUOTING_10_INTO_20_UL',
    defaultMessage: '10 x 20 µl',
  },
  PC_SPEC_ALIQUOTING_10_INTO_200_UL: {
    id: 'PC_SPEC_ALIQUOTING_10_INTO_200_UL',
    defaultMessage: '10 x 200 µl',
  },
  PC_SPEC_ALIQUOTING_100_INTO_20_UL: {
    id: 'PC_SPEC_ALIQUOTING_100_INTO_20_UL',
    defaultMessage: '100 x 20 µl',
  },
  PC_SPEC_ALIQUOTING_100_INTO_50_UL: {
    id: 'PC_SPEC_ALIQUOTING_100_INTO_50_UL',
    defaultMessage: '100 x 50 µl',
  },
  PC_SPEC_ALIQUOTING_2_INTO_100_UL: {
    id: 'PC_SPEC_ALIQUOTING_2_INTO_100_UL',
    defaultMessage: '2 x 100 µl',
  },
  PC_SPEC_ALIQUOTING_2_INTO_50_UL: {
    id: 'PC_SPEC_ALIQUOTING_2_INTO_50_UL',
    defaultMessage: '2 x 50 µl',
  },
  PC_SPEC_ALIQUOTING_20_INTO_100_UL: {
    id: 'PC_SPEC_ALIQUOTING_20_INTO_100_UL',
    defaultMessage: '20 x 100 µl',
  },
  PC_SPEC_ALIQUOTING_20_INTO_50_UL: {
    id: 'PC_SPEC_ALIQUOTING_20_INTO_50_UL',
    defaultMessage: '20 x 50 µl',
  },
  PC_SPEC_ALIQUOTING_200_INTO_25_UL: {
    id: 'PC_SPEC_ALIQUOTING_200_INTO_25_UL',
    defaultMessage: '200 x 25 µl',
  },
  PC_SPEC_ALIQUOTING_25_INTO_200_UL: {
    id: 'PC_SPEC_ALIQUOTING_25_INTO_200_UL',
    defaultMessage: '25 x 200 µl',
  },
  PC_SPEC_ALIQUOTING_4_INTO_25_UL: {
    id: 'PC_SPEC_ALIQUOTING_4_INTO_25_UL',
    defaultMessage: '4 x 25 µl',
  },
  PC_SPEC_ALIQUOTING_4_INTO_50_UL: {
    id: 'PC_SPEC_ALIQUOTING_4_INTO_50_UL',
    defaultMessage: '4 x 50 µl',
  },
  PC_SPEC_ALIQUOTING_40_INTO_25_UL: {
    id: 'PC_SPEC_ALIQUOTING_40_INTO_25_UL',
    defaultMessage: '40 x 25 µl',
  },
  PC_SPEC_ALIQUOTING_40_INTO_50_UL: {
    id: 'PC_SPEC_ALIQUOTING_40_INTO_50_UL',
    defaultMessage: '40 x 50 µl',
  },
  PC_SPEC_ALIQUOTING_5_INTO_20_UL: {
    id: 'PC_SPEC_ALIQUOTING_5_INTO_20_UL',
    defaultMessage: '5 x 20 µl',
  },
  PC_SPEC_ALIQUOTING_5_INTO_200_UL: {
    id: 'PC_SPEC_ALIQUOTING_5_INTO_200_UL',
    defaultMessage: '5 x 200 µl',
  },
  PC_SPEC_ALIQUOTING_50_INTO_100_UL: {
    id: 'PC_SPEC_ALIQUOTING_50_INTO_100_UL',
    defaultMessage: '50 x 100 µl',
  },
  PC_SPEC_ALIQUOTING_50_INTO_20_UL: {
    id: 'PC_SPEC_ALIQUOTING_50_INTO_20_UL',
    defaultMessage: '50 x 20 µl',
  },
  PC_SPEC_ALIQUOTING_8_INTO_25_UL: {
    id: 'PC_SPEC_ALIQUOTING_8_INTO_25_UL',
    defaultMessage: '8 x 25 µl',
  },
  PC_SPEC_ALIQUOTING_80_INTO_25_UL: {
    id: 'PC_SPEC_ALIQUOTING_80_INTO_25_UL',
    defaultMessage: '80 x 25 µl',
  },
  PC_SPEC_VOLUME_0_1_ml: {
    id: 'PC_SPEC_VOLUME_0_1_ml',
    defaultMessage: '100 µl',
  },
  PC_SPEC_VOLUME_0_2_ml: {
    id: 'PC_SPEC_VOLUME_0_2_ml',
    defaultMessage: '200 µl',
  },
  PC_SPEC_VOLUME_1_0_ml: {
    id: 'PC_SPEC_VOLUME_1_0_ml',
    defaultMessage: '1 ml',
  },
  PC_SPEC_VOLUME_2_0_ml: {
    id: 'PC_SPEC_VOLUME_2_0_ml',
    defaultMessage: '2 ml',
  },
  PC_SPEC_VOLUME_5_0_ml: {
    id: 'PC_SPEC_VOLUME_5_0_ml',
    defaultMessage: '5 ml',
  },
  PC_SPEC_VIRAL_TITER_10_6: {
    id: 'PC_SPEC_VIRAL_TITER_10_6',
    defaultMessage: '10^6 particles/ml',
  },
  PC_SPEC_VIRAL_TITER_10_7: {
    id: 'PC_SPEC_VIRAL_TITER_10_7',
    defaultMessage: '10^7 particles/ml',
  },
  PC_SPEC_VIRAL_TITER_10_8: {
    id: 'PC_SPEC_VIRAL_TITER_10_8',
    defaultMessage: '10^8 particles/ml',
  },
  PC_SPEC_VIRAL_TITER_10_9: {
    id: 'PC_SPEC_VIRAL_TITER_10_9',
    defaultMessage: '10^9 particles/ml',
  },
  PC_SPEC_SPCAS9: { id: 'PC_SPEC_SPCAS9', defaultMessage: 'SpCas9' },
  //TODO: remove one of them after BE deletes one of them
  PC_SPEC_CYTOSINE_BASE_EDITORS: {
    id: 'PC_SPEC_CYTOSINE_BASE_EDITORS',
    defaultMessage: 'PURedit® Cas9 Cytosine Base Editors',
  },
  PC_SPEC_CYTOSINE: {
    id: 'PC_SPEC_CYTOSINE',
    defaultMessage: 'PURedit® Cas9 Cytosine Base Editors',
  },
  PC_SPEC_FNCAS9: {
    id: 'PC_SPEC_FNCAS9',
    defaultMessage: 'FnCas9 (For non-cellular, synthetic applications)',
  },
  PC_SPEC_CRRNA: {
    id: 'PC_SPEC_CRRNA',
    defaultMessage: 'crRNA (tracrRNA sold separately)',
  },
  PC_SPEC_SYGRNA: {
    id: 'PC_SPEC_SYGRNA',
    defaultMessage: 'sgRNA (crRNA + tracrRNA as one)',
  },
  PC_SPEC_3_0NM: { id: 'PC_SPEC_3_0NM', defaultMessage: '3 nmol' },
  PC_SPEC_AMOUNT_5MG: { id: 'PC_SPEC_AMOUNT_5MG', defaultMessage: '5 mg' },
  PC_SPEC_AMOUNT_10MG: { id: 'PC_SPEC_AMOUNT_10MG', defaultMessage: '10 mg' },
  PC_SPEC_CARRIER_PROTIENKLH_antisera: {
    id: 'PC_SPEC_CARRIER_PROTIENKLH_antisera',
    defaultMessage: 'KLH',
  },
  PC_SPEC_CARRIER_PROTIENBSA_antisera: {
    id: 'PC_SPEC_CARRIER_PROTIENBSA_antisera',
    defaultMessage: 'BSA',
  },
  PC_SPEC_PURITY_GT70_antisera: {
    id: 'PC_SPEC_PURITY_GT70_antisera',
    defaultMessage: '>70',
  },
  PC_SPEC_PURITY_GT80_antisera: {
    id: 'PC_SPEC_PURITY_GT80_antisera',
    defaultMessage: '>80',
  },
  PC_SPEC_PURITY_GT90_antisera: {
    id: 'PC_SPEC_PURITY_GT90_antisera',
    defaultMessage: '>90',
  },
  PC_SPEC_PURITY_GT95_antisera: {
    id: 'PC_SPEC_PURITY_GT95_antisera',
    defaultMessage: '>95',
  },
  PC_SPEC_PURITY_IMMUNOLOGICAL_antisera: {
    id: 'PC_SPEC_PURITY_IMMUNOLOGICAL_antisera',
    defaultMessage: 'Immunological',
  },
  PC_SPEC_CTERM_OH_Carboxyl_antisera: {
    id: 'PC_SPEC_CTERM_OH_Carboxyl_antisera',
    defaultMessage: '[OH]=Carboxyl',
  },
  PC_SPEC_CTERM_NH2_Amidation_antisera: {
    id: 'PC_SPEC_CTERM_NH2_Amidation_antisera',
    defaultMessage: '[NH2]=Amidation',
  },
  PC_SPEC_INTERNALMOD_pTyr_phosphotyrosine_antisera: {
    id: 'PC_SPEC_INTERNALMOD_pTyr_phosphotyrosine_antisera',
    defaultMessage: '[pTyr]phosphotyrosine',
  },
  PC_SPEC_INTERNALMOD_pThr_Phosphothreonine_antisera: {
    id: 'PC_SPEC_INTERNALMOD_pThr_Phosphothreonine_antisera',
    defaultMessage: '[pThr]Phosphothreonine',
  },
  PC_SPEC_INTERNALMOD_Ahx_Aminohexanoicacid_antisera: {
    id: 'PC_SPEC_INTERNALMOD_Ahx_Aminohexanoicacid_antisera',
    defaultMessage: '[Ahx]Aminohexanoic acid',
  },
  PC_SPEC_INTERNALMOD_pSer_Phosphoserine_antisera: {
    id: 'PC_SPEC_INTERNALMOD_pSer_Phosphoserine_antisera',
    defaultMessage: '[pSer]Phosphoserine',
  },
  PC_SPEC_INTERNALMOD_Kme1_mono_Methyl_Lysine_antisera: {
    id: 'PC_SPEC_INTERNALMOD_Kme1_mono_Methyl_Lysine_antisera',
    defaultMessage: '[Kme]mono-Methyl-Lysine',
  },
  PC_SPEC_INTERNALMOD_Kme2_di_Methyl_Lysine_antisera: {
    id: 'PC_SPEC_INTERNALMOD_Kme2_di_Methyl_Lysine_antisera',
    defaultMessage: '[Kme2]di-Methyl-Lysine',
  },
  PC_SPEC_NTERM_H_Amine_antisera: {
    id: 'PC_SPEC_NTERM_H_Amine_antisera',
    defaultMessage: '[H]=Amine',
  },
  PC_SPEC_NTERM_Ace_Acetylation_antisera: {
    id: 'PC_SPEC_NTERM_Ace_Acetylation_antisera',
    defaultMessage: '[Ace]=Acetylation',
  },
  PC_SPEC_PSA: {
    id: 'PC_SPEC_PSA',
    defaultMessage: 'Peptide synthesis and antisera',
  },
  PC_SPEC_CSAA: {
    id: 'PC_SPEC_CSAA',
    defaultMessage: 'Customer supplied antigen and antisera',
  },
  PC_SPEC_SELECT_PEPTIDE1_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE1_antisera',
    defaultMessage: 'Peptide1',
  },
  PC_SPEC_SELECT_PEPTIDE2_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE2_antisera',
    defaultMessage: 'Peptide2',
  },
  PC_SPEC_SELECT_PEPTIDE3_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE3_antisera',
    defaultMessage: 'Peptide3',
  },
  PC_SPEC_SELECT_PEPTIDE123_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE123_antisera',
    defaultMessage: 'Peptide1+2+3',
  },
  PC_SPEC_SELECT_PEPTIDE12_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE12_antisera',
    defaultMessage: 'Peptide1+2',
  },
  PC_SPEC_SELECT_PEPTIDE_CUST_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE_CUST_antisera',
    defaultMessage: 'Customer Supplied Antigen',
  },
  PC_SPEC_SELECT_PEPTIDE23_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE23_antisera',
    defaultMessage: 'Peptide2+3',
  },
  PC_SPEC_SELECT_PEPTIDE13_antisera: {
    id: 'PC_SPEC_SELECT_PEPTIDE13_antisera',
    defaultMessage: 'Peptide1+3',
  },
  PC_SPEC_Rabbit_antisera: {
    id: 'PC_SPEC_Rabbit_antisera',
    defaultMessage: 'Rabbit',
  },
  PC_SPEC_Mouse_antisera: {
    id: 'PC_SPEC_Mouse_antisera',
    defaultMessage: 'Mouse',
  },
  PC_SPEC_Rat_antisera: { id: 'PC_SPEC_Rat_antisera', defaultMessage: 'Rat' },
  PC_SPEC_Chicken_antisera: {
    id: 'PC_SPEC_Chicken_antisera',
    defaultMessage: 'Chicken',
  },
  PC_SPEC_NOANIMALS1_antisera: {
    id: 'PC_SPEC_NOANIMALS1_antisera',
    defaultMessage: '1',
  },
  PC_SPEC_NOANIMALS2_antisera: {
    id: 'PC_SPEC_NOANIMALS2_antisera',
    defaultMessage: '2',
  },
  PC_SPEC_NOANIMALS3_antisera: {
    id: 'PC_SPEC_NOANIMALS3_antisera',
    defaultMessage: '3',
  },
  PC_SPEC_NOANIMALS5_antisera: {
    id: 'PC_SPEC_NOANIMALS5_antisera',
    defaultMessage: '5',
  },
  PC_SPEC_IMMUN_TERM49_antisera: {
    id: 'PC_SPEC_IMMUN_TERM49_antisera',
    defaultMessage: '49 Days',
  },
  PC_SPEC_IMMUN_TERM63_antisera: {
    id: 'PC_SPEC_IMMUN_TERM63_antisera',
    defaultMessage: '63 Days',
  },
  PC_SPEC_IMMUN_TERM56_antisera: {
    id: 'PC_SPEC_IMMUN_TERM56_antisera',
    defaultMessage: '56 Days',
  },
  PC_SPEC_IMMUN_TERM77_antisera: {
    id: 'PC_SPEC_IMMUN_TERM77_antisera',
    defaultMessage: '77 Days',
  },
  PC_SPEC_PURIFIC_TYPE_AFF10_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_AFF10_antisera',
    defaultMessage: 'Affinity (Pep - 10ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_AFF20_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_AFF20_antisera',
    defaultMessage: 'Affinity (Pep - 20ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_AFF30_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_AFF30_antisera',
    defaultMessage: 'Affinity (Pep - 30ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_AFF40_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_AFF40_antisera',
    defaultMessage: 'Affinity (Pep - 40ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_AFF50_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_AFF50_antisera',
    defaultMessage: 'Affinity (Pep - 50ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_PRO10_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_PRO10_antisera',
    defaultMessage: 'Protein A (10ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_PRO20_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_PRO20_antisera',
    defaultMessage: 'Protein A (20ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_PRO30_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_PRO30_antisera',
    defaultMessage: 'Protein A (30ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_PRO40_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_PRO40_antisera',
    defaultMessage: 'Protein A (40ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_PRO50_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_PRO50_antisera',
    defaultMessage: 'Protein A (50ml Antisera)',
  },
  PC_SPEC_NONE_antisera: {
    id: 'PC_SPEC_NONE_antisera',
    defaultMessage: 'None',
  },
  PC_SPEC_COLUMN_NO1_antisera: {
    id: 'PC_SPEC_COLUMN_NO1_antisera',
    defaultMessage: 'Column 1',
  },
  PC_SPEC_COLUMN_NO2_antisera: {
    id: 'PC_SPEC_COLUMN_NO2_antisera',
    defaultMessage: 'Column 2',
  },
  PC_SPEC_COLUMN_NO3_antisera: {
    id: 'PC_SPEC_COLUMN_NO3_antisera',
    defaultMessage: 'Column 3',
  },
  PC_SPEC_CTERM_OH_Carboxyl_simpleantisera: {
    id: 'PC_SPEC_CTERM_OH_Carboxyl_simpleantisera',
    defaultMessage: '[OH]=Carboxyl',
  },
  PC_SPEC_CTERM_NH2_Amidation_simpleantisera: {
    id: 'PC_SPEC_CTERM_NH2_Amidation_simpleantisera',
    defaultMessage: '[NH2]=Amidation',
  },
  PC_SPEC_NTERM_H_Amine_simpleantisera: {
    id: 'PC_SPEC_NTERM_H_Amine_simpleantisera',
    defaultMessage: '[H]=Amine',
  },
  PC_SPEC_NTERM_Ace_Acetylation_simpleantisera: {
    id: 'PC_SPEC_NTERM_Ace_Acetylation_simpleantisera',
    defaultMessage: '[Ace]=Acetylation',
  },
  PC_SPEC_CARRIER_PROTIENKLH_simpleantisera: {
    id: 'PC_SPEC_CARRIER_PROTIENKLH_simpleantisera',
    defaultMessage: 'KLH',
  },
  PC_SPEC_PURIFIC_TYPE_1_simpleantisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_1_simpleantisera',
    defaultMessage: 'Affinity (Pep - 10ml Antisera)',
  },
  PC_SPEC_COLUMN_NO1_simpleantisera: {
    id: 'PC_SPEC_COLUMN_NO1_simpleantisera',
    defaultMessage: 'Column 1',
  },
  PC_SPEC_PROJECT_TYPE_PEPTIDE_SYNTH_antisera: {
    id: 'PC_SPEC_PROJECT_TYPE_PEPTIDE_SYNTH_antisera',
    defaultMessage: 'Peptide synthesis and antisera',
  },
  PC_SPEC_PROJECT_TYPE_CUSTOMER_SUPPLIED_antisera: {
    id: 'PC_SPEC_PROJECT_TYPE_CUSTOMER_SUPPLIED_antisera',
    defaultMessage: 'Customer supplied antigen and antisera',
  },
  PC_SPEC_PURITY_IMMUNOLOGICAL_simpleantisera: {
    id: 'PC_SPEC_PURITY_IMMUNOLOGICAL_simpleantisera',
    defaultMessage: 'Immunological',
  },
  PC_SPEC_Rabbit_simpleantisera: {
    id: 'PC_SPEC_Rabbit_simpleantisera',
    defaultMessage: 'Rabbit',
  },
  PC_SPEC_NOANIMALS1_simpleantisera: {
    id: 'PC_SPEC_NOANIMALS1_simpleantisera',
    defaultMessage: ' 1',
  },
  PC_SPEC_IMMUN_TERM56_simpleantisera: {
    id: 'PC_SPEC_IMMUN_TERM56_simpleantisera',
    defaultMessage: '56 days',
  },
  PC_SPEC_SELECT_COL1_antisera: {
    id: 'PC_SPEC_SELECT_COL1_antisera',
    defaultMessage: 'Column 1',
  },
  PC_SPEC_SELECT_KLH_antisera: {
    id: 'PC_SPEC_SELECT_KLH_antisera',
    defaultMessage: 'KLH',
  },
  PC_SPEC_SELECT_COL2_antisera: {
    id: 'PC_SPEC_SELECT_COL2_antisera',
    defaultMessage: 'Column 2',
  },
  PC_SPEC_SELECT_COL3_antisera: {
    id: 'PC_SPEC_SELECT_COL3_antisera',
    defaultMessage: 'Column 3',
  },
  PC_SPEC_SELECT_antisera: {
    id: 'PC_SPEC_SELECT_antisera',
    defaultMessage: 'Select',
  },
  PC_SPEC_PURIFIC_TYPE_1_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_1_antisera',
    defaultMessage: 'Affinity(Peptide -10ml Antisera)',
  },
  PC_SPEC_PURIFIC_TYPE_2_antisera: {
    id: 'PC_SPEC_PURIFIC_TYPE_2_antisera',
    defaultMessage: 'Protien A (5ml Antisera)',
  },
  PC_SPEC_SARS_CoV_2NucleoProN: {
    id: 'PC_SPEC_SARS_CoV_2NucleoProN',
    defaultMessage: 'SARS-CoV-2 Nucleocapsid Protein (N)',
  },
  PC_SPEC_SARS_CoV_2RBD: {
    id: 'PC_SPEC_SARS_CoV_2RBD',
    defaultMessage: 'SARS-CoV-2 Receptor Binding Domain(RBD)',
  },
  PC_SPEC_SARS_CoV_2S1: {
    id: 'PC_SPEC_SARS_CoV_2S1',
    defaultMessage: 'SARS-CoV-2 Spike S1',
  },
  PC_SPEC_SARS_CoV_2S2: {
    id: 'PC_SPEC_SARS_CoV_2S2',
    defaultMessage: 'SARS-CoV-2 Spike S2',
  },
  PC_SPEC_4_1BBL_TNFSF9: {
    id: 'PC_SPEC_4_1BBL_TNFSF9',
    defaultMessage: '4-1BBL/TNFSF9',
  },
  PC_SPEC_APRIL: { id: 'PC_SPEC_APRIL', defaultMessage: 'APRIL' },
  PC_SPEC_B7_H2_ICOSL: {
    id: 'PC_SPEC_B7_H2_ICOSL',
    defaultMessage: 'B7-H2/ICOSL',
  },
  PC_SPEC_B7_H3_CD276: {
    id: 'PC_SPEC_B7_H3_CD276',
    defaultMessage: 'B7-H3/CD276',
  },
  PC_SPEC_B7_H4_VTCN1: {
    id: 'PC_SPEC_B7_H4_VTCN1',
    defaultMessage: 'B7-H4/VTCN1',
  },
  PC_SPEC_B7_H5_VISTA: {
    id: 'PC_SPEC_B7_H5_VISTA',
    defaultMessage: 'B7-H5/VISTA',
  },
  PC_SPEC_B7_H6: { id: 'PC_SPEC_B7_H6', defaultMessage: 'B7-H6' },
  PC_SPEC_CD226_DNAM_1: {
    id: 'PC_SPEC_CD226_DNAM_1',
    defaultMessage: 'CD226/DNAM-1',
  },
  PC_SPEC_E_Cadherin: {
    id: 'PC_SPEC_E_Cadherin',
    defaultMessage: 'E-Cadherin',
  },
  PC_SPEC_FGL1_Hepassocin: {
    id: 'PC_SPEC_FGL1_Hepassocin',
    defaultMessage: 'FGL1/Hepassocin',
  },
  PC_SPEC_Granulysin: {
    id: 'PC_SPEC_Granulysin',
    defaultMessage: 'Granulysin',
  },
  PC_SPEC_IDO1: { id: 'PC_SPEC_IDO1', defaultMessage: 'IDO1' },
  PC_SPEC_MICA: { id: 'PC_SPEC_MICA', defaultMessage: 'MICA' },
  PC_SPEC_MICB: { id: 'PC_SPEC_MICB', defaultMessage: 'MICB' },
  PC_SPEC_Nectin_2: { id: 'PC_SPEC_Nectin_2', defaultMessage: 'Nectin-2' },
  PC_SPEC_Nectin_4: { id: 'PC_SPEC_Nectin_4', defaultMessage: 'Nectin-4' },
  PC_SPEC_OX40_CD134: {
    id: 'PC_SPEC_OX40_CD134',
    defaultMessage: 'OX40/CD134',
  },
  PC_SPEC_PVR_CD155: { id: 'PC_SPEC_PVR_CD155', defaultMessage: 'PVR/CD155' },
  PC_SPEC_Siglec_7: { id: 'PC_SPEC_Siglec_7', defaultMessage: 'Siglec-7' },
  PC_SPEC_Siglec_9: { id: 'PC_SPEC_Siglec_9', defaultMessage: 'Siglec-9' },
  PC_SPEC_RESEARCH_AREAS_Virology_milliplex: {
    id: 'PC_SPEC_RESEARCH_AREAS_Virology_milliplex',
    defaultMessage: 'Virology',
  },
  PC_SPEC_SPECIES_Ovine_milliplex: {
    id: 'PC_SPEC_SPECIES_Ovine_milliplex',
    defaultMessage: 'Ovine',
  },
  PC_SPEC_ABSORPTION_TYPE_ABSAFF10: {
    id: 'PC_SPEC_ABSORPTION_TYPE_ABSAFF10',
    defaultMessage: 'Absorption Affinity 10 ml',
  },
  PC_SPEC_ABSORPTION_TYPE_ABSAFF20: {
    id: 'PC_SPEC_ABSORPTION_TYPE_ABSAFF20',
    defaultMessage: 'Absorption Affinity 20 ml',
  },
  PC_SPEC_ABSORPTION_TYPE_ABSAFF30: {
    id: 'PC_SPEC_ABSORPTION_TYPE_ABSAFF30',
    defaultMessage: 'Absorption Affinity 30 ml',
  },
  PC_SPEC_ABSORPTION_TYPE_ABSAFF40: {
    id: 'PC_SPEC_ABSORPTION_TYPE_ABSAFF40',
    defaultMessage: 'Absorption Affinity 40 ml',
  },
  PC_SPEC_ABSORPTION_TYPE_ABSAFF50: {
    id: 'PC_SPEC_ABSORPTION_TYPE_ABSAFF50',
    defaultMessage: 'Absorption Affinity 50 ml',
  },
  PLATE_96_SHALLOW_PCR_100: {
    id: 'PLATE_96_SHALLOW_PCR_100',
    defaultMessage: 'Shallow Well PCR (100 μL)',
  },
  PLATE_96_SHALLOW_200: {
    id: 'PLATE_96_SHALLOW_200',
    defaultMessage: 'Shallow Well (200 μL)',
  },
  PLATE_96_DEEP_400: {
    id: 'PLATE_96_DEEP_400',
    defaultMessage: 'Deep  Well (400 μL)',
  },
  Shallow_well_40: {
    id: 'Shallow_well_40',
    defaultMessage: 'Shallow Well (40 μL)',
  },
  FROZEN: { id: 'FROZEN', defaultMessage: 'Frozen' },
  PC_MOD_NTERM_SPECIAL_antisera: {
    id: 'PC_MOD_NTERM_SPECIAL_antisera',
    defaultMessage: '[SPECIAL]',
  },
  CONFIG_CUSTOMER_SERVICE: {
    id: 'CONFIG_CUSTOMER_SERVICE',
    defaultMessage: 'Customer Service',
  },
  CUSTOMER_SERVICE: {
    id: 'CUSTOMER_SERVICE',
    defaultMessage: 'Customer Service',
  },

  CONFIG_NEXT_STEP: {
    id: 'CONFIG_NEXT_STEP',
    defaultMessage: 'Next Step',
  },
  CUSTOM_CRISPR: {
    id: 'CUSTOM_CRISPR',
    defaultMessage: 'Custom CRISPR',
  },
  SEQUENCE_LIST_EMPTY: {
    id: 'SEQUENCE_LIST_EMPTY',
    defaultMessage:
      'Sequence list is empty. Start typing and adding the sequence from above.',
  },
  DELETE_ALL: {
    id: 'DELETE_ALL',
    defaultMessage: 'Delete All',
  },
  CONFIG_DELETE: {
    id: 'CONFIG_DELETE',
    defaultMessage: 'Delete',
  },
  DELETE: {
    id: 'DELETE',
    defaultMessage: 'Delete',
  },
  CONFIG_REQUIRED_FIELDS: {
    id: 'CONFIG_REQUIRED_FIELDS',
    defaultMessage: 'Required Fields',
  },
  REQUIRED_FIELDS: {
    id: 'REQUIRED_FIELDS',
    defaultMessage: 'Required Fields',
  },
  OUR_PERFORMANCE_GUARANTEE: {
    id: 'OUR_PERFORMANCE_GUARANTEE',
    defaultMessage: 'Our Performance Guarantee',
  },
  PERFORMANCE_GUARANTEE: {
    id: 'PERFORMANCE_GUARANTEE',
    defaultMessage: 'Performance Guarantee',
  },
  PERFORMANCE_GUARANTEE_FIRST: {
    id: 'PERFORMANCE_GUARANTEE_FIRST',
    defaultMessage:
      'We are so confident in the performance of our SygRNA® products, that we fully guarantee the quality and performance of any guide we produce, including custom sequences. If your synthetic guides do not yield detectable cleavage at the intended target site, we will provide a one-time replacement, free of charge.',
  },
  PERFORMANCE_GUARANTEE_SECOND: {
    id: 'PERFORMANCE_GUARANTEE_SECOND',
    defaultMessage:
      'To qualify for this guarantee, simply send an image or sequencing data from a single experiment demonstrating detectable cleavage using one of our positive controls, side-by-side with the negative results from your SygRNA® guide. To receive your replacement, simply email',
  },
  PERFORMANCE_GUARANTEE_THIRD: {
    id: 'PERFORMANCE_GUARANTEE_THIRD',
    defaultMessage:
      'and include sample data from a representative experiment (T7E1, TIDE, or NGS).',
  },
  CRISPR_GENE_ID: {
    id: 'CRISPR_GENE_ID',
    defaultMessage: 'Gene ID',
  },
  CRISPR_GENE_SYMBOL: {
    id: 'CRISPR_GENE_SYMBOL',
    defaultMessage: 'Gene Symbol',
  },
  CRISPR_BULK_UPLOAD_STEP2: {
    id: 'CRISPR_BULK_UPLOAD_STEP2',
    defaultMessage: 'Download the ordering template you need:',
  },
  CONF_DROP_CSV_OR_XLS_FILE_OR: {
    id: 'CONF_DROP_CSV_OR_XLS_FILE_OR',
    defaultMessage: 'Drop CSV or XLS files ',
  },
  CONFIG_BROWSE_FILES: {
    id: 'CONFIG_BROWSE_FILES',
    defaultMessage: 'Browse Files',
  },
  BROWSE_FILES: {
    id: 'BROWSE_FILES',
    defaultMessage: 'Browse Files',
  },
  CONFIG_PLEASE_CORRECT_ERRORS: {
    id: 'CONFIG_PLEASE_CORRECT_ERRORS',
    defaultMessage: ' Please correct the error(s) on the list.',
  },
  CONFIG_VISIT_CRISPR_ESSENTIALS_PAGE_MORE_DETAILS: {
    id: 'CONFIG_VISIT_CRISPR_ESSENTIALS_PAGE_MORE_DETAILS',
    defaultMessage:
      'Visit {link} for more details about the formats and specifications offered.',
  },
  CONFIG_REQUIRED: {
    id: 'CONFIG_REQUIRED',
    defaultMessage: 'Required',
  },
  CONF_BASES_HASH: {
    id: 'CONF_BASES_HASH',
    defaultMessage: '# Base',
  },
  CONF_MUST_ACCEPT_ACKNOWLEDGE: {
    id: 'CONF_MUST_ACCEPT_ACKNOWLEDGE',
    defaultMessage: 'Must accept to acknowledge',
  },
  CONF_ITEM_ADDED_TO_SHOPPIN_CART_TITLE_REDESIGN: {
    id: 'CONF_ITEM_ADDED_TO_SHOPPIN_CART_TITLE_REDESIGN',
    defaultMessage: 'added to shopping cart',
  },
  CONF_ITEM_ADDED_TO_SHOPPIN_CART_REDESIGN: {
    id: 'CONF_ITEM_ADDED_TO_SHOPPIN_CART_REDESIGN',
    defaultMessage: 'item(s) has been added to your shopping cart',
  },
  CONF_ITEM_FIND_MORE_CRISPER_ESSENTIALS: {
    id: 'CONF_ITEM_FIND_MORE_CRISPER_ESSENTIALS',
    defaultMessage: 'Find out more CRISPR Essentials',
  },
  CONF_VIEW_CART: {
    id: 'CONF_VIEW_CART',
    defaultMessage: 'View Cart',
  },
  CONF_ADD_MORE_CLONES: {
    id: 'CONF_ADD_MORE_CLONES',
    defaultMessage: 'Add More Clones ',
  },
  CONF_SEE_PRODUCT_DETAILS: {
    id: 'CONF_SEE_PRODUCT_DETAILS',
    defaultMessage: 'See Product Details',
  },
  CONF_RECOMMENDATION_PRODUCTS: {
    id: 'CONF_RECOMMENDATION_PRODUCTS',
    defaultMessage: 'Recommended Products',
  },
  CONF_COMPANY_SIGMA: {
    id: 'CONF_COMPANY_SIGMA',
    defaultMessage: 'Sigma-Aldrich',
  },
  CONF_VIRAL_TITER_customcrispr_REDESIGNED: {
    id: 'CONF_VIRAL_TITER_customcrispr_REDESIGNED',
    defaultMessage: 'Viral Titer',
  },
  LAB_WATER_PURIFICATION: {
    id: 'LAB_WATER_PURIFICATION',
    defaultMessage: 'Lab Water Purification',
  },
  MILLI_Q_WATER_PURIFICATION_SYSTEMS: {
    id: 'MILLI_Q_WATER_PURIFICATION_SYSTEMS',
    defaultMessage: 'Milli-Q{registered} Water Purification Systems',
  },
  CONTACT_LAB_WATER_SPECIALIST: {
    id: 'CONTACT_LAB_WATER_SPECIALIST',
    defaultMessage: 'Contact Lab Water Specialist',
  },
  LAB_WATER_REQUEST: {
    id: 'LAB_WATER_REQUEST',
    defaultMessage: 'For LAB WATER requests, please {link}',
  },
  SEND_TO_DEALER: {
    id: 'SEND_TO_DEALER',
    defaultMessage: 'Send to Dealer',
  },
  SEND_REQUEST_TO_DEALER: {
    id: 'SEND_REQUEST_TO_DEALER',
    defaultMessage: 'Send Request to Dealer',
  },
  QUOTE_REQUEST_TO_DEALER_MODAL_MODAL_TITLE: {
    id: 'QUOTE_REQUEST_TO_DEALER_MODAL_MODAL_TITLE',
    defaultMessage: 'Quote Request to Dealer',
  },
  QUOTE_REQUEST_TO_DEALER_MODAL_TEXT: {
    id: 'QUOTE_REQUEST_TO_DEALER_MODAL_TEXT',
    defaultMessage:
      'Please provide your contact information and submit your request to the dealer.',
  },
  MESSAGE_TO_DEALER: {
    id: 'MESSAGE_TO_DEALER',
    defaultMessage: 'Message To Dealer',
  },
  SUBMIT_REQUEST: {
    id: 'SUBMIT_REQUEST',
    defaultMessage: 'Submit Request',
  },
  QUOTE_PRICE: { id: 'QUOTE_PRICE', defaultMessage: 'Quote Price' },
  REVIEW_AND_ORDER: {
    id: 'REVIEW_AND_ORDER',
    defaultMessage: 'Review & Order',
  },
  _PC_SPEC_REPORTER_QUENCHER_TEXT: {
    id: '_PC_SPEC_REPORTER_QUENCHER_TEXT',
    defaultMessage: "5' Reporter / 3' Quencher Combination",
  },
  _PC_SPEC_REPORTER_QUENCHER_TEXT_DUAL_QUENCH: {
    id: '_PC_SPEC_REPORTER_QUENCHER_TEXT_DUAL_QUENCH',
    defaultMessage: "5' Reporter / Internal Quencher / 3' Quencher Combination",
  },
  _PC_SPEC_REPORTER_QUENCHER_TEXT_INTERNAL_QUENCH: {
    id: '_PC_SPEC_REPORTER_QUENCHER_TEXT_INTERNAL_QUENCH',
    defaultMessage: "5' Reporter / Internal Quencher / Phosphate Combination",
  },
  _PC_SPEC_OMETHYL_BASE: {
    id: '_PC_SPEC_OMETHYL_BASE',
    defaultMessage: "2'-OMe RNA Bases",
  },
  _PC_SPEC_DEOXY_URIDINE: {
    id: '_PC_SPEC_DEOXY_URIDINE',
    defaultMessage: 'Deoxyuridine',
  },
  _PC_SPEC_DNA_BASE: {
    id: '_PC_SPEC_DNA_BASE',
    defaultMessage: 'DNA Bases',
  },
  _PC_SPEC_OFLUORO_BASE: {
    id: '_PC_SPEC_OFLUORO_BASE',
    defaultMessage: "2'-Fluoro Bases",
  },
})

export default messages
